"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBaseCacheProfileSchema = exports.AppBaseDeliveryModeSchema = exports.APP_BASE_APP_TYPE_GUIDE = exports.AppBaseExposureProfileSchema = exports.AppBaseAccessModeSchema = exports.AppBaseProductModeSchema = exports.APP_BASE_WORKSPACE_DATASET_INVALIDATED_EVENT = exports.APP_BASE_WEB_MANIFEST_ROUTE = exports.APP_BASE_SERVICE_WORKER_ROUTE = exports.APP_BASE_INTERNAL_LIVE_COMMAND_ROUTE = exports.APP_BASE_INTERNAL_LIVE_EVENTS_ROUTE = exports.APP_BASE_EXTERNAL_ACTION_ROUTE = exports.APP_BASE_EXTERNAL_EVENTS_ROUTE = exports.APP_BASE_SOURCE_QUERY_ROUTE = exports.APP_BASE_COMPOSITION_COMPILER_VERSION = exports.APP_BASE_COMPILED_ARTIFACT_PROVENANCE_SCHEMA_VERSION = exports.APP_BASE_COMPILED_ROUTE_SEO_SCHEMA_VERSION = exports.APP_SEO_CONTRACT_SCHEMA_VERSION = exports.APP_BASE_INVOCATION_REPLAY_SEMANTICS = exports.AppBaseInvocationRequestIdSchema = exports.APP_BASE_INVOCATION_IDENTITY_CONTRACT_VERSION = exports.APP_BASE_EXPOSURE_PROFILE_SCHEMA_VERSION = exports.APP_BASE_AGENT_ACTION_DEFINITION_SCHEMA_VERSION = exports.APP_DEFINITION_SCHEMA_VERSION = exports.APP_ROUTE_SEGMENT_MAX_LENGTH = exports.APP_CONTAINER_ROUTE_MAX_SEGMENTS = exports.APP_BASE_ATTACHMENT_NEW_ROW_FIELDS_MAX = exports.APP_BASE_ATTACHMENT_REMOVABLE_DEFAULT = exports.appBaseAttachmentRefusal = exports.APP_BASE_INVOCATION_RATE_LIMITED = exports.APP_BASE_ATTACHMENT_TOO_LARGE_MESSAGE = exports.APP_BASE_ATTACHMENT_TOO_LARGE = exports.APP_BASE_ATTACHMENT_REFUSALS = exports.APP_BASE_ATTACHMENT_DOWNLOAD_NOT_DECLARED = exports.APP_BASE_MAX_FILE_BYTES = exports.APP_MOUNT_POINT_SEGMENTS = exports.APP_ROUTE_MAX_SEGMENTS = exports.APP_BASE_APP_MOUNT_SCHEMA_VERSION = exports.APP_BASE_COMPOSITION_SCHEMA_VERSION = exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION = exports.APP_BASE_DOCUMENT_EXPORT_SCHEMA_VERSION = exports.APP_ROUTE_MODULE_SCHEMA_VERSION = exports.APP_BASE_INTERACTION_CONTRACT_SCHEMA_VERSION = exports.APP_BASE_LIFECYCLE_SCHEMA_VERSION = exports.APP_ARTIFACT_SCHEMA_VERSION = exports.APP_BASE_DATABASE_BINDING_SCHEMA_VERSION = exports.APP_MANIFEST_SCHEMA_VERSION = exports.AppTopBarItemSchema = exports.AppBaseNavigationItemSchema = exports.AppBaseCompiledTopBarItemSchema = void 0;
exports.AppSeoHreflangSchema = exports.AppSeoCanonicalSchema = exports.AppSeoMetadataSourceSchema = exports.AppSeoStrategySchema = exports.AppBaseAgentActionDefinitionSchema = exports.AppBaseAgentActionResourceBindingSchema = exports.AppVisibilityContractSchema = exports.AppBaseDocumentExportSchema = exports.AppBaseDocumentExportFormatSchema = exports.AppBaseAttachmentDownloadSchema = exports.AppActionSchema = exports.AppBaseOwnRowChangeActionSchema = exports.AppBaseRowGroupInsertActionSchema = exports.AppBaseAttachmentUpdateActionSchema = exports.AppBaseAutomationRunActionSchema = exports.AppBaseAutomationResultPresentationSchema = exports.AppBaseAutomationInputBindingSchema = exports.AppBaseRowInsertActionSchema = exports.AppActionFieldSchema = exports.AppRouteSchema = exports.STREAMLAIN_BUILDING_BLOCK_FAMILIES = exports.AppBaseBuildingBlockRefSchema = exports.AppBaseBuildingBlockKindSchema = exports.AppBaseInvocationIdentitySchema = exports.AppBaseExposureCapabilityDecisionSchema = exports.AppBaseEffectivePrincipalTypeSchema = exports.AppBaseMembersPageSchema = exports.AppBaseMemberSchema = exports.AppBaseMembersReadInputSchema = exports.APP_BASE_MEMBERS_PAGE_MAX = exports.AppBaseCapabilitySchema = exports.AppBaseCapabilityPermissionSchema = exports.AppBasePlatformCapabilityIdSchema = exports.AppBaseInternalLiveCommandRequestSchema = exports.AppBaseReplicaChunkSchema = exports.AppBaseReplicaIndexSchema = exports.AppBaseInternalLiveDatasetWindowResponseSchema = exports.AppBaseDatasetRowSchema = exports.AppBaseDatasetColumnSchema = exports.AppBaseInternalLiveCellSchema = exports.AppBaseInternalLiveDatasetWindowRequestSchema = exports.AppBaseSourceHistoryRequestSchema = exports.APP_BASE_SOURCE_HISTORY_LIMIT_DEFAULT = exports.APP_BASE_SOURCE_HISTORY_LIMIT_MAX = exports.AppBaseRuntimeModeSchema = exports.AppBaseExposureProfilePolicySchema = exports.AppBaseDeliverySchema = exports.AppBaseLiveDataPolicySchema = exports.AppRouteCachePolicySchema = exports.AppBaseCacheClassSchema = void 0;
exports.AppBaseLifecycleBriefSchema = exports.AppVisibilityCompatibilityIssueSchema = exports.AppArtifactSchema = exports.AppDefinitionOperationBatchSchema = exports.AppDefinitionOperationSchema = exports.AppDefinitionSchema = exports.AppDefinitionTrashSchema = exports.AppNavigationActionSchema = exports.AppBaseAppRouteDefinitionSchema = exports.AppBaseFixedRowSelectionSchema = exports.AppBaseAppCompiledOutputSchema = exports.AppBaseAppDefinitionOutputSchema = exports.AppBaseAppResourceDefinitionSchema = exports.AppBaseAppResourceRetentionSchema = exports.AppBaseAppResourcePlacementSchema = exports.AppRouteModuleSchema = exports.AppArtifactFileSchema = exports.AppBaseCompiledArtifactProvenanceSchema = exports.AppCompositionOperationBatchSchema = exports.AppCompositionOperationSchema = exports.AppCompositionSchema = exports.AppBaseAppMountSchema = exports.AppBaseAppDesignSchema = exports.AppBaseAppBindingRefSchema = exports.AppBaseAppNavigationPlacementSchema = exports.AppBaseAppMountSlotSchema = exports.APP_BASE_FRAME_NAV_ATTRIBUTE = exports.APP_BASE_FRAME_NAV_ACTIVE_ATTRIBUTE = exports.APP_BASE_FRAME_NAV_LEVEL_ATTRIBUTE = exports.APP_BASE_FRAME_OUTLET_ATTRIBUTE = exports.AppBaseCompiledNotFoundPageSchema = exports.AppNotFoundSchema = exports.AppBaseCompiledFrameSchema = exports.AppFrameSchema = exports.AppFrameBrandSchema = exports.AppCompositionShellSchema = exports.AppManifestSchema = exports.AppManifestBaseSchema = exports.AppNavigationLayoutSchema = exports.AppBaseAppDeliverySchema = exports.AppBaseInteractionContractSchema = exports.AppBaseInteractionControlSchema = exports.AppBaseInteractionConfirmationPolicySchema = exports.AppBaseInteractionRequiredRoleSchema = exports.AppBaseInteractionIntentSchema = exports.AppBaseInteractionControlKindSchema = exports.AppBaseCompiledRouteSeoSchema = exports.AppBaseCompiledRouteSeoOwnerSchema = exports.AppSeoContractSchema = exports.AppSeoAiSearchSchema = void 0;
exports.appBaseDataBusyBody = exports.APP_BASE_READ_BUDGETS = exports.APP_BASE_BRIDGE_BUDGETS = exports.APP_BASE_READ_ADMISSION_LIMITS = exports.APP_BASE_BUDGETS = exports.APP_BASE_MUTATION_ROW_PAYLOAD_INVALID_TEXT = exports.APP_BASE_MUTATION_ROW_PAYLOAD_INVALID = exports.APP_BASE_MUTATION_RELATION_TAKEN_TEXT = exports.APP_BASE_MUTATION_RELATION_TAKEN = exports.APP_BASE_MUTATION_LINKED_ROW_NOT_FOUND_TEXT = exports.APP_BASE_MUTATION_LINKED_ROW_NOT_FOUND = exports.APP_BASE_RELATION_LINK_LIMIT_TEXT = exports.APP_BASE_RELATION_LINK_LIMIT_EXCEEDED = exports.APP_BASE_RELATION_LINK_LIMIT = exports.APP_CONTAINER_AGENT_ACTIONS_PER_TABLE = exports.APP_BASE_REPLICA_JSON_EXPANSION_FACTOR = exports.AppBaseDatabaseBindingRegistrySchema = exports.AppBaseDatabaseBindingSchema = exports.AppBaseDatabaseBindingPlacementSchema = exports.AppBaseDatabaseBindingExposureSchema = exports.AppBaseDatabaseBindingDetachPolicySchema = exports.AppBaseDatabaseBindingStatusSchema = exports.AppBaseDatabaseBindingOwnershipSchema = exports.AppBaseLifecycleSchema = exports.AppBaseLifecycleBudgetCountersSchema = exports.AppBaseLifecycleRunStateSchema = void 0;
exports.appBaseAttachmentLimit = appBaseAttachmentLimit;
exports.deriveAppBaseExposureProfile = deriveAppBaseExposureProfile;
exports.resolveAppDelivery = resolveAppDelivery;
exports.appDeliveryRoutePaths = appDeliveryRoutePaths;
exports.resolveAppExposureProfile = resolveAppExposureProfile;
exports.listAppBaseDeliveries = listAppBaseDeliveries;
exports.resolveAppDeliveriesForSource = resolveAppDeliveriesForSource;
exports.appDeliveryHasLiveData = appDeliveryHasLiveData;
exports.resolveAppBaseExposureProfileFromDeliveryMode = resolveAppBaseExposureProfileFromDeliveryMode;
exports.appBaseRuntimeModeForDeliveryMode = appBaseRuntimeModeForDeliveryMode;
exports.appBaseAudienceFactsForProfile = appBaseAudienceFactsForProfile;
exports.decideAppBaseExposureCapability = decideAppBaseExposureCapability;
exports.decideAppBaseAudienceCapability = decideAppBaseAudienceCapability;
exports.decideAppBaseRowGroupInsertExposure = decideAppBaseRowGroupInsertExposure;
exports.canonicalAppBaseInvocationIdentity = canonicalAppBaseInvocationIdentity;
exports.deriveAppBaseInvocationOperationId = deriveAppBaseInvocationOperationId;
exports.appBaseCanonicalPayloadDigest = appBaseCanonicalPayloadDigest;
exports.normalizeAppBaseInvocationRoute = normalizeAppBaseInvocationRoute;
exports.appBaseBuildingBlockFamily = appBaseBuildingBlockFamily;
exports.canonicalAppBaseBuildingBlockRefId = canonicalAppBaseBuildingBlockRefId;
exports.appRoutePathIssue = appRoutePathIssue;
exports.isAppBaseDynamicRoutePath = isAppBaseDynamicRoutePath;
exports.nestAppNavigation = nestAppNavigation;
exports.appBaseOwnRowChangeFieldsIssue = appBaseOwnRowChangeFieldsIssue;
exports.appBaseAttachmentNewRowFieldsIssue = appBaseAttachmentNewRowFieldsIssue;
exports.appBaseAttachmentDownloadIssues = appBaseAttachmentDownloadIssues;
exports.appBaseHasFrame = appBaseHasFrame;
exports.appBaseFrameContentRoutes = appBaseFrameContentRoutes;
exports.appBaseDesignOf = appBaseDesignOf;
exports.appCompositionHasRootApp = appCompositionHasRootApp;
exports.normalizeAppArtifactContentType = normalizeAppArtifactContentType;
exports.appResourceRetentionCutoff = appResourceRetentionCutoff;
exports.appResourceRetentionExpiredRowIds = appResourceRetentionExpiredRowIds;
exports.resolveAppResourcePlacement = resolveAppResourcePlacement;
exports.appSourcePlacement = appSourcePlacement;
exports.appContainerSourcePlacement = appContainerSourcePlacement;
exports.findAppContainerPlacementConflicts = findAppContainerPlacementConflicts;
exports.findAppContainerRetentionConflicts = findAppContainerRetentionConflicts;
exports.appContainerSourceRetention = appContainerSourceRetention;
exports.actionIdFromInteractionControlId = actionIdFromInteractionControlId;
exports.defineApp = defineApp;
exports.compileAppDefinition = compileAppDefinition;
exports.normalizeAppRoutePath = normalizeAppRoutePath;
exports.joinMountedAppPath = joinMountedAppPath;
exports.unmountAppPath = unmountAppPath;
exports.mountOfRoute = mountOfRoute;
exports.findTakenAppMountPoint = findTakenAppMountPoint;
exports.scopedAppId = scopedAppId;
exports.scopedAppIdOfMount = scopedAppIdOfMount;
exports.appPageLeadsCommand = appPageLeadsCommand;
exports.mountedAppSourceKey = mountedAppSourceKey;
exports.mountedAppFrame = mountedAppFrame;
exports.scopedAppFilePath = scopedAppFilePath;
exports.appBaseSha256Hex = appBaseSha256Hex;
exports.compileAppMount = compileAppMount;
exports.withRequiredAppBaseDeliveryRoutePolicies = withRequiredAppBaseDeliveryRoutePolicies;
exports.appShellRouteSeoForExposure = appShellRouteSeoForExposure;
exports.appRouteSeoForExposure = appRouteSeoForExposure;
exports.strongestAppBaseExposureProfile = strongestAppBaseExposureProfile;
exports.openestAppBaseExposureProfile = openestAppBaseExposureProfile;
exports.getAppVisibilityCompatibilityIssues = getAppVisibilityCompatibilityIssues;
exports.appBaseCapabilityForAction = appBaseCapabilityForAction;
exports.compileAppDefinitionNavigationActions = compileAppDefinitionNavigationActions;
exports.compileAppNavigationActions = compileAppNavigationActions;
exports.compileAppComposition = compileAppComposition;
exports.selectAppBaseFrameMount = selectAppBaseFrameMount;
exports.withAppBaseFrameSources = withAppBaseFrameSources;
exports.liveAppDefinitions = liveAppDefinitions;
exports.trashedAppDefinitions = trashedAppDefinitions;
exports.appContainerAgentActionLimit = appContainerAgentActionLimit;
exports.appBaseLinkedRowIds = appBaseLinkedRowIds;
exports.formatAppBaseBytes = formatAppBaseBytes;
exports.appArtifactUsage = appArtifactUsage;
exports.formatAppArtifactUsage = formatAppArtifactUsage;
exports.appPageTablesIssue = appPageTablesIssue;
exports.appArtifactWithinPublishLimits = appArtifactWithinPublishLimits;
exports.appBudgetViolations = appBudgetViolations;
exports.buildAppBaseInteractionContract = buildAppBaseInteractionContract;
exports.isGeneratedAppBaseCapabilityId = isGeneratedAppBaseCapabilityId;
exports.buildAppBaseCapabilityDeclarations = buildAppBaseCapabilityDeclarations;
exports.appRouteControlIssues = appRouteControlIssues;
exports.withAppBaseInteractionContract = withAppBaseInteractionContract;
exports.resolveAppBaseDatabaseBindingSchemaAuthority = resolveAppBaseDatabaseBindingSchemaAuthority;
exports.createAppBaseDatabaseBinding = createAppBaseDatabaseBinding;
exports.createAppBaseDatabaseSemanticKey = createAppBaseDatabaseSemanticKey;
exports.createAppBaseDatabaseSchemaFingerprint = createAppBaseDatabaseSchemaFingerprint;
exports.isAppBaseDatabaseSchemaCompatible = isAppBaseDatabaseSchemaCompatible;
exports.stableJsonStringify = stableJsonStringify;
exports.bumpAppBaseDatabaseBindingRevision = bumpAppBaseDatabaseBindingRevision;
const brand_1 = require("@streamlain/brand");
const database_identity_1 = require("@streamlain/database-identity");
const zod_1 = require("zod");
const app_access_vocabulary_1 = require("./app-access-vocabulary");
const app_base_binding_route_1 = require("./app-base-binding-route");
const app_base_bridge_budgets_1 = require("./app-base-bridge-budgets");
const app_base_locales_1 = require("./app-base-locales");
const app_base_navigation_contract_1 = require("./app-base-navigation-contract");
const app_base_one_per_owner_1 = require("./app-base-one-per-owner");
const app_base_source_query_schema_1 = require("./app-base-source-query-schema");
const app_base_template_markers_1 = require("./app-base-template-markers");
const app_flow_planning_1 = require("./app-flow-planning");
const app_rules_1 = require("./app-rules");
var app_base_navigation_contract_2 = require("./app-base-navigation-contract");
Object.defineProperty(exports, "AppBaseCompiledTopBarItemSchema", { enumerable: true, get: function () { return app_base_navigation_contract_2.AppBaseCompiledTopBarItemSchema; } });
Object.defineProperty(exports, "AppBaseNavigationItemSchema", { enumerable: true, get: function () { return app_base_navigation_contract_2.AppBaseNavigationItemSchema; } });
Object.defineProperty(exports, "AppTopBarItemSchema", { enumerable: true, get: function () { return app_base_navigation_contract_2.AppTopBarItemSchema; } });
exports.APP_MANIFEST_SCHEMA_VERSION = 1;
exports.APP_BASE_DATABASE_BINDING_SCHEMA_VERSION = 1;
exports.APP_ARTIFACT_SCHEMA_VERSION = 1;
exports.APP_BASE_LIFECYCLE_SCHEMA_VERSION = 1;
exports.APP_BASE_INTERACTION_CONTRACT_SCHEMA_VERSION = 1;
exports.APP_ROUTE_MODULE_SCHEMA_VERSION = 1;
exports.APP_BASE_DOCUMENT_EXPORT_SCHEMA_VERSION = 1;
exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION = 1;
exports.APP_BASE_COMPOSITION_SCHEMA_VERSION = 1;
exports.APP_BASE_APP_MOUNT_SCHEMA_VERSION = 1;
/** Deepest route of an App, in path segments below its start page `/`. */
exports.APP_ROUTE_MAX_SEGMENTS = 5;
/** A mount point is `/` (the main App) or has exactly this many segments. */
exports.APP_MOUNT_POINT_SEGMENTS = 1;
/** Largest file the platform takes in one upload: uploads, copies and the StreamKit alike. */
exports.APP_BASE_MAX_FILE_BYTES = 4 * 1024 ** 3;
/**
 * The largest file one upload of an App takes: the `maxBytes` of its action
 * within the file limit of the plan of the workspace (the StreamKit takes
 * APP_BASE_MAX_FILE_BYTES as its plan).
 */
function appBaseAttachmentLimit(maxBytes, planBlobLimit) {
    return Math.min(maxBytes, planBlobLimit, exports.APP_BASE_MAX_FILE_BYTES);
}
var app_base_refusals_1 = require("./app-base-refusals");
Object.defineProperty(exports, "APP_BASE_ATTACHMENT_DOWNLOAD_NOT_DECLARED", { enumerable: true, get: function () { return app_base_refusals_1.APP_BASE_ATTACHMENT_DOWNLOAD_NOT_DECLARED; } });
Object.defineProperty(exports, "APP_BASE_ATTACHMENT_REFUSALS", { enumerable: true, get: function () { return app_base_refusals_1.APP_BASE_ATTACHMENT_REFUSALS; } });
Object.defineProperty(exports, "APP_BASE_ATTACHMENT_TOO_LARGE", { enumerable: true, get: function () { return app_base_refusals_1.APP_BASE_ATTACHMENT_TOO_LARGE; } });
Object.defineProperty(exports, "APP_BASE_ATTACHMENT_TOO_LARGE_MESSAGE", { enumerable: true, get: function () { return app_base_refusals_1.APP_BASE_ATTACHMENT_TOO_LARGE_MESSAGE; } });
Object.defineProperty(exports, "APP_BASE_INVOCATION_RATE_LIMITED", { enumerable: true, get: function () { return app_base_refusals_1.APP_BASE_INVOCATION_RATE_LIMITED; } });
Object.defineProperty(exports, "appBaseAttachmentRefusal", { enumerable: true, get: function () { return app_base_refusals_1.appBaseAttachmentRefusal; } });
/** Whether a file action lets its page remove one file of the cell. */
exports.APP_BASE_ATTACHMENT_REMOVABLE_DEFAULT = false;
/** Most further cells a newRow file action fills from the page payload. */
exports.APP_BASE_ATTACHMENT_NEW_ROW_FIELDS_MAX = 8;
/** Deepest page of an App Container: the mount point plus the App route. */
exports.APP_CONTAINER_ROUTE_MAX_SEGMENTS = exports.APP_MOUNT_POINT_SEGMENTS + exports.APP_ROUTE_MAX_SEGMENTS;
exports.APP_ROUTE_SEGMENT_MAX_LENGTH = 64;
exports.APP_DEFINITION_SCHEMA_VERSION = 1;
exports.APP_BASE_AGENT_ACTION_DEFINITION_SCHEMA_VERSION = 1;
exports.APP_BASE_EXPOSURE_PROFILE_SCHEMA_VERSION = 1;
exports.APP_BASE_INVOCATION_IDENTITY_CONTRACT_VERSION = 1;
exports.AppBaseInvocationRequestIdSchema = zod_1.z.string().uuid().max(64);
exports.APP_BASE_INVOCATION_REPLAY_SEMANTICS = Object.freeze({
    invalidRequestStatus: 400,
    duplicateSameIdentity: 'replay',
    requestFingerprintConflictStatus: 409,
});
exports.APP_SEO_CONTRACT_SCHEMA_VERSION = 1;
exports.APP_BASE_COMPILED_ROUTE_SEO_SCHEMA_VERSION = 1;
exports.APP_BASE_COMPILED_ARTIFACT_PROVENANCE_SCHEMA_VERSION = 1;
exports.APP_BASE_COMPOSITION_COMPILER_VERSION = 'streamlain-app-base-composition-compiler/v1';
exports.APP_BASE_SOURCE_QUERY_ROUTE = '/_data';
exports.APP_BASE_EXTERNAL_EVENTS_ROUTE = '/_app-events';
exports.APP_BASE_EXTERNAL_ACTION_ROUTE = '/_app-action';
exports.APP_BASE_INTERNAL_LIVE_EVENTS_ROUTE = '/_app-live/events';
exports.APP_BASE_INTERNAL_LIVE_COMMAND_ROUTE = '/_app-live/command';
/** The platform's service worker and web manifest of an App address. */
exports.APP_BASE_SERVICE_WORKER_ROUTE = '/_app-sw.js';
exports.APP_BASE_WEB_MANIFEST_ROUTE = '/_app-manifest.webmanifest';
exports.APP_BASE_WORKSPACE_DATASET_INVALIDATED_EVENT = 'streamlain:app-base-workspace-dataset-invalidated';
/**
 * Apps have one runtime product model. Marketplace Apps assembled from
 * internal PagePresets are not a second App runtime.
 */
exports.AppBaseProductModeSchema = zod_1.z.literal('app-base');
exports.AppBaseAccessModeSchema = zod_1.z.enum(['public', 'members', 'portal']);
exports.AppBaseExposureProfileSchema = zod_1.z.enum([
    'publicStatic',
    'publicInteractive',
    'memberPortal',
    'internalLive',
]);
/** How an agent chooses the App type: the one text every tool shows. */
exports.APP_BASE_APP_TYPE_GUIDE = 'For a new App first choose for whom it is in overrides.audience (internal = members, portal = portal persons, public = visitors); Who may use a page is set per page and audience (members, portal persons, visitors) in access: an audience is off or reads its own rows, the rows of its groups or all rows, and may create, change or delete rows. Leave access out to keep the current rights.';
exports.AppBaseDeliveryModeSchema = zod_1.z.enum([
    'public_static',
    'public_interactive',
    'member_portal',
    'internal_live',
]);
exports.AppBaseCacheProfileSchema = zod_1.z.enum([
    'public_static',
    'public_interactive',
    'member_portal',
    'internal_live',
]);
exports.AppBaseCacheClassSchema = zod_1.z.enum([
    'htmlShell',
    'staticAsset',
    'customData',
    'customEvents',
    'customAction',
    'internalLiveData',
    'internalLiveEvents',
    'internalLiveCommand',
    'automationStatus',
    'portal',
]);
exports.AppRouteCachePolicySchema = zod_1.z
    .object({
    path: zod_1.z.string().min(1),
    cacheClass: exports.AppBaseCacheClassSchema.default('htmlShell'),
})
    .strict();
exports.AppBaseLiveDataPolicySchema = zod_1.z
    .object({
    enabled: zod_1.z.boolean().default(false),
    transport: zod_1.z.literal('sse').default('sse'),
    scope: zod_1.z
        .union([
        zod_1.z.enum(['none', 'dataset-invalidations', 'automation-status']),
        zod_1.z
            .array(zod_1.z.enum(['dataset-invalidations', 'automation-status']))
            .min(1)
            .max(2),
    ])
        .default('none'),
    statusExposure: zod_1.z.literal('summary').default('summary'),
})
    .strict();
exports.AppBaseDeliverySchema = zod_1.z
    .object({
    mode: exports.AppBaseDeliveryModeSchema.default('public_static'),
    cacheProfile: exports.AppBaseCacheProfileSchema.default('public_static'),
    routePolicies: zod_1.z.array(exports.AppRouteCachePolicySchema).default([]),
    liveData: exports.AppBaseLiveDataPolicySchema.prefault({}),
})
    .strict();
exports.AppBaseExposureProfilePolicySchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_EXPOSURE_PROFILE_SCHEMA_VERSION),
    profile: exports.AppBaseExposureProfileSchema,
    access: exports.AppBaseAccessModeSchema,
    delivery: exports.AppBaseDeliverySchema,
    robotsIndex: zod_1.z.boolean(),
    requiresAuthenticatedViewer: zod_1.z.boolean(),
    allowsLiveData: zod_1.z.boolean(),
    allowsCommands: zod_1.z.boolean(),
    allowsWrites: zod_1.z.boolean(),
})
    .strict();
function deriveAppBaseExposureProfile(profile) {
    switch (profile) {
        case 'publicStatic':
            return exports.AppBaseExposureProfilePolicySchema.parse({
                schemaVersion: exports.APP_BASE_EXPOSURE_PROFILE_SCHEMA_VERSION,
                profile,
                access: 'public',
                delivery: {
                    mode: 'public_static',
                    cacheProfile: 'public_static',
                    routePolicies: [],
                    liveData: {
                        enabled: false,
                        transport: 'sse',
                        scope: 'none',
                        statusExposure: 'summary',
                    },
                },
                robotsIndex: true,
                requiresAuthenticatedViewer: false,
                allowsLiveData: false,
                allowsCommands: false,
                allowsWrites: false,
            });
        case 'publicInteractive':
            return exports.AppBaseExposureProfilePolicySchema.parse({
                schemaVersion: exports.APP_BASE_EXPOSURE_PROFILE_SCHEMA_VERSION,
                profile,
                access: 'public',
                delivery: {
                    mode: 'public_interactive',
                    cacheProfile: 'public_interactive',
                    routePolicies: [
                        { path: exports.APP_BASE_SOURCE_QUERY_ROUTE, cacheClass: 'customData' },
                        {
                            path: exports.APP_BASE_EXTERNAL_EVENTS_ROUTE,
                            cacheClass: 'customEvents',
                        },
                        {
                            path: exports.APP_BASE_EXTERNAL_ACTION_ROUTE,
                            cacheClass: 'customAction',
                        },
                    ],
                    liveData: {
                        enabled: true,
                        transport: 'sse',
                        scope: ['dataset-invalidations', 'automation-status'],
                        statusExposure: 'summary',
                    },
                },
                robotsIndex: true,
                requiresAuthenticatedViewer: false,
                allowsLiveData: true,
                allowsCommands: true,
                allowsWrites: true,
            });
        case 'memberPortal':
            return exports.AppBaseExposureProfilePolicySchema.parse({
                schemaVersion: exports.APP_BASE_EXPOSURE_PROFILE_SCHEMA_VERSION,
                profile,
                access: 'portal',
                delivery: {
                    mode: 'member_portal',
                    cacheProfile: 'member_portal',
                    routePolicies: [
                        { path: exports.APP_BASE_SOURCE_QUERY_ROUTE, cacheClass: 'customData' },
                        {
                            path: exports.APP_BASE_EXTERNAL_EVENTS_ROUTE,
                            cacheClass: 'customEvents',
                        },
                        {
                            path: exports.APP_BASE_EXTERNAL_ACTION_ROUTE,
                            cacheClass: 'customAction',
                        },
                    ],
                    liveData: {
                        enabled: true,
                        transport: 'sse',
                        scope: ['dataset-invalidations', 'automation-status'],
                        statusExposure: 'summary',
                    },
                },
                robotsIndex: false,
                requiresAuthenticatedViewer: true,
                allowsLiveData: true,
                allowsCommands: true,
                allowsWrites: true,
            });
        case 'internalLive':
            return exports.AppBaseExposureProfilePolicySchema.parse({
                schemaVersion: exports.APP_BASE_EXPOSURE_PROFILE_SCHEMA_VERSION,
                profile,
                access: 'members',
                delivery: {
                    mode: 'internal_live',
                    cacheProfile: 'internal_live',
                    routePolicies: [
                        {
                            path: exports.APP_BASE_SOURCE_QUERY_ROUTE,
                            cacheClass: 'internalLiveData',
                        },
                        {
                            path: exports.APP_BASE_INTERNAL_LIVE_EVENTS_ROUTE,
                            cacheClass: 'internalLiveEvents',
                        },
                        {
                            path: exports.APP_BASE_INTERNAL_LIVE_COMMAND_ROUTE,
                            cacheClass: 'internalLiveCommand',
                        },
                    ],
                    liveData: {
                        enabled: true,
                        transport: 'sse',
                        scope: ['dataset-invalidations', 'automation-status'],
                        statusExposure: 'summary',
                    },
                },
                robotsIndex: false,
                requiresAuthenticatedViewer: true,
                allowsLiveData: true,
                allowsCommands: true,
                allowsWrites: true,
            });
    }
}
function resolvedAppDelivery(manifest, app) {
    // Without a manifest nothing is published: the static default denies all.
    const delivery = app?.delivery ?? manifest?.delivery ?? exports.AppBaseDeliverySchema.parse({});
    return {
        mountId: app?.mountId ?? null,
        appId: app?.appId ?? null,
        delivery,
        exposureProfile: resolveAppBaseExposureProfileFromDeliveryMode(delivery.mode),
    };
}
/**
 * The delivery of the App behind a declared route (`route.path` of the
 * manifest, not a requested address) or an action. A route or action no
 * mounted App owns gets the delivery of the manifest itself: the shell of a
 * container, which is the strictest profile of its kind.
 */
function resolveAppDelivery(manifest, target) {
    return resolvedAppDelivery(manifest, findAppDelivery(manifest?.appDeliveries, target));
}
function findAppDelivery(apps, target) {
    return apps?.find(app => 'actionId' in target
        ? app.actionIds.includes(target.actionId)
        : app.routePaths.includes(target.routePath));
}
/** The pages a mounted App owns in its container, in the order it mounts them. */
function appDeliveryRoutePaths(apps, appId) {
    return (apps ?? [])
        .filter(app => app.appId === appId)
        .flatMap(app => app.routePaths);
}
/**
 * The exposure profile of the App behind a declared route or an action, for
 * readers that hold only the access part of a manifest. Same owner rule as
 * `resolveAppDelivery`.
 */
function resolveAppExposureProfile(manifest, target) {
    const app = findAppDelivery(manifest.appDeliveries, target);
    return resolveAppBaseExposureProfileFromDeliveryMode((app ?? manifest).delivery.mode);
}
/** Every delivery a manifest runs with: one per mounted App, or its own. */
function listAppBaseDeliveries(manifest) {
    return manifest.appDeliveries?.length
        ? manifest.appDeliveries.map(app => app.delivery)
        : [manifest.delivery];
}
/** Every delivery a source is served with; several Apps may share a source. */
function resolveAppDeliveriesForSource(manifest, sourceKey) {
    const apps = (manifest?.appDeliveries ?? []).filter(app => app.dataSourceKeys.includes(sourceKey));
    return apps.length > 0
        ? apps.map(app => resolvedAppDelivery(manifest, app))
        : [resolvedAppDelivery(manifest)];
}
/**
 * Whether Apps of this delivery receive change signals at all. Internal Apps
 * always do; every other delivery states it in `liveData.enabled`.
 */
function appDeliveryHasLiveData(delivery) {
    return delivery.liveData.enabled || delivery.mode === 'internal_live';
}
function resolveAppBaseExposureProfileFromDeliveryMode(deliveryMode) {
    if (deliveryMode === 'internal_live')
        return 'internalLive';
    if (deliveryMode === 'member_portal')
        return 'memberPortal';
    if (deliveryMode === 'public_interactive')
        return 'publicInteractive';
    return 'publicStatic';
}
exports.AppBaseRuntimeModeSchema = zod_1.z.enum([
    'external_snapshot',
    'member_portal_snapshot',
    'internal_live',
]);
/** The runtime mode a page of an App with this delivery runs in. */
function appBaseRuntimeModeForDeliveryMode(deliveryMode) {
    if (deliveryMode === 'internal_live')
        return 'internal_live';
    if (deliveryMode === 'member_portal')
        return 'member_portal_snapshot';
    return 'external_snapshot';
}
/** The most persist runs one page of the history of a source reads. */
exports.APP_BASE_SOURCE_HISTORY_LIMIT_MAX = 100;
/** The runs a page of the history reads without `limit`. */
exports.APP_BASE_SOURCE_HISTORY_LIMIT_DEFAULT = 50;
/**
 * A page of the history of a source (Bridge `readHistory`, `_data` with
 * `view=history`): `limit` persist runs before `cursor`, newest first.
 */
exports.AppBaseSourceHistoryRequestSchema = zod_1.z
    .object({
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce
        .number()
        .int()
        .min(1)
        .max(exports.APP_BASE_SOURCE_HISTORY_LIMIT_MAX)
        .default(exports.APP_BASE_SOURCE_HISTORY_LIMIT_DEFAULT),
})
    .strict();
exports.AppBaseInternalLiveDatasetWindowRequestSchema = zod_1.z
    .object({
    manifestId: zod_1.z.string().min(1),
    routePath: zod_1.z.string().min(1),
    sourceKey: zod_1.z.string().min(1),
    columnIds: zod_1.z.array(zod_1.z.string().min(1).max(256)).max(64).optional(),
    cursor: zod_1.z.string().min(1).optional(),
    limit: zod_1.z.number().int().positive().max(5000),
    sort: zod_1.z
        .array(zod_1.z
        .object({
        columnId: zod_1.z.string().min(1),
        direction: zod_1.z.enum(['asc', 'desc']),
    })
        .strict())
        .max(8)
        .optional(),
    filter: zod_1.z.unknown().optional(),
    /** Shared database search semantics over the exposed columns. */
    search: zod_1.z.string().max(500).optional(),
    searchColumnIds: zod_1.z.array(zod_1.z.string().min(1)).max(64).optional(),
    /** Platform projection predicates (`@streamlain/database-identity`). */
    predicates: zod_1.z.array(zod_1.z.unknown()).max(32).optional(),
})
    .strict();
exports.AppBaseInternalLiveCellSchema = zod_1.z
    .object({
    value: zod_1.z.unknown().optional(),
})
    .strict();
exports.AppBaseDatasetColumnSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    name: zod_1.z.string().min(1),
    type: zod_1.z.string().min(1),
    /** select/multi-select only: cells hold option ids. */
    options: zod_1.z
        .array(zod_1.z.object({ id: zod_1.z.string().min(1), value: zod_1.z.string() }).strict())
        .optional(),
    /** Safe group semantics for computed columns. Never exposes relation placement. */
    grouping: zod_1.z
        .object({
        type: zod_1.z.enum(['relation', 'select', 'multi-select']),
        options: zod_1.z
            .array(zod_1.z.object({ id: zod_1.z.string().min(1), value: zod_1.z.string() }).strict())
            .optional(),
    })
        .strict()
        .optional(),
})
    .strict();
exports.AppBaseDatasetRowSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    cells: zod_1.z.record(zod_1.z.string().min(1), exports.AppBaseInternalLiveCellSchema),
    updatedAt: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.AppBaseInternalLiveDatasetWindowResponseSchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    columns: zod_1.z.array(exports.AppBaseDatasetColumnSchema),
    rows: zod_1.z.array(exports.AppBaseDatasetRowSchema),
    nextCursor: zod_1.z.string().min(1).nullable().optional(),
    revision: zod_1.z.string().min(1).optional(),
})
    .strict();
/** Revision-bound storage chunks of one source. Server queries return only a
 * bounded window; this storage manifest never selects a different executor. */
exports.AppBaseReplicaIndexSchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    schemaVersion: zod_1.z.literal(1),
    schemaKey: zod_1.z.string().min(1),
    totalRows: zod_1.z.number().int().nonnegative(),
    columns: zod_1.z.array(exports.AppBaseDatasetColumnSchema),
    shards: zod_1.z.array(zod_1.z
        .object({
        shardId: zod_1.z.string().min(1),
        revision: zod_1.z.string().min(1),
        rowCount: zod_1.z.number().int().nonnegative(),
    })
        .strict()),
})
    .strict();
exports.AppBaseReplicaChunkSchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    shardId: zod_1.z.string().min(1),
    revision: zod_1.z.string().min(1),
    schemaKey: zod_1.z.string().min(1),
    rows: zod_1.z.array(exports.AppBaseDatasetRowSchema),
})
    .strict();
exports.AppBaseInternalLiveCommandRequestSchema = zod_1.z
    .object({
    requestId: exports.AppBaseInvocationRequestIdSchema,
    manifestId: zod_1.z.string().min(1),
    routePath: zod_1.z.string().min(1),
    commandId: zod_1.z.string().min(1),
    capabilityId: zod_1.z.string().min(1).optional(),
    input: zod_1.z.unknown().optional(),
})
    .strict();
exports.AppBasePlatformCapabilityIdSchema = zod_1.z.enum([
    'dataset.readWindow',
    'dataset.subscribe',
    'database.row.insert',
    'database.row.update',
    'database.row.delete',
    'agentAction.invoke',
    'automation.run',
    'attachment.update',
    'document.export',
    'members.read',
    'dataset.restore',
]);
exports.AppBaseCapabilityPermissionSchema = zod_1.z.enum([
    'read',
    'write',
    'execute',
    'manage',
]);
exports.AppBaseCapabilitySchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    capabilityId: exports.AppBasePlatformCapabilityIdSchema,
    label: zod_1.z.string().min(1),
    permission: exports.AppBaseCapabilityPermissionSchema.default('read'),
    routePaths: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    actionIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    secretBindingKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
})
    .strict();
/** A page of the people with access to the App Container holds at most this
 * many. */
exports.APP_BASE_MEMBERS_PAGE_MAX = 100;
/** What `members.read` asks: a page of the people with access, optionally
 * only those whose name contains `search`. */
exports.AppBaseMembersReadInputSchema = zod_1.z
    .object({
    search: zod_1.z.string().trim().max(120).optional(),
    cursor: zod_1.z.string().min(1).max(200).optional(),
    limit: zod_1.z
        .number()
        .int()
        .min(1)
        .max(exports.APP_BASE_MEMBERS_PAGE_MAX)
        .default(exports.APP_BASE_MEMBERS_PAGE_MAX),
})
    .strict();
/** One person with access to the App Container: no mail, no role. */
exports.AppBaseMemberSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    name: zod_1.z.string(),
    avatarUrl: zod_1.z.string().nullable(),
})
    .strict();
exports.AppBaseMembersPageSchema = zod_1.z
    .object({
    members: zod_1.z.array(exports.AppBaseMemberSchema).max(exports.APP_BASE_MEMBERS_PAGE_MAX),
    nextCursor: zod_1.z.string().nullable(),
})
    .strict();
exports.AppBaseEffectivePrincipalTypeSchema = zod_1.z.enum([
    'anonymous',
    'portal',
    'workspaceMember',
    'guest',
]);
exports.AppBaseExposureCapabilityDecisionSchema = zod_1.z
    .object({
    allowed: zod_1.z.boolean(),
    effectivePrincipal: exports.AppBaseEffectivePrincipalTypeSchema,
    reason: zod_1.z.enum([
        'allowed',
        'profile_denied',
        'principal_denied',
        'capability_denied',
    ]),
})
    .strict();
/**
 * The facts an exposure profile carries: an internal App runs live for
 * members, a public App without portal serves visitors only. Whether
 * visitors add rows (a public form) the page rights decide per page.
 */
function appBaseAudienceFactsForProfile(profile) {
    return {
        workspaceLive: profile === 'internalLive',
        signsIn: profile === 'memberPortal' || profile === 'internalLive',
    };
}
/** What a principal may use in an App of this exposure profile. */
function decideAppBaseExposureCapability(input) {
    const { exposureProfile, ...rest } = input;
    return decideAppBaseAudienceCapability({
        ...rest,
        facts: appBaseAudienceFactsForProfile(exposureProfile),
    });
}
/**
 * Who may use a capability follows from the principal: a visitor acts for
 * the public, a portal person for the portal, a member for the workspace. A
 * guest, and a member in an App that signs nobody in, act as visitors.
 */
function decideAppBaseAudienceCapability(input) {
    const { capability, facts } = input;
    const effectivePrincipal = input.principal === 'guest' ||
        (input.principal === 'workspaceMember' && !facts.signsIn)
        ? 'anonymous'
        : input.principal;
    const decision = (reason) => exports.AppBaseExposureCapabilityDecisionSchema.parse({
        allowed: reason === 'allowed',
        effectivePrincipal,
        reason,
    });
    const withoutLiveCalls = capability === 'dataset.subscribe' || capability === 'agentAction.invoke'
        ? decision('capability_denied')
        : decision('allowed');
    // External audiences grant data access only; asking the managers of a
    // table to restore it is for a member of the workspace.
    if ((capability === 'automation.run' || capability === 'dataset.restore') &&
        effectivePrincipal !== 'workspaceMember')
        return decision('capability_denied');
    // Who has access to the container is for its own members only.
    if (capability === 'members.read' &&
        (!facts.workspaceLive || effectivePrincipal !== 'workspaceMember'))
        return decision('capability_denied');
    // An internal container serves its own members only.
    if (facts.workspaceLive && effectivePrincipal !== 'workspaceMember')
        return decision('principal_denied');
    if (effectivePrincipal === 'anonymous') {
        if (capability === 'dataset.readWindow' ||
            capability === 'document.export' ||
            capability === 'database.row.insert')
            return decision('allowed');
        return decision('capability_denied');
    }
    if (effectivePrincipal === 'portal') {
        // In an App that signs nobody in, a portal person only adds a row on a
        // public page as itself.
        if (!facts.signsIn)
            return capability === 'database.row.insert'
                ? decision('allowed')
                : decision('principal_denied');
        return withoutLiveCalls;
    }
    return facts.workspaceLive ? decision('allowed') : withoutLiveCalls;
}
/**
 * A rowGroupInsert action is a row insert into every table of its Agent
 * Action; the page rights decide each table, the profile the insert.
 */
function decideAppBaseRowGroupInsertExposure(input) {
    return decideAppBaseExposureCapability({
        exposureProfile: input.exposureProfile,
        principal: input.principal,
        capability: 'database.row.insert',
    });
}
exports.AppBaseInvocationIdentitySchema = zod_1.z
    .object({
    contractVersion: zod_1.z.literal(exports.APP_BASE_INVOCATION_IDENTITY_CONTRACT_VERSION),
    requestId: exports.AppBaseInvocationRequestIdSchema,
    workspaceId: zod_1.z.string().min(1),
    appBaseId: zod_1.z.string().min(1),
    manifestId: zod_1.z.string().min(1),
    routePath: zod_1.z.string().min(1),
    actionId: zod_1.z.string().min(1),
    actionRevision: zod_1.z.number().int().nonnegative(),
    candidateDigest: zod_1.z.string().regex(/^[0-9a-f]{64}$/),
    exposurePolicyVersion: zod_1.z.literal(exports.APP_BASE_EXPOSURE_PROFILE_SCHEMA_VERSION),
    activationEpoch: zod_1.z.string().regex(/^\d+$/).optional(),
    principalType: exports.AppBaseEffectivePrincipalTypeSchema,
    principalId: zod_1.z.string().min(1),
    payloadDigest: zod_1.z.string().regex(/^[0-9a-f]{64}$/),
    operationKind: zod_1.z.enum([
        'rowInsert',
        'attachmentUpdate',
        'automationRun',
        'rowGroupInsert',
        'ownRowChange',
    ]),
    bindingId: zod_1.z.string().min(1).optional(),
    bindingEpoch: zod_1.z.string().regex(/^\d+$/).optional(),
    targetDocId: zod_1.z.string().min(1).optional(),
    databaseBlockId: zod_1.z.string().min(1).optional(),
    rowId: zod_1.z.string().min(1).optional(),
    columnId: zod_1.z.string().min(1).optional(),
    permissionEpoch: zod_1.z.string().regex(/^\d+$/).optional(),
})
    .strict()
    .superRefine((identity, ctx) => {
    if (identity.principalType === 'anonymous' &&
        identity.principalId !== 'anonymous') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Anonymous invocations require the canonical anonymous ID',
            path: ['principalId'],
        });
    }
    if (identity.operationKind === 'automationRun' &&
        !identity.activationEpoch) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Automation invocations require activationEpoch',
            path: ['activationEpoch'],
        });
    }
    // A group writes into several tables: its bindingId and epochs stand for
    // all of them, and it names no single table, row or column.
    const group = identity.operationKind === 'rowGroupInsert';
    const oneTable = ['targetDocId', 'databaseBlockId'];
    if (identity.operationKind !== 'automationRun') {
        for (const field of [
            'bindingId',
            'bindingEpoch',
            'permissionEpoch',
            ...(group ? [] : oneTable),
        ]) {
            if (identity[field])
                continue;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Mutation invocations require ${field}`,
                path: [field],
            });
        }
    }
    if (group) {
        for (const field of [...oneTable, 'rowId', 'columnId']) {
            if (identity[field] === undefined)
                continue;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Row group invocations name no single ${field}`,
                path: [field],
            });
        }
    }
    if (identity.operationKind === 'attachmentUpdate' &&
        (!identity.rowId || !identity.columnId)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Attachment invocations require rowId and columnId',
            path: [identity.rowId ? 'columnId' : 'rowId'],
        });
    }
    if (identity.operationKind === 'ownRowChange' && !identity.rowId) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Own row invocations require rowId',
            path: ['rowId'],
        });
    }
})
    .transform(identity => ({
    ...identity,
    routePath: normalizeAppBaseInvocationRoute(identity.routePath),
}));
function canonicalAppBaseInvocationIdentity(input) {
    return canonicalAppBaseJson(exports.AppBaseInvocationIdentitySchema.parse(input));
}
function deriveAppBaseInvocationOperationId(input) {
    const canonical = canonicalAppBaseInvocationIdentity(input);
    const fingerprint = appBaseSha256Hex(canonical);
    return {
        fingerprint,
        operationId: appBaseSha256Hex(`${exports.APP_BASE_INVOCATION_IDENTITY_CONTRACT_VERSION}:${fingerprint}`),
    };
}
function appBaseCanonicalPayloadDigest(value) {
    return appBaseSha256Hex(canonicalAppBaseJson(value));
}
function normalizeAppBaseInvocationRoute(path) {
    const normalized = `/${path.trim().replace(/^\/+|\/+$/g, '')}`;
    if (!isSafeAppRoutePath(normalized)) {
        throw new Error('Invalid App invocation route');
    }
    return normalized === '/' ? '/' : normalized;
}
function canonicalAppBaseJson(value) {
    if (value === null || typeof value !== 'object')
        return JSON.stringify(value);
    if (Array.isArray(value)) {
        return `[${value.map(canonicalAppBaseJson).join(',')}]`;
    }
    return `{${Object.entries(value)
        .filter(([, entry]) => entry !== undefined)
        .sort(([left], [right]) => left.localeCompare(right))
        .map(([key, entry]) => `${JSON.stringify(key)}:${canonicalAppBaseJson(entry)}`)
        .join(',')}}`;
}
exports.AppBaseBuildingBlockKindSchema = zod_1.z.enum([
    'dataSource',
    'action',
    'capability',
    'documentExport',
    'routeModule',
    'asset',
]);
exports.AppBaseBuildingBlockRefSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION),
    id: zod_1.z.string().min(1),
    kind: exports.AppBaseBuildingBlockKindSchema,
    label: zod_1.z.string().min(1).optional(),
    family: zod_1.z.string().min(1).optional(),
    sourceKey: zod_1.z.string().min(1).optional(),
    actionId: zod_1.z.string().min(1).optional(),
    capabilityId: exports.AppBasePlatformCapabilityIdSchema.optional(),
    exportId: zod_1.z.string().min(1).optional(),
    routePath: zod_1.z.string().min(1).optional(),
    metadata: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.unknown()).optional(),
})
    .strict();
exports.STREAMLAIN_BUILDING_BLOCK_FAMILIES = [
    'streamlain.datasource',
    'streamlain.action',
    'streamlain.capability',
    'streamlain.documentExport',
];
/** The family of a building block ref: the declared one, else the one its id starts with. */
function appBaseBuildingBlockFamily(ref) {
    const declared = exports.STREAMLAIN_BUILDING_BLOCK_FAMILIES.find(family => family === ref.family);
    if (declared)
        return declared;
    return (exports.STREAMLAIN_BUILDING_BLOCK_FAMILIES.find(family => ref.id === family || ref.id.startsWith(`${family}.`)) ?? null);
}
/**
 * The id a building block must carry: its family, its qualifiers and the id of
 * what it points at. A ref whose target is renamed (an App mounted into a
 * container) therefore names the new target. Null when the ref is outside the
 * building block families or lacks a field its id is made of.
 */
function canonicalAppBaseBuildingBlockRefId(ref) {
    const family = appBaseBuildingBlockFamily(ref);
    if (family === 'streamlain.datasource') {
        const role = ref.metadata?.['role'];
        const contentModel = ref.metadata?.['contentModel'];
        return ref.sourceKey &&
            typeof role === 'string' &&
            typeof contentModel === 'string'
            ? `streamlain.datasource.${role}.${contentModel}.${ref.sourceKey}`
            : null;
    }
    if (family === 'streamlain.action') {
        const intent = ref.metadata?.['intent'];
        return ref.actionId && typeof intent === 'string'
            ? `streamlain.action.${intent}.${ref.actionId}`
            : null;
    }
    if (family === 'streamlain.capability') {
        if (!ref.capabilityId)
            return null;
        const scope = ref.actionId ?? ref.sourceKey ?? ref.exportId;
        return scope
            ? `streamlain.capability.${ref.capabilityId}.${scope}`
            : `streamlain.capability.${ref.capabilityId}`;
    }
    if (family === 'streamlain.documentExport') {
        const formats = ref.metadata?.['formats'];
        return ref.exportId &&
            Array.isArray(formats) &&
            formats.length > 0 &&
            formats.every(format => typeof format === 'string' && format.length > 0)
            ? `streamlain.documentExport.${formats.join('+')}.${ref.exportId}`
            : null;
    }
    return null;
}
function isSafeAppRoutePath(path) {
    if (!path.startsWith('/'))
        return false;
    if (path.includes('://') || path.startsWith('//'))
        return false;
    return !path
        .replace(/\\/g, '/')
        .split('/')
        .filter(Boolean)
        .some(part => part === '.' || part === '..');
}
/**
 * The one path rule of Apps. Contract, installation, publishing and the Dev
 * Kit all report this text; returns null when the path is allowed.
 */
function appRoutePathIssue(path, scope) {
    if (!isSafeAppRoutePath(path)) {
        return scope === 'mount'
            ? 'App mount points must be absolute workspace paths without traversal or URL syntax'
            : 'App routes must be absolute workspace paths without traversal or URL syntax';
    }
    const segments = path.split('/').filter(Boolean);
    const longSegment = segments.find(segment => segment.length > exports.APP_ROUTE_SEGMENT_MAX_LENGTH);
    if (longSegment) {
        return `Path ${path} has a segment with ${longSegment.length} characters; a segment has at most ${exports.APP_ROUTE_SEGMENT_MAX_LENGTH}`;
    }
    if (scope === 'mount') {
        return segments.length > exports.APP_MOUNT_POINT_SEGMENTS
            ? `Mount point ${path} has ${segments.length} segments; an App Module is mounted at / or at a path with exactly ${exports.APP_MOUNT_POINT_SEGMENTS} segment such as /blog`
            : null;
    }
    if (scope === 'app') {
        return segments.length > exports.APP_ROUTE_MAX_SEGMENTS
            ? `App Module route ${path} has ${segments.length} segments; an App Module route has at most ${exports.APP_ROUTE_MAX_SEGMENTS}`
            : null;
    }
    return segments.length > exports.APP_CONTAINER_ROUTE_MAX_SEGMENTS
        ? `App route ${path} has ${segments.length} segments; a page has at most ${exports.APP_CONTAINER_ROUTE_MAX_SEGMENTS} (${exports.APP_MOUNT_POINT_SEGMENTS} for the mount point and ${exports.APP_ROUTE_MAX_SEGMENTS} inside the App Module)`
        : null;
}
/** A `:param` segment addresses one row per collection entry. */
function isAppBaseDynamicRoutePath(path) {
    return path.split('/').some(segment => segment.startsWith(':'));
}
const appRouteSchemaFor = (scope) => zod_1.z
    .object({
    path: zod_1.z.string().min(1),
    title: zod_1.z.string().min(1),
    entry: zod_1.z.string().min(1).default('index.html'),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    agentActionIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    navigation: zod_1.z.boolean().default(true),
    dynamicSlugSourceKey: zod_1.z.string().min(1).optional(),
    dynamicSlugColumnId: zod_1.z.string().min(1).optional(),
    /**
     * The rights the App brings for this page, in the format of the access
     * section; a new page of a container starts with exactly these.
     */
    access: app_access_vocabulary_1.AppRouteAccessSchema.optional(),
})
    .strict()
    .superRefine((route, ctx) => {
    const issue = appRoutePathIssue(route.path, scope);
    if (issue) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: issue,
            path: ['path'],
        });
    }
});
/** A page of the App Container, in mounted coordinates. */
exports.AppRouteSchema = appRouteSchemaFor('container');
/** A route of an App, relative to its start page `/`. */
const AppDefinitionRouteSchema = appRouteSchemaFor('app');
/**
 * Nests the navigation of one App: the entry of its start page is the main
 * entry, every other entry of the App sits below it. An App without a
 * start-page entry keeps all its entries as main entries.
 */
function nestAppNavigation(navigation, startPagePath) {
    const startPath = normalizeAppRoutePath(startPagePath);
    const main = navigation.find(item => item.path !== undefined && normalizeAppRoutePath(item.path) === startPath);
    return navigation.map(({ parentId: _parentId, ...item }) => main && item.id !== main.id ? { ...item, parentId: main.id } : item);
}
exports.AppActionFieldSchema = zod_1.z
    .object({
    columnId: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    type: zod_1.z
        .enum([
        'text',
        'textarea',
        'email',
        'url',
        'number',
        'date',
        'select',
        'multi-select',
        'checkbox',
    ])
        .default('text'),
    required: zod_1.z.boolean().default(false),
    maxLength: zod_1.z.number().int().positive().max(4000).optional(),
    options: zod_1.z.array(zod_1.z.string().min(1)).max(128).optional(),
})
    .strict();
exports.AppBaseRowInsertActionSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    type: zod_1.z.literal('rowInsert'),
    sourceKey: zod_1.z.string().min(1),
    fields: zod_1.z.array(exports.AppActionFieldSchema).default([]),
    consentRequired: zod_1.z.boolean().default(false),
    /** One row per signed-in person and value of this column. */
    onePerOwner: app_base_one_per_owner_1.AppBaseOnePerOwnerSchema.optional(),
})
    .strict();
exports.AppBaseAutomationInputBindingSchema = zod_1.z
    .object({
    targetField: zod_1.z.string().min(1),
    source: zod_1.z.enum(['payload', 'route', 'row', 'user', 'constant']),
    sourceKey: zod_1.z.string().min(1).optional(),
    columnId: zod_1.z.string().min(1).optional(),
    routeParam: zod_1.z.string().min(1).optional(),
    payloadPath: zod_1.z.string().min(1).optional(),
    value: zod_1.z.unknown().optional(),
})
    .strict();
exports.AppBaseAutomationResultPresentationSchema = zod_1.z
    .object({
    type: zod_1.z.enum([
        'statusOnly',
        'tableReview',
        'attachmentGallery',
        'imageReview',
        'fileReview',
    ]),
    sourceKey: zod_1.z.string().min(1).optional(),
    columns: zod_1.z.array(zod_1.z.string().min(1)).max(64).default([]),
    filterSourceKey: zod_1.z.string().min(1).optional(),
    primaryAttachmentColumnId: zod_1.z.string().min(1).optional(),
    primaryImageColumnId: zod_1.z.string().min(1).optional(),
    blobOpenMode: zod_1.z
        .enum(['inline', 'fullscreen', 'download'])
        .default('inline'),
    editable: zod_1.z.boolean().default(false),
    saveActionId: zod_1.z.string().min(1).optional(),
    rowLimit: zod_1.z.number().int().positive().max(500).default(50),
})
    .strict()
    .superRefine((presentation, ctx) => {
    if (presentation.type !== 'statusOnly' && !presentation.sourceKey) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Result presentations other than statusOnly require sourceKey',
            path: ['sourceKey'],
        });
    }
    if (presentation.editable && !presentation.saveActionId) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Editable result presentations require saveActionId',
            path: ['saveActionId'],
        });
    }
});
exports.AppBaseAutomationRunActionSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    type: zod_1.z.literal('automationRun'),
    // Optional declarative form input; omission keeps non-form automation payloads.
    fields: zod_1.z.array(exports.AppActionFieldSchema).min(1).max(64).optional(),
    automationKey: zod_1.z.string().min(1),
    blockId: zod_1.z.string().min(1),
    automationTemplateId: zod_1.z.string().min(1).optional(),
    docId: zod_1.z.string().min(1).optional(),
    automationId: zod_1.z.string().min(1).optional(),
    workflowId: zod_1.z.string().min(1).optional(),
    inputSourceKey: zod_1.z.string().min(1).optional(),
    inputBindings: zod_1.z.array(exports.AppBaseAutomationInputBindingSchema).default([]),
    resultPresentation: exports.AppBaseAutomationResultPresentationSchema.prefault({
        type: 'statusOnly',
    }),
    // The automation starts through the internal webhook trigger; the run
    // uses the automation owner's rights, never the caller's.
    consentRequired: zod_1.z.boolean().default(false),
    statusExposure: zod_1.z.literal('summary').default('summary'),
})
    .strict();
exports.AppBaseAttachmentUpdateActionSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    type: zod_1.z.literal('attachmentUpdate'),
    sourceKey: zod_1.z.string().min(1),
    rowIdBinding: zod_1.z.string().min(1),
    columnId: zod_1.z.string().min(1),
    mode: zod_1.z.enum(['replace', 'append', 'newRow']).default('replace'),
    acceptedMimeTypes: zod_1.z
        .array(zod_1.z.string().min(1))
        .min(1)
        .max(16)
        .default(['image/png', 'image/jpeg', 'image/webp']),
    maxBytes: zod_1.z
        .number()
        .int()
        .positive()
        .max(exports.APP_BASE_MAX_FILE_BYTES)
        .default(10 * 1024 * 1024),
    preservePrevious: zod_1.z.boolean().default(true),
    consentRequired: zod_1.z.boolean().default(true),
    removable: zod_1.z.boolean().default(exports.APP_BASE_ATTACHMENT_REMOVABLE_DEFAULT),
    /** Further cells of the row a newRow action makes, each from the page
     * payload value named `binding` (for example the link to a parent row). */
    newRowFields: zod_1.z
        .array(zod_1.z
        .object({
        columnId: zod_1.z.string().min(1),
        binding: zod_1.z.string().min(1),
    })
        .strict())
        .max(exports.APP_BASE_ATTACHMENT_NEW_ROW_FIELDS_MAX)
        .default([]),
    /** Only the host of the App runs it (its file call), never a page: no
     * page leads it and the files need no marker for it. */
    hostOnly: zod_1.z.literal(true).optional(),
})
    .strict();
/**
 * Creates the rows of one create-only Agent Action group (a parent row, its
 * child rows and their links) for visitors or portal users. Input, tables and
 * columns are the contract and the bindings of that Agent Action; the action
 * declares none of its own.
 */
exports.AppBaseRowGroupInsertActionSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    type: zod_1.z.literal('rowGroupInsert'),
    /** Agent Action of the same App. Mounting keeps this id: Agent Actions
     * belong to their App, not to a mount. */
    agentActionId: zod_1.z.string().min(1),
    consentRequired: zod_1.z.boolean().default(false),
})
    .strict();
/**
 * Changes or deletes one row the signed-in portal person owns. Visitors without
 * an account never reach it; a foreign and a missing row get the same answer.
 * An update writes the declared fields the call sends; a delete declares none.
 */
exports.AppBaseOwnRowChangeActionSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    type: zod_1.z.literal('ownRowChange'),
    sourceKey: zod_1.z.string().min(1),
    operation: zod_1.z.enum(['update', 'delete']),
    fields: zod_1.z.array(exports.AppActionFieldSchema).max(64).default([]),
    consentRequired: zod_1.z.boolean().default(false),
})
    .strict();
exports.AppActionSchema = zod_1.z.discriminatedUnion('type', [
    exports.AppBaseRowInsertActionSchema,
    exports.AppBaseAutomationRunActionSchema,
    exports.AppBaseAttachmentUpdateActionSchema,
    exports.AppBaseRowGroupInsertActionSchema,
    exports.AppBaseOwnRowChangeActionSchema,
]);
/** Why an ownRowChange declaration does not fit its operation, if it does not:
 * an update needs a field to write, a delete writes none. */
function appBaseOwnRowChangeFieldsIssue(action) {
    if (action.type !== 'ownRowChange')
        return null;
    const count = action.fields?.length ?? 0;
    if (action.operation === 'update' && count === 0)
        return 'ownRowChange update actions declare at least one field';
    if (action.operation === 'delete' && count > 0)
        return 'ownRowChange delete actions declare no fields';
    return null;
}
/** Why the further cells of a file action do not fit, if they do not: only a
 * newRow action makes a row to fill, and never into its own file column. */
function appBaseAttachmentNewRowFieldsIssue(action) {
    if (action.type !== 'attachmentUpdate')
        return null;
    const fields = action.newRowFields ?? [];
    if (fields.length > 0 && action.mode !== 'newRow')
        return 'attachmentUpdate actions fill newRowFields only in mode newRow';
    if (fields.some(field => field.columnId === action.columnId))
        return 'attachmentUpdate newRowFields never name the file column';
    if (new Set(fields.map(field => field.columnId)).size !== fields.length)
        return 'attachmentUpdate newRowFields name each column once';
    return null;
}
/** Original attachment columns the App explicitly offers for download. */
exports.AppBaseAttachmentDownloadSchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    columnId: zod_1.z.string().min(1),
})
    .strict();
/** Each source a rule reads is one of the App's own. */
function appRuleSourceIssues(rules, dataSourceKeys) {
    return (rules?.rules ?? []).flatMap((rule, index) => (0, app_rules_1.appRuleSourceKeys)(rule).flatMap((sourceKey, position) => dataSourceKeys.includes(sourceKey)
        ? []
        : [
            {
                message: `App rule names unknown source ${sourceKey}`,
                path: [
                    'rules',
                    'rules',
                    index,
                    position === 0 ? 'sourceKey' : 'targetSourceKey',
                ],
            },
        ]));
}
/** The same declaration rules for definitions, manifests and portable schemas. */
function appBaseAttachmentDownloadIssues(downloads, routes, columnsBySource) {
    const issues = [];
    const sourceKeys = new Set(routes.flatMap(route => route.dataSourceKeys));
    const seen = new Set();
    downloads.forEach(({ sourceKey, columnId }, index) => {
        const key = JSON.stringify([sourceKey, columnId]);
        if (seen.has(key))
            issues.push({
                message: `Duplicate App Container attachment download ${sourceKey}.${columnId}`,
                path: ['attachmentDownloads', index],
            });
        seen.add(key);
        if (!sourceKeys.has(sourceKey))
            issues.push({
                message: 'App Container attachment download sourceKey must be declared in route dataSourceKeys',
                path: ['attachmentDownloads', index, 'sourceKey'],
            });
        if (columnsBySource &&
            !columnsBySource[sourceKey]?.some(column => column.id === columnId && column.type === 'attachment'))
            issues.push({
                message: `App Container attachment download ${sourceKey}.${columnId} must reference an attachment column`,
                path: ['attachmentDownloads', index, 'columnId'],
            });
    });
    return issues;
}
exports.AppBaseDocumentExportFormatSchema = zod_1.z.enum(['png', 'jpeg', 'pdf']);
exports.AppBaseDocumentExportSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_DOCUMENT_EXPORT_SCHEMA_VERSION),
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    routePath: zod_1.z.string().min(1),
    selector: zod_1.z.string().min(1),
    formats: zod_1.z.array(exports.AppBaseDocumentExportFormatSchema).min(1).max(4),
    defaultFormat: exports.AppBaseDocumentExportFormatSchema,
    filenameTemplate: zod_1.z.string().min(1).max(160),
    targetActionId: zod_1.z.string().min(1).optional(),
})
    .strict()
    .superRefine((documentExport, ctx) => {
    if (documentExport.formats.includes(documentExport.defaultFormat))
        return;
    ctx.addIssue({
        code: zod_1.z.ZodIssueCode.custom,
        message: 'Document export defaultFormat must be included in formats',
        path: ['defaultFormat'],
    });
});
const AppBaseLiveDataScopeEntrySchema = zod_1.z.enum([
    'dataset-invalidations',
    'automation-status',
]);
exports.AppVisibilityContractSchema = zod_1.z
    .object({
    requiredCapabilities: zod_1.z
        .array(exports.AppBasePlatformCapabilityIdSchema)
        .default([]),
    publicSafe: zod_1.z.boolean().default(false),
    requiresAuth: zod_1.z.boolean().default(true),
    requiresWrite: zod_1.z.boolean().default(false),
    requiresSecret: zod_1.z.boolean().default(false),
    liveDataScopes: zod_1.z.array(AppBaseLiveDataScopeEntrySchema).default([]),
})
    .strict();
/** Portable Agent Action owned by exactly one App. */
exports.AppBaseAgentActionResourceBindingSchema = zod_1.z
    .object({
    bindingKey: zod_1.z.string().regex(/^[a-z][a-z0-9_]{0,63}$/),
    sourceKey: zod_1.z.string().min(1),
    allowedColumnIds: zod_1.z.array(zod_1.z.string().min(1)).min(1).max(128),
    accessMode: zod_1.z.enum(['READ', 'WRITE']),
    lookupKeys: zod_1.z
        .array(zod_1.z
        .object({
        name: zod_1.z.string().regex(/^[a-z][a-z0-9_]{0,63}$/),
        columnId: zod_1.z.string().min(1),
    })
        .strict())
        .max(16)
        .default([]),
    relationTargetKeys: zod_1.z.array(zod_1.z.string().min(1)).max(32).default([]),
})
    .strict();
exports.AppBaseAgentActionDefinitionSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_AGENT_ACTION_DEFINITION_SCHEMA_VERSION),
    id: zod_1.z.string().min(1),
    name: zod_1.z.string().regex(/^[a-z][a-z0-9_]{2,63}$/),
    displayName: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().min(1).max(500),
    contract: zod_1.z.unknown().optional(),
    bindings: zod_1.z.array(exports.AppBaseAgentActionResourceBindingSchema).min(1),
})
    .strict()
    .superRefine((action, ctx) => {
    if (action.bindings.length > app_base_bridge_budgets_1.APP_PAGE_TABLE_LIMIT) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `Agent Action ${action.id} binds ${action.bindings.length} tables (max ${app_base_bridge_budgets_1.APP_PAGE_TABLE_LIMIT}) (limit agentAction.tables)`,
            path: ['bindings'],
        });
        return;
    }
    const bindingKeys = action.bindings.map(binding => binding.bindingKey);
    if (new Set(bindingKeys).size !== bindingKeys.length) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Agent Action binding keys must be unique',
            path: ['bindings'],
        });
    }
});
exports.AppSeoStrategySchema = zod_1.z.enum([
    'pageRoute',
    'contentRow',
    'formRoute',
    'internalRoute',
]);
exports.AppSeoMetadataSourceSchema = zod_1.z.enum([
    'static',
    'row',
    'route',
    'none',
]);
exports.AppSeoCanonicalSchema = zod_1.z.enum(['auto', 'rowField', 'disabled']);
exports.AppSeoHreflangSchema = zod_1.z.enum(['appLocales', 'rowGroup', 'none']);
exports.AppSeoAiSearchSchema = zod_1.z
    .object({
    llmsTxt: zod_1.z.enum(['include', 'exclude']).default('exclude'),
    semanticSummary: zod_1.z.enum(['required', 'optional', 'none']).default('none'),
    robotsAiPolicy: zod_1.z.enum(['allow', 'noai', 'noimageai']).default('noai'),
})
    .strict();
exports.AppSeoContractSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_SEO_CONTRACT_SCHEMA_VERSION),
    strategy: exports.AppSeoStrategySchema,
    indexableByDefault: zod_1.z.boolean().default(false),
    metadataSource: exports.AppSeoMetadataSourceSchema.default('none'),
    structuredDataTypes: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    canonical: exports.AppSeoCanonicalSchema.default('disabled'),
    hreflang: exports.AppSeoHreflangSchema.default('none'),
    aiSearch: exports.AppSeoAiSearchSchema.prefault({}),
})
    .strict()
    .superRefine((contract, ctx) => {
    if (contract.strategy === 'internalRoute' && contract.indexableByDefault) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Internal App SEO routes must default to noindex',
            path: ['indexableByDefault'],
        });
    }
    if (contract.indexableByDefault && contract.metadataSource === 'none') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Indexable App SEO routes require metadataSource other than none',
            path: ['metadataSource'],
        });
    }
    if (contract.strategy === 'internalRoute' &&
        contract.aiSearch.llmsTxt === 'include') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Internal App SEO routes cannot be included in llms.txt',
            path: ['aiSearch', 'llmsTxt'],
        });
    }
    if (contract.metadataSource === 'none' &&
        contract.structuredDataTypes.length > 0) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Structured data requires SEO metadataSource',
            path: ['structuredDataTypes'],
        });
    }
});
exports.AppBaseCompiledRouteSeoOwnerSchema = zod_1.z.discriminatedUnion('kind', [
    zod_1.z
        .object({
        kind: zod_1.z.literal('shell'),
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('app'),
        mountId: zod_1.z.string().min(1),
        appId: zod_1.z.string().min(1),
    })
        .strict(),
]);
exports.AppBaseCompiledRouteSeoSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_COMPILED_ROUTE_SEO_SCHEMA_VERSION),
    id: zod_1.z.string().min(1),
    routePath: zod_1.z.string().min(1),
    appLevel: zod_1.z.boolean().default(false),
    owner: exports.AppBaseCompiledRouteSeoOwnerSchema,
    strategy: exports.AppSeoStrategySchema,
    indexableByDefault: zod_1.z.boolean(),
    metadataSource: exports.AppSeoMetadataSourceSchema,
    structuredDataTypes: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    canonical: exports.AppSeoCanonicalSchema,
    hreflang: exports.AppSeoHreflangSchema,
    aiSearch: exports.AppSeoAiSearchSchema,
    robotsDirectives: zod_1.z.array(zod_1.z.string().min(1)).default([]),
})
    .strict();
function hasRoutePolicy(input) {
    return input.policies.some(policy => policy.cacheClass === input.cacheClass &&
        (policy.path === input.pathPrefix ||
            policy.path.startsWith(`${input.pathPrefix}/`)));
}
function requireRoutePolicy(ctx, policies, input) {
    if (hasRoutePolicy({
        policies,
        pathPrefix: input.pathPrefix,
        cacheClass: input.cacheClass,
    })) {
        return;
    }
    ctx.addIssue({
        code: zod_1.z.ZodIssueCode.custom,
        message: `App ${input.label} requires routePolicies entry ${input.pathPrefix} with cacheClass ${input.cacheClass}`,
        path: ['delivery', 'routePolicies'],
    });
}
exports.AppBaseInteractionControlKindSchema = zod_1.z.enum([
    'route',
    'action',
    'field',
    'status',
    'dataset',
    'export',
]);
exports.AppBaseInteractionIntentSchema = zod_1.z.enum([
    'navigate',
    'rowInsert',
    'rowUpdate',
    'rowDelete',
    'automationRun',
    'editField',
    'readStatus',
    'readDataset',
    'openAttachment',
    'saveAttachment',
    'exportDocument',
]);
exports.AppBaseInteractionRequiredRoleSchema = zod_1.z.enum([
    'reader',
    'writer',
    'manager',
]);
exports.AppBaseInteractionConfirmationPolicySchema = zod_1.z.enum([
    'none',
    'recommended',
    'required',
]);
exports.AppBaseInteractionControlSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    kind: exports.AppBaseInteractionControlKindSchema,
    intent: exports.AppBaseInteractionIntentSchema,
    routePath: zod_1.z.string().min(1).optional(),
    /** Local executable action identity; the compiled id remains mount-qualified. */
    navigationActionId: zod_1.z.string().optional(),
    sourceRoutePaths: zod_1.z.array(zod_1.z.string()).optional(),
    unavailableReason: zod_1.z
        .enum(['target-missing', 'target-ambiguous'])
        .optional(),
    navigation: zod_1.z.enum(['forward', 'back', 'related', 'global']).optional(),
    layout: zod_1.z.string().optional(),
    actionId: zod_1.z.string().min(1).optional(),
    sourceKey: zod_1.z.string().min(1).optional(),
    exportId: zod_1.z.string().min(1).optional(),
    fieldColumnId: zod_1.z.string().min(1).optional(),
    fieldType: exports.AppActionFieldSchema.shape.type.optional(),
    fieldRequired: zod_1.z.boolean().optional(),
    fieldOptions: zod_1.z.array(zod_1.z.string().min(1)).max(128).optional(),
    formats: zod_1.z.array(exports.AppBaseDocumentExportFormatSchema).max(4).optional(),
    selector: zod_1.z.string().min(1).optional(),
    filenameTemplate: zod_1.z.string().min(1).max(160).optional(),
    statePath: zod_1.z.string().min(1).optional(),
    requiredRole: exports.AppBaseInteractionRequiredRoleSchema.default('reader'),
    confirmationPolicy: exports.AppBaseInteractionConfirmationPolicySchema.default('none'),
    description: zod_1.z.string().min(1).max(500).optional(),
})
    .strict();
exports.AppBaseInteractionContractSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_INTERACTION_CONTRACT_SCHEMA_VERSION),
    protocol: zod_1.z.literal('streamlain-app-base-bridge/v1'),
    controls: zod_1.z.array(exports.AppBaseInteractionControlSchema).default([]),
    runtimeHints: zod_1.z.array(zod_1.z.string().min(1).max(500)).max(32).default([]),
})
    .strict()
    .superRefine((contract, ctx) => {
    const seen = new Set();
    for (const [index, control] of contract.controls.entries()) {
        if (!seen.has(control.id)) {
            seen.add(control.id);
            continue;
        }
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `Duplicate App interaction control id ${control.id}`,
            path: ['controls', index, 'id'],
        });
    }
});
/**
 * Delivery of one mounted App. A container manifest lists one entry per
 * mount and its own `delivery` then describes the shell only. The manifest of
 * a single App has no entries; its `delivery` is the delivery of that App.
 */
exports.AppBaseAppDeliverySchema = zod_1.z
    .object({
    mountId: zod_1.z.string().min(1),
    appId: zod_1.z.string().min(1),
    delivery: exports.AppBaseDeliverySchema,
    routePaths: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    actionIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
})
    .strict();
/** Where the Container layout puts the navigation: a top bar or a side bar. */
exports.AppNavigationLayoutSchema = zod_1.z.enum(['top', 'side']);
exports.AppManifestBaseSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_MANIFEST_SCHEMA_VERSION),
    manifestId: zod_1.z.string().min(1),
    name: zod_1.z.string().min(1),
    entry: zod_1.z.string().min(1).default('index.html'),
    delivery: exports.AppBaseDeliverySchema.prefault({}),
    appDeliveries: zod_1.z.array(exports.AppBaseAppDeliverySchema).optional(),
    navigationLayout: exports.AppNavigationLayoutSchema.default('top'),
    routes: zod_1.z.array(exports.AppRouteSchema).default([]),
    navigation: zod_1.z.array(app_base_navigation_contract_1.AppBaseNavigationItemSchema).default([]),
    topBar: zod_1.z.array(app_base_navigation_contract_1.AppBaseCompiledTopBarItemSchema).default([]),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    actions: zod_1.z.array(exports.AppActionSchema).default([]),
    capabilities: zod_1.z.array(exports.AppBaseCapabilitySchema).optional(),
    documentExports: zod_1.z.array(exports.AppBaseDocumentExportSchema).default([]),
    attachmentDownloads: zod_1.z.array(exports.AppBaseAttachmentDownloadSchema).default([]),
    routeSeo: zod_1.z.array(exports.AppBaseCompiledRouteSeoSchema).default([]),
    interaction: exports.AppBaseInteractionContractSchema.optional(),
    /** What the values of its columns must look like, see app-rules.ts. */
    rules: app_rules_1.AppRuleSetSchema.optional(),
    /** Query results read like sources, see app-base-source-query-schema.ts. */
    derivedSources: zod_1.z
        .array(app_base_source_query_schema_1.AppDerivedSourceSchema)
        .max(app_base_source_query_schema_1.APP_DERIVED_SOURCES_MAX)
        .optional(),
})
    .strict();
exports.AppManifestSchema = exports.AppManifestBaseSchema.superRefine((manifest, ctx) => {
    for (const issue of appRuleSourceIssues(manifest.rules, manifest.dataSourceKeys))
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, ...issue });
    const routeSourceKeys = new Set([
        ...manifest.dataSourceKeys,
        ...manifest.routes.flatMap(route => route.dataSourceKeys),
    ]);
    const derivedKeys = new Set();
    manifest.derivedSources?.forEach((derived, index) => {
        if (!manifest.dataSourceKeys.includes(derived.sourceKey))
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `App derived source reads unknown source ${derived.sourceKey}`,
                path: ['derivedSources', index, 'sourceKey'],
            });
        if (routeSourceKeys.has(derived.key) || derivedKeys.has(derived.key))
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `App derived source key ${derived.key} is taken`,
                path: ['derivedSources', index, 'key'],
            });
        derivedKeys.add(derived.key);
    });
    for (const issue of appBaseAttachmentDownloadIssues(manifest.attachmentDownloads, manifest.routes))
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, ...issue });
    for (const issue of (0, app_base_navigation_contract_1.appNavigationIssues)(manifest.navigation, manifest.dataSourceKeys)) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, ...issue });
    }
    const policies = manifest.delivery.routePolicies;
    const actionDataSourceKeys = manifest.actions.flatMap(appActionSourceKeys);
    for (const required of requiredAppBaseRoutePolicies(manifest)) {
        requireRoutePolicy(ctx, policies, required);
    }
    // A route or an action runs with exactly one delivery.
    const deliveryOwners = new Set();
    const servedRoutePaths = new Set(manifest.routes.map(route => route.path));
    const servedActionIds = new Set(manifest.actions.map(action => action.id));
    (manifest.appDeliveries ?? []).forEach((app, index) => {
        const claims = [
            ...app.routePaths.map(path => ({
                key: `route ${path}`,
                known: servedRoutePaths.has(path),
            })),
            ...app.actionIds.map(id => ({
                key: `action ${id}`,
                known: servedActionIds.has(id),
            })),
            { key: `mount ${app.mountId}`, known: true },
        ];
        for (const claim of claims) {
            if (claim.known && !deliveryOwners.has(claim.key)) {
                deliveryOwners.add(claim.key);
                continue;
            }
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: claim.known
                    ? `App delivery lists ${claim.key} for more than one App Module`
                    : `App delivery of ${app.mountId} lists unknown ${claim.key}`,
                path: ['appDeliveries', index],
            });
        }
        if (app.delivery.mode === 'public_static' &&
            app.delivery.liveData.enabled) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App live data requires public_interactive, member_portal, or internal_live delivery mode',
                path: ['appDeliveries', index, 'delivery', 'mode'],
            });
        }
    });
    const routePaths = new Set();
    manifest.routes.forEach((route, index) => {
        if (routePaths.has(route.path)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate App route path ${route.path}`,
                path: ['routes', index, 'path'],
            });
        }
        routePaths.add(route.path);
    });
    manifest.navigation.forEach((item, index) => {
        if (item.path !== undefined && !routePaths.has(item.path)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App navigation paths must reference declared routes',
                path: ['navigation', index, 'path'],
            });
        }
    });
    const routeSeoIds = new Set();
    let appLevelSeoOwner = null;
    manifest.routeSeo.forEach((routeSeo, index) => {
        if (routeSeoIds.has(routeSeo.id)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate App route SEO id ${routeSeo.id}`,
                path: ['routeSeo', index, 'id'],
            });
        }
        routeSeoIds.add(routeSeo.id);
        const route = manifest.routes.find(item => item.path === routeSeo.routePath);
        if (!route) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App route SEO must reference a declared route path',
                path: ['routeSeo', index, 'routePath'],
            });
        }
        if (routeSeo.strategy === 'internalRoute' &&
            routeSeo.indexableByDefault) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Internal App route SEO must be noindex',
                path: ['routeSeo', index, 'indexableByDefault'],
            });
        }
        if (!routeSeo.appLevel)
            return;
        if (appLevelSeoOwner) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `App app-level SEO already owned by ${appLevelSeoOwner}`,
                path: ['routeSeo', index, 'appLevel'],
            });
        }
        appLevelSeoOwner =
            routeSeo.owner.kind === 'shell'
                ? 'shell'
                : `${routeSeo.owner.mountId}/${routeSeo.owner.appId}`;
    });
    const manifestDataSourceKeys = new Set([
        ...manifest.dataSourceKeys,
        ...manifest.routes.flatMap(route => route.dataSourceKeys),
        ...actionDataSourceKeys,
    ]);
    const actionsById = new Map(manifest.actions.map(action => [action.id, action]));
    manifest.actions.forEach((action, index) => {
        const message = appBaseOwnRowChangeFieldsIssue(action) ??
            (0, app_base_one_per_owner_1.appBaseOnePerOwnerIssue)(action) ??
            appBaseAttachmentNewRowFieldsIssue(action);
        if (!message)
            return;
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `App action ${action.id}: ${message}`,
            path: ['actions', index, 'fields'],
        });
    });
    const capabilityIds = new Set();
    (manifest.capabilities ?? []).forEach((capability, index) => {
        if (capabilityIds.has(capability.id)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate App capability id ${capability.id}`,
                path: ['capabilities', index, 'id'],
            });
        }
        capabilityIds.add(capability.id);
        for (const [routeIndex, routePath] of capability.routePaths.entries()) {
            if (!routePaths.has(routePath)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'App capability routePaths must reference declared routes',
                    path: ['capabilities', index, 'routePaths', routeIndex],
                });
            }
        }
        for (const [sourceIndex, sourceKey,] of capability.dataSourceKeys.entries()) {
            if (!manifestDataSourceKeys.has(sourceKey)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'App capability dataSourceKeys must reference declared data sources',
                    path: ['capabilities', index, 'dataSourceKeys', sourceIndex],
                });
            }
        }
        for (const [actionIndex, actionId] of capability.actionIds.entries()) {
            if (!actionsById.has(actionId)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'App capability actionIds must reference declared actions',
                    path: ['capabilities', index, 'actionIds', actionIndex],
                });
            }
        }
    });
    const documentExportIds = new Set();
    manifest.documentExports.forEach((documentExport, index) => {
        if (documentExportIds.has(documentExport.id)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate App document export id ${documentExport.id}`,
                path: ['documentExports', index, 'id'],
            });
        }
        documentExportIds.add(documentExport.id);
        if (!routePaths.has(documentExport.routePath)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App document export routePath must reference a declared route',
                path: ['documentExports', index, 'routePath'],
            });
        }
        if (!documentExport.targetActionId)
            return;
        const action = actionsById.get(documentExport.targetActionId);
        if (action?.type === 'attachmentUpdate')
            return;
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'App document export targetActionId must reference an attachmentUpdate action',
            path: ['documentExports', index, 'targetActionId'],
        });
    });
    if (manifest.delivery.liveData.enabled) {
        if (manifest.delivery.mode === 'public_static') {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App live data requires public_interactive, member_portal, or internal_live delivery mode',
                path: ['delivery', 'mode'],
            });
        }
    }
    else if (manifest.delivery.liveData.scope !== 'none') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'App live data scope requires liveData.enabled=true',
            path: ['delivery', 'liveData', 'scope'],
        });
    }
    manifest.routes.forEach((route, index) => {
        const segments = route.path.split('/');
        const ownRowSegments = segments.filter(segment => segment === app_base_binding_route_1.APP_BASE_OWN_ROW_ROUTE_SEGMENT);
        // `:me` resolves the viewer's own row by ownership, never by a value.
        if (ownRowSegments.length > 0 &&
            (ownRowSegments.length > 1 ||
                segments.includes(':slug') ||
                !route.dynamicSlugSourceKey ||
                route.dynamicSlugColumnId)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App :me routes need exactly one :me segment, no :slug, a dynamicSlugSourceKey and no dynamicSlugColumnId',
                path: ['routes', index, 'path'],
            });
        }
        if (route.dynamicSlugColumnId && !route.dynamicSlugSourceKey) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App dynamic slug columns require dynamicSlugSourceKey',
                path: ['routes', index, 'dynamicSlugSourceKey'],
            });
        }
        if (route.dynamicSlugSourceKey &&
            !route.dataSourceKeys.includes(route.dynamicSlugSourceKey)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App dynamic slug source must be listed in route dataSourceKeys',
                path: ['routes', index, 'dynamicSlugSourceKey'],
            });
        }
    });
});
exports.AppCompositionShellSchema = zod_1.z
    .object({
    manifestId: zod_1.z.string().min(1).default('custom'),
    name: zod_1.z.string().min(1),
    entry: zod_1.z.string().min(1).default('index.html'),
    rootRoutePath: zod_1.z.literal('/').default('/'),
    /**
     * Mount whose app provides the shared app frame (header, footer,
     * sidebar and their styles). The platform wraps every page of the app in
     * that frame and renders the merged app navigation into it. Undefined
     * selects the first frame-providing mount; null disables the frame.
     */
    frameMountId: zod_1.z.string().min(1).nullable().optional(),
    navigationLayout: exports.AppNavigationLayoutSchema.default('top'),
})
    .strict();
exports.AppFrameBrandSchema = zod_1.z
    .object({
    name: zod_1.z.string().min(1).max(80),
    namesI18n: app_base_navigation_contract_1.AppNavigationLabelsSchema.optional(),
    logo: app_base_navigation_contract_1.AppNavigationIconSchema.optional(),
})
    .strict();
/** The App supplies branding, optional styling and foot content; the Container owns structure. */
exports.AppFrameSchema = zod_1.z
    .object({
    brand: exports.AppFrameBrandSchema,
    stylesheet: zod_1.z.string().min(1).optional(),
    foot: zod_1.z.string().min(1).optional(),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
})
    .strict();
exports.AppBaseCompiledFrameSchema = exports.AppFrameSchema.extend({
    mountId: zod_1.z.string().min(1),
}).strict();
/**
 * Whether the Container frames its pages: a frame App, a top bar entry or at
 * least two places to go. A single entry leads only to the page itself, so it
 * frames nothing (a one-page App keeps its own chrome).
 */
function appBaseHasFrame(input) {
    return (Boolean(input.frame) ||
        input.topBar.length > 0 ||
        input.navigation.length > 1);
}
/**
 * The documents the Container inserts into every page, as routes for the
 * binding check: the foot and the top bar panels bind only the frame tables.
 */
function appBaseFrameContentRoutes(frame, topBar) {
    const dataSourceKeys = [...(frame?.dataSourceKeys ?? [])];
    return [
        ...(frame?.foot ? [frame.foot] : []),
        ...topBar.flatMap(item => (item.panel ? [item.panel.entry] : [])),
    ].map(entry => ({ entry, dataSourceKeys }));
}
function appFrameContentIssues(frame, topBar, files) {
    const refs = [
        {
            value: frame?.brand.logo,
            path: ['frame', 'brand', 'logo'],
            contentType: 'image/svg+xml',
        },
        {
            value: frame?.stylesheet,
            path: ['frame', 'stylesheet'],
            contentType: 'text/css',
        },
        { value: frame?.foot, path: ['frame', 'foot'], contentType: 'text/html' },
        ...topBar.flatMap((item, index) => [
            {
                value: item.icon,
                path: ['topBar', index, 'icon'],
                contentType: 'image/svg+xml',
            },
            {
                value: item.panel?.entry,
                path: ['topBar', index, 'panel', 'entry'],
                contentType: 'text/html',
            },
        ]),
    ];
    return refs.flatMap(ref => ref.value !== undefined &&
        (files[ref.value]?.path !== ref.value ||
            normalizeAppArtifactContentType(files[ref.value]?.contentType ?? '') !==
                ref.contentType)
        ? [
            {
                path: ref.path,
                message: 'Frame/top bar content must reference a declared ' +
                    ref.contentType +
                    ' file: ' +
                    ref.value,
            },
        ]
        : []);
}
/**
 * Page an App shows, with status 404, for an address below its place that
 * names no page or no row. `entry` is an HTML file of the App; besides the
 * frame tables it binds no data.
 */
exports.AppNotFoundSchema = zod_1.z
    .object({
    entry: zod_1.z.string().min(1),
})
    .strict();
exports.AppBaseCompiledNotFoundPageSchema = zod_1.z
    .object({
    mountId: zod_1.z.string().min(1),
    entry: zod_1.z.string().min(1),
})
    .strict();
exports.APP_BASE_FRAME_OUTLET_ATTRIBUTE = 'data-sl-frame-outlet';
/** On each navigation list: `1` for Apps, `2` for the pages of one App. */
exports.APP_BASE_FRAME_NAV_LEVEL_ATTRIBUTE = 'data-sl-nav-level';
var app_base_nav_mark_1 = require("./app-base-nav-mark");
Object.defineProperty(exports, "APP_BASE_FRAME_NAV_ACTIVE_ATTRIBUTE", { enumerable: true, get: function () { return app_base_nav_mark_1.APP_BASE_FRAME_NAV_ACTIVE_ATTRIBUTE; } });
Object.defineProperty(exports, "APP_BASE_FRAME_NAV_ATTRIBUTE", { enumerable: true, get: function () { return app_base_nav_mark_1.APP_BASE_FRAME_NAV_ATTRIBUTE; } });
exports.AppBaseAppMountSlotSchema = zod_1.z.enum(['main', 'aside']);
exports.AppBaseAppNavigationPlacementSchema = zod_1.z.enum([
    'primary',
    'secondary',
    'hidden',
]);
exports.AppBaseAppBindingRefSchema = zod_1.z
    .object({
    targetSourceKey: zod_1.z.string().min(1),
    required: zod_1.z.boolean().default(true),
})
    .strict();
/**
 * How an App looks: its own design, or the design of the StreamLain app in
 * the theme of the viewer. Without a value an App keeps its own design.
 */
exports.AppBaseAppDesignSchema = zod_1.z.enum(['own', 'streamlain']);
/**
 * The design of the App of a mount, or of an App the StreamKit serves alone:
 * the one it names, its own without a value or without a mount. The stored
 * mount only carries a design someone chose.
 */
function appBaseDesignOf(source) {
    return source?.design ?? 'own';
}
exports.AppBaseAppMountSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_APP_MOUNT_SCHEMA_VERSION),
    mountId: zod_1.z.string().min(1),
    appId: zod_1.z.string().min(1),
    appVersion: zod_1.z.string().min(1).optional(),
    slot: exports.AppBaseAppMountSlotSchema.default('main'),
    order: zod_1.z.number().int().nonnegative().default(0),
    routePrefix: zod_1.z.string().min(1),
    entryRoutePath: zod_1.z.string().min(1).optional(),
    navigation: zod_1.z.boolean().default(true),
    navigationPlacement: exports.AppBaseAppNavigationPlacementSchema.default('primary'),
    navigationLabel: zod_1.z.string().min(1).optional(),
    design: exports.AppBaseAppDesignSchema.optional(),
    bindings: zod_1.z
        .record(zod_1.z.string().min(1), exports.AppBaseAppBindingRefSchema)
        .prefault({}),
    props: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.unknown()).prefault({}),
})
    .strict()
    .superRefine((mount, ctx) => {
    const routePrefixIssue = appRoutePathIssue(mount.routePrefix, 'mount');
    if (routePrefixIssue) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: routePrefixIssue,
            path: ['routePrefix'],
        });
    }
    const entryRoutePathIssue = mount.entryRoutePath
        ? appRoutePathIssue(mount.entryRoutePath, 'mount')
        : null;
    if (entryRoutePathIssue) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: entryRoutePathIssue,
            path: ['entryRoutePath'],
        });
    }
});
/** An App is mounted at the root place `/` of the App Container. */
function appCompositionHasRootApp(composition) {
    return composition.mounts.some(mount => (mount.entryRoutePath ?? mount.routePrefix) ===
        composition.shell.rootRoutePath);
}
exports.AppCompositionSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_COMPOSITION_SCHEMA_VERSION),
    compositionId: zod_1.z.string().min(1),
    revision: zod_1.z.number().int().positive().default(1),
    updatedAt: zod_1.z.string().min(1).optional(),
    shell: exports.AppCompositionShellSchema,
    // No count of Apps: they share the tables and files of their App
    // Container (card 19.10.2026, choice B).
    mounts: zod_1.z.array(exports.AppBaseAppMountSchema).default([]),
})
    .strict()
    .superRefine((composition, ctx) => {
    const mountIds = new Set();
    const hasRootRouteMount = appCompositionHasRootApp(composition);
    const routePaths = new Set(hasRootRouteMount ? [] : [composition.shell.rootRoutePath]);
    const routePrefixes = new Set();
    const frameMountId = composition.shell.frameMountId;
    if (frameMountId &&
        !composition.mounts.some(mount => mount.mountId === frameMountId)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `App frame mount ${frameMountId} is not mounted`,
            path: ['shell', 'frameMountId'],
        });
    }
    composition.mounts.forEach((mount, index) => {
        const entryRoutePath = mount.entryRoutePath ?? mount.routePrefix;
        if (mountIds.has(mount.mountId)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate App mount id ${mount.mountId}`,
                path: ['mounts', index, 'mountId'],
            });
        }
        mountIds.add(mount.mountId);
        if (routePrefixes.has(mount.routePrefix)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: mount.routePrefix === composition.shell.rootRoutePath
                    ? `An App has exactly one main App Module at ${mount.routePrefix}; mount ${mount.mountId} needs its own mount point`
                    : `Duplicate App composition route prefix ${mount.routePrefix}`,
                path: ['mounts', index, 'routePrefix'],
            });
        }
        routePrefixes.add(mount.routePrefix);
        if (routePaths.has(entryRoutePath)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `Duplicate App composition route path ${entryRoutePath}`,
                path: ['mounts', index, 'entryRoutePath'],
            });
        }
        routePaths.add(entryRoutePath);
    });
});
/** The place of a mount changes through `moveMount` only. */
const AppCompositionMountPatchSchema = zod_1.z
    .object({
    navigation: zod_1.z.boolean().optional(),
    navigationPlacement: exports.AppBaseAppNavigationPlacementSchema.optional(),
    /** null drops the label of the mount: the App shows under its own name. */
    navigationLabel: zod_1.z.string().min(1).nullable().optional(),
    design: exports.AppBaseAppDesignSchema.optional(),
    bindings: zod_1.z
        .record(zod_1.z.string().min(1), exports.AppBaseAppBindingRefSchema)
        .optional(),
    props: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.unknown()).optional(),
})
    .strict();
exports.AppCompositionOperationSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal('mountApp'),
        mount: exports.AppBaseAppMountSchema,
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('unmountApp'),
        mountId: zod_1.z.string().min(1),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('unmountAppEverywhere'),
        appId: zod_1.z.string().min(1),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('updateMount'),
        mountId: zod_1.z.string().min(1),
        patch: AppCompositionMountPatchSchema,
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('moveMount'),
        mountId: zod_1.z.string().min(1),
        /** The new place: `/` or a path with exactly one segment. */
        routePrefix: zod_1.z.string().min(1),
        /** The App mounted at the new place takes the old one. */
        swap: zod_1.z.boolean().optional(),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('updateShell'),
        // The shell fields without their defaults: an absent field keeps its value.
        patch: zod_1.z
            .object({
            name: exports.AppCompositionShellSchema.shape.name,
            entry: exports.AppCompositionShellSchema.shape.entry.unwrap(),
            navigationLayout: exports.AppCompositionShellSchema.shape.navigationLayout.unwrap(),
        })
            .partial()
            .strict(),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('setFrameMount'),
        /**
         * null disables the shared frame; the mount id selects its provider;
         * without one the first mount provides it again (the automatic frame).
         */
        mountId: zod_1.z.string().min(1).nullable().optional(),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('reorderMounts'),
        mountIds: zod_1.z.array(zod_1.z.string().min(1)).min(1),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('setNavigationPlacement'),
        mountId: zod_1.z.string().min(1),
        navigation: zod_1.z.boolean(),
        navigationPlacement: exports.AppBaseAppNavigationPlacementSchema.optional(),
        navigationLabel: zod_1.z.string().min(1).optional(),
    })
        .strict(),
]);
exports.AppCompositionOperationBatchSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    operations: zod_1.z.array(exports.AppCompositionOperationSchema).min(1),
})
    .strict();
exports.AppBaseCompiledArtifactProvenanceSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_COMPILED_ARTIFACT_PROVENANCE_SCHEMA_VERSION),
    source: zod_1.z.literal('appComposition'),
    compositionId: zod_1.z.string().min(1),
    compositionRevision: zod_1.z.number().int().positive(),
    compiledAt: zod_1.z.string().min(1),
    compilerVersion: zod_1.z.literal(exports.APP_BASE_COMPOSITION_COMPILER_VERSION),
})
    .strict();
/** Bare lowercase media type; parameters such as charset are dropped. */
function normalizeAppArtifactContentType(contentType) {
    return contentType.split(';')[0]?.trim().toLowerCase() ?? '';
}
exports.AppArtifactFileSchema = zod_1.z
    .object({
    path: zod_1.z.string().min(1),
    // Stored canonical so every consumer compares one media type form.
    contentType: zod_1.z
        .string()
        .min(1)
        .transform(normalizeAppArtifactContentType)
        .pipe(zod_1.z.string().min(1)),
    sha256: zod_1.z.string().min(16),
    bytes: zod_1.z.number().int().nonnegative(),
    text: zod_1.z.string().optional(),
    storageKey: zod_1.z.string().min(1).optional(),
})
    .strict()
    .superRefine((file, ctx) => {
    if (file.text !== undefined || file.storageKey)
        return;
    ctx.addIssue({
        code: zod_1.z.ZodIssueCode.custom,
        message: 'App artifact file requires text or storageKey',
        path: ['text'],
    });
});
function isRoutePathWithinRootNamespace(routePath, rootRoutePath) {
    return (rootRoutePath === '/' ||
        routePath === rootRoutePath ||
        routePath.startsWith(`${rootRoutePath}/`));
}
exports.AppRouteModuleSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_ROUTE_MODULE_SCHEMA_VERSION),
    id: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1).optional(),
    rootRoutePath: zod_1.z.string().min(1),
    routePaths: zod_1.z.array(zod_1.z.string().min(1)).min(1),
    filePaths: zod_1.z.array(zod_1.z.string().min(1)).min(1),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    actionIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    navigationItemIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    interactionControlIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    buildingBlockRefs: zod_1.z.array(exports.AppBaseBuildingBlockRefSchema).default([]),
    assetRefs: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    shared: zod_1.z.boolean().default(false),
})
    .strict()
    .superRefine((routeModule, ctx) => {
    if (!routeModule.routePaths.includes(routeModule.rootRoutePath)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'App route module rootRoutePath must be in routePaths',
            path: ['rootRoutePath'],
        });
    }
    routeModule.routePaths.forEach((routePath, routeIndex) => {
        if (isRoutePathWithinRootNamespace(routePath, routeModule.rootRoutePath)) {
            return;
        }
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'App route module paths must belong to its rootRoutePath namespace',
            path: ['routePaths', routeIndex],
        });
    });
    const uniqueFields = [
        'routePaths',
        'filePaths',
        'dataSourceKeys',
        'actionIds',
        'navigationItemIds',
        'interactionControlIds',
        'assetRefs',
    ];
    for (const field of uniqueFields) {
        const values = routeModule[field];
        if (new Set(values).size === values.length)
            continue;
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `App route module ${field} must be unique`,
            path: [field],
        });
    }
    const buildingBlockIds = routeModule.buildingBlockRefs.map(ref => ref.id);
    if (new Set(buildingBlockIds).size !== buildingBlockIds.length) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'App route module buildingBlockRefs must be unique',
            path: ['buildingBlockRefs'],
        });
    }
});
/**
 * Where an install creates the table of a resource: in the folder of the App
 * Container, or in the workspace outside of it, where a second App Container
 * can attach it. It only governs a table the install creates; a table the
 * install attaches stays where it is.
 */
exports.AppBaseAppResourcePlacementSchema = zod_1.z.enum([
    'workspace',
    'container',
]);
/**
 * How long the rows of a resource's table stay: a row older than `keepDays`
 * (by its creation) goes, and so does every row beyond the newest
 * `keepRows`. A retention names at least one of both.
 */
exports.AppBaseAppResourceRetentionSchema = zod_1.z
    .object({
    keepDays: zod_1.z.number().int().min(1).max(3650).optional(),
    keepRows: zod_1.z.number().int().min(1).max(1_000_000).optional(),
})
    .strict()
    .refine(retention => retention.keepDays !== undefined || retention.keepRows !== undefined, { message: 'A retention keeps rows by keepDays, keepRows or both' });
const DAY_MS = 24 * 60 * 60 * 1000;
/**
 * The creation time in milliseconds before which `retention` lets a row go
 * at `now`; null when it keeps rows by count alone.
 */
function appResourceRetentionCutoff(retention, now) {
    return retention.keepDays === undefined
        ? null
        : now - retention.keepDays * DAY_MS;
}
/**
 * The rows `retention` lets go at `now`, oldest first: each row created
 * before appResourceRetentionCutoff, and each row beyond the newest
 * `keepRows`. `createdAt` is the creation time in milliseconds; rows are
 * ordered by (createdAt, id), as the platform orders its row locators, so of
 * two rows created at the same time the one with the greater id is newer.
 */
function appResourceRetentionExpiredRowIds(retention, rows, now) {
    const newestFirst = [...rows].sort((a, b) => b.createdAt - a.createdAt || (a.id < b.id ? 1 : -1));
    const cutoff = appResourceRetentionCutoff(retention, now);
    return newestFirst
        .filter((row, index) => (cutoff !== null && row.createdAt < cutoff) ||
        (retention.keepRows !== undefined && index >= retention.keepRows))
        .reverse()
        .map(row => row.id);
}
exports.AppBaseAppResourceDefinitionSchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1).optional(),
    required: zod_1.z.boolean().default(true),
    role: zod_1.z.string().min(1).optional(),
    contentModel: zod_1.z.string().min(1).optional(),
    placement: exports.AppBaseAppResourcePlacementSchema.optional(),
    retention: exports.AppBaseAppResourceRetentionSchema.optional(),
})
    .strict();
/** The place of a resource's table; a resource that names none is `container`. */
function resolveAppResourcePlacement(resource) {
    return resource.placement ?? 'container';
}
/** The place an App gives the table of one of its sources. */
function appSourcePlacement(definition, sourceKey) {
    return resolveAppResourcePlacement(definition.resources.find(resource => resource.sourceKey === sourceKey) ??
        {});
}
/**
 * The place the Apps of one App Container give the table of a source: the
 * place the App that declares the source names (Apps that share a table name
 * one place, findAppContainerPlacementConflicts); `container` when no App
 * declares it.
 */
function appContainerSourcePlacement(appDefinitions, sourceKey) {
    const declaring = Object.values(appDefinitions).find(definition => definition.resources.some(resource => resource.sourceKey === sourceKey));
    return declaring ? appSourcePlacement(declaring, sourceKey) : 'container';
}
/**
 * The tables the Apps of one App Container package place differently. Apps
 * that name the same source key share one table, so all of them must name the
 * same place for it. The tables come in the order the Apps name them first; an
 * App that names a table twice counts once, by the first place it names.
 */
function findAppContainerPlacementConflicts(apps) {
    return appContainerResourceConflicts(apps, resource => resolveAppResourcePlacement(resource)).map(({ sourceKey, apps: named }) => ({
        sourceKey,
        apps: named.map(({ appId, value }) => ({ appId, placement: value })),
    }));
}
/**
 * The tables the Apps of one App Container package keep differently: Apps
 * that share a table name the same retention for it, or none, by the rule of
 * findAppContainerPlacementConflicts.
 */
function findAppContainerRetentionConflicts(apps) {
    return appContainerResourceConflicts(apps, resource => resource.retention
        ? {
            ...(resource.retention.keepDays !== undefined
                ? { keepDays: resource.retention.keepDays }
                : {}),
            ...(resource.retention.keepRows !== undefined
                ? { keepRows: resource.retention.keepRows }
                : {}),
        }
        : null).map(({ sourceKey, apps: named }) => ({
        sourceKey,
        apps: named.map(({ appId, value }) => ({ appId, retention: value })),
    }));
}
/**
 * The retention the Apps of one App Container give the table of a source:
 * the one of the App that declares the source (Apps that share a table name
 * one, findAppContainerRetentionConflicts); none when no App keeps its rows
 * for a time or a count.
 */
function appContainerSourceRetention(appDefinitions, sourceKey) {
    for (const definition of Object.values(appDefinitions)) {
        const resource = definition.resources.find(candidate => candidate.sourceKey === sourceKey);
        if (resource)
            return resource.retention ?? null;
    }
    return null;
}
/**
 * The tables whose resources differ between the Apps that name them, by
 * `valueOf` compared as JSON, in the order the Apps name them first; an App
 * that names a table twice counts once, by its first resource.
 */
function appContainerResourceConflicts(apps, valueOf) {
    const tables = new Map();
    for (const { appId, resources } of apps) {
        const own = new Set();
        for (const resource of resources) {
            if (own.has(resource.sourceKey))
                continue;
            own.add(resource.sourceKey);
            const named = tables.get(resource.sourceKey) ?? [];
            named.push({ appId, value: valueOf(resource) });
            tables.set(resource.sourceKey, named);
        }
    }
    return [...tables]
        .filter(([, named]) => named.some(({ value }) => JSON.stringify(value) !== JSON.stringify(named[0].value)))
        .map(([sourceKey, named]) => ({ sourceKey, apps: named }));
}
exports.AppBaseAppDefinitionOutputSchema = zod_1.z
    .object({
    visibility: exports.AppVisibilityContractSchema,
    routes: zod_1.z.array(exports.AppRouteSchema).default([]),
    navigation: zod_1.z.array(app_base_navigation_contract_1.AppBaseNavigationItemSchema).default([]),
    topBar: zod_1.z.array(app_base_navigation_contract_1.AppBaseCompiledTopBarItemSchema).default([]),
    frame: exports.AppFrameSchema.optional(),
    notFound: exports.AppNotFoundSchema.optional(),
    resources: zod_1.z.array(exports.AppBaseAppResourceDefinitionSchema).default([]),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    actions: zod_1.z.array(exports.AppActionSchema).default([]),
    documentExports: zod_1.z.array(exports.AppBaseDocumentExportSchema).default([]),
    attachmentDownloads: zod_1.z.array(exports.AppBaseAttachmentDownloadSchema).default([]),
    rules: app_rules_1.AppRuleSetSchema.optional(),
    files: zod_1.z.record(zod_1.z.string().min(1), exports.AppArtifactFileSchema).prefault({}),
    routeModules: zod_1.z.array(exports.AppRouteModuleSchema).default([]),
    routeSeo: zod_1.z.array(exports.AppBaseCompiledRouteSeoSchema).default([]),
})
    .strict();
exports.AppBaseAppCompiledOutputSchema = exports.AppBaseAppDefinitionOutputSchema.extend({
    mountId: zod_1.z.string().min(1),
}).strict();
/**
 * A static route that shows exactly one row. `fixed-slug` addresses it by its
 * `slug` cell, `fixed-key` by the value of one declared column (App column
 * id). Exactly one row must match; see resolveAppBaseFixedRow.
 */
exports.AppBaseFixedRowSelectionSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal('fixed-slug'),
        sourceKey: zod_1.z.string().min(1),
        slug: zod_1.z.string().min(1),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('fixed-key'),
        sourceKey: zod_1.z.string().min(1),
        columnId: zod_1.z.string().min(1),
        value: zod_1.z.string().trim().min(1),
    })
        .strict(),
]);
exports.AppBaseAppRouteDefinitionSchema = zod_1.z
    .object({
    route: AppDefinitionRouteSchema,
    rowSelection: exports.AppBaseFixedRowSelectionSchema.optional(),
    filePaths: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    interactionControlIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    buildingBlockRefs: zod_1.z.array(exports.AppBaseBuildingBlockRefSchema).default([]),
    assetRefs: zod_1.z.array(zod_1.z.string().min(1)).default([]),
})
    .strict();
/** An executable navigation control references a route, never a second URL. */
exports.AppNavigationActionSchema = zod_1.z
    .object({
    id: zod_1.z.string().regex(/^[A-Za-z][A-Za-z0-9_-]{0,127}$/),
    label: zod_1.z.string().min(1).max(160),
    target: zod_1.z
        .object({
        routePath: zod_1.z.string().startsWith('/').max(512),
        appId: zod_1.z.string().min(1).optional(),
        mountId: zod_1.z.string().min(1).optional(),
    })
        .strict(),
    /** A frame action is available in the shared foot and App panels on every page. */
    scope: zod_1.z.enum(['page', 'frame']).default('page'),
    navigation: zod_1.z.enum(['forward', 'back', 'related', 'global']).optional(),
    layout: zod_1.z.string().min(1).max(160).optional(),
})
    .strict();
/**
 * An App whose last mount was removed stays in the container with this
 * mark: definition, bindings and Agent Actions are kept, its pages are gone.
 * `mount` is the removed mount as it was, so restoring puts the App back
 * with its place, tables and props; `frame` says it was the frame.
 */
exports.AppDefinitionTrashSchema = zod_1.z
    .object({
    trashedAt: zod_1.z.string().datetime(),
    mount: exports.AppBaseAppMountSchema,
    frame: zod_1.z.boolean(),
})
    .strict();
/** App definition: see APP_BASE_PLATFORM_AUTHORING_GUIDE.terminology. */
exports.AppDefinitionSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_DEFINITION_SCHEMA_VERSION),
    appId: zod_1.z.string().min(1),
    title: zod_1.z.string().min(1),
    /** The start page of an App is always `/`; its mount decides the URL. */
    rootRoutePath: zod_1.z
        .literal('/', {
        error: 'An App Module always starts at /; where it is mounted is chosen at installation',
    })
        .default('/'),
    locales: app_base_locales_1.AppLocalesSchema.optional(),
    seo: exports.AppSeoContractSchema,
    visibility: exports.AppVisibilityContractSchema,
    routes: zod_1.z.array(exports.AppBaseAppRouteDefinitionSchema).min(1),
    resources: zod_1.z.array(exports.AppBaseAppResourceDefinitionSchema).default([]),
    commands: zod_1.z.array(exports.AppActionSchema).default([]),
    agentActions: zod_1.z.array(exports.AppBaseAgentActionDefinitionSchema).default([]),
    exports: zod_1.z.array(exports.AppBaseDocumentExportSchema).default([]),
    attachmentDownloads: zod_1.z.array(exports.AppBaseAttachmentDownloadSchema).default([]),
    /** What must hold for the rows of its tables, see app-rules.ts. */
    rules: app_rules_1.AppRuleSetSchema.optional(),
    navigation: zod_1.z.array(app_base_navigation_contract_1.AppBaseNavigationItemSchema).default([]),
    topBar: zod_1.z.array(app_base_navigation_contract_1.AppTopBarItemSchema).max(8).default([]),
    frame: exports.AppFrameSchema.optional(),
    notFound: exports.AppNotFoundSchema.optional(),
    files: zod_1.z.record(zod_1.z.string().min(1), exports.AppArtifactFileSchema).prefault({}),
    trash: exports.AppDefinitionTrashSchema.optional(),
    navigationActions: zod_1.z.array(exports.AppNavigationActionSchema).max(256).optional(),
    /**
     * The plan of the App's flows (screens, states and the ways between them).
     * Planning metadata: it travels in a package as `flows.json`, never as an
     * App file. The definition checks its form and size; the pages it names
     * are compared when it is written and shown as findings in the catalogue.
     */
    flowPlan: zod_1.z
        .custom(value => typeof value === 'object' && value !== null && !Array.isArray(value), 'The flow plan must be an object')
        .optional(),
})
    .strict()
    .superRefine((definition, ctx) => {
    for (const issue of appBaseAttachmentDownloadIssues(definition.attachmentDownloads, definition.routes.map(item => item.route)))
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, ...issue });
    for (const issue of appRuleSourceIssues(definition.rules, [
        ...definition.resources.map(resource => resource.sourceKey),
        ...definition.routes.flatMap(item => item.route.dataSourceKeys),
    ]))
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, ...issue });
    if (definition.flowPlan !== undefined) {
        const issue = (message) => ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message,
            path: ['flowPlan'],
        });
        if ((0, app_flow_planning_1.flowPlanTooLarge)(definition.flowPlan))
            issue(app_flow_planning_1.FLOW_PLAN_TOO_LARGE);
        else
            try {
                // Its form and the references inside it; the pages are compared
                // where the plan is written, so a change of the pages stays possible.
                (0, app_flow_planning_1.validatePlanningDocument)(definition.flowPlan, {
                    appId: definition.appId,
                });
            }
            catch (error) {
                issue(error instanceof Error ? error.message : 'Invalid flow plan');
            }
    }
    if (definition.trash && definition.trash.mount.appId !== definition.appId) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `App Module ${definition.appId} in trash names the mount of App Module ${definition.trash.mount.appId}`,
            path: ['trash', 'mount', 'appId'],
        });
    }
    for (const issue of [
        ...(0, app_base_navigation_contract_1.appNavigationIssues)(definition.navigation, definition.resources.map(resource => resource.sourceKey), {
            frame: definition.frame,
            routes: definition.routes.map(item => item.route),
        }),
        ...(0, app_base_navigation_contract_1.appNavigationFileIssues)(definition.navigation, definition.files, [
            ...definition.routes.map(item => item.route.entry),
            ...appBaseFrameContentRoutes(definition.frame, definition.topBar).map(route => route.entry),
        ]),
    ]) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, ...issue });
    }
    for (const issue of (0, app_base_navigation_contract_1.appNavigationIssues)(definition.topBar, definition.resources.map(resource => resource.sourceKey), {
        frame: definition.frame,
        routes: definition.routes.map(item => item.route),
    }, 'topBar'))
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, ...issue });
    const routePaths = definition.routes.map(route => route.route.path);
    const filePaths = new Set(Object.keys(definition.files));
    const commandIds = new Set(definition.commands.map(command => command.id));
    const agentActionIds = new Set(definition.agentActions.map(action => action.id));
    const exportIds = new Set(definition.exports.map(item => item.id));
    const navigationIds = new Set(definition.navigation.map(item => item.id));
    const routePathSet = new Set(routePaths);
    const navigationActionIds = new Set();
    for (const [index, action] of (definition.navigationActions ?? []).entries()) {
        const issue = (message) => ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message,
            path: ['navigationActions', index],
        });
        if (navigationActionIds.has(action.id))
            issue('Duplicate navigation action id');
        navigationActionIds.add(action.id);
        if ((!action.target.appId || action.target.appId === definition.appId) &&
            !routePathSet.has(action.target.routePath))
            issue('Navigation target must reference a declared App Module route');
        if (action.scope === 'frame' &&
            !definition.frame &&
            !definition.topBar.some(item => item.panel))
            issue('Frame navigation requires an App frame');
    }
    const addDuplicateIssues = (values, path, label) => {
        const seen = new Set();
        values.forEach((value, index) => {
            if (!seen.has(value)) {
                seen.add(value);
                return;
            }
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `App Module definition ${label} must be unique: ${value}`,
                path: [...path, index],
            });
        });
    };
    addDuplicateIssues(routePaths, ['routes'], 'route paths');
    addDuplicateIssues(definition.resources.map(resource => resource.sourceKey), ['resources'], 'resource sourceKeys');
    addDuplicateIssues(definition.commands.map(command => command.id), ['commands'], 'command ids');
    addDuplicateIssues(definition.agentActions.map(action => action.id), ['agentActions'], 'Agent Action ids');
    addDuplicateIssues(definition.agentActions.map(action => action.name), ['agentActions'], 'Agent Action names');
    addDuplicateIssues(definition.exports.map(item => item.id), ['exports'], 'export ids');
    addDuplicateIssues(definition.navigation.map(item => item.id), ['navigation'], 'navigation ids');
    if (!routePaths.includes(definition.rootRoutePath)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `An App Module needs a start page at ${definition.rootRoutePath}`,
            path: ['routes'],
        });
    }
    const resourceKeys = new Set(definition.resources.map(resource => resource.sourceKey));
    definition.agentActions.forEach((action, actionIndex) => {
        action.bindings.forEach((binding, bindingIndex) => {
            if (resourceKeys.has(binding.sourceKey))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Agent Action bindings must reference App Module resources',
                path: [
                    'agentActions',
                    actionIndex,
                    'bindings',
                    bindingIndex,
                    'sourceKey',
                ],
            });
        });
    });
    for (const issue of appFrameContentIssues(definition.frame, definition.topBar, definition.files))
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, ...issue });
    definition.topBar.forEach((item, index) => {
        if (item.path && !routePathSet.has(item.path))
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['topBar', index, 'path'],
                message: 'Top bar path must reference a declared App Module route',
            });
    });
    addDuplicateIssues(definition.topBar.map(item => item.id), ['topBar'], 'top bar id');
    if (definition.notFound) {
        const notFoundFile = definition.files[definition.notFound.entry];
        if (!notFoundFile ||
            normalizeAppArtifactContentType(notFoundFile.contentType) !==
                'text/html') {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module not-found entry must be an HTML file declared in definition files',
                path: ['notFound', 'entry'],
            });
        }
    }
    // Every page of the App Container shows the frame; its tables are
    // declared resources, and the page rights rule who reads them.
    definition.frame?.dataSourceKeys.forEach((sourceKey, sourceIndex) => {
        if (definition.resources.some(candidate => candidate.sourceKey === sourceKey))
            return;
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'App Module frame dataSourceKeys must reference declared resources',
            path: ['frame', 'dataSourceKeys', sourceIndex],
        });
    });
    if (definition.frame) {
        addDuplicateIssues(definition.frame.dataSourceKeys, ['frame', 'dataSourceKeys'], 'frame dataSourceKeys');
    }
    definition.routes.forEach((route, routeIndex) => {
        if (!filePaths.has(route.route.entry)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module route entry must be declared in definition files',
                path: ['routes', routeIndex, 'route', 'entry'],
            });
        }
        route.filePaths.forEach((filePath, fileIndex) => {
            if (filePaths.has(filePath))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module route filePaths must be declared in definition files',
                path: ['routes', routeIndex, 'filePaths', fileIndex],
            });
        });
        route.assetRefs.forEach((assetRef, assetIndex) => {
            if (filePaths.has(assetRef))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module route assetRefs must be declared in definition files',
                path: ['routes', routeIndex, 'assetRefs', assetIndex],
            });
        });
        route.route.dataSourceKeys.forEach((sourceKey, sourceIndex) => {
            if (resourceKeys.has(sourceKey))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module route dataSourceKeys must reference declared resources',
                path: ['routes', routeIndex, 'route', 'dataSourceKeys', sourceIndex],
            });
        });
        const pageTables = appPageTablesIssue(route.route.path, route.route.dataSourceKeys, definition.frame?.dataSourceKeys);
        if (pageTables) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: pageTables,
                path: ['routes', routeIndex, 'route', 'dataSourceKeys'],
            });
        }
        if (route.rowSelection &&
            !route.route.dataSourceKeys.includes(route.rowSelection.sourceKey)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module route rowSelection sourceKey must be declared in route dataSourceKeys',
                path: ['routes', routeIndex, 'rowSelection', 'sourceKey'],
            });
        }
        if (route.rowSelection && isAppBaseDynamicRoutePath(route.route.path)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module route rowSelection requires a static path',
                path: ['routes', routeIndex, 'rowSelection'],
            });
        }
        route.buildingBlockRefs.forEach((ref, refIndex) => {
            if (ref.sourceKey && !resourceKeys.has(ref.sourceKey)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'App Module buildingBlockRefs sourceKey must reference declared resources',
                    path: [
                        'routes',
                        routeIndex,
                        'buildingBlockRefs',
                        refIndex,
                        'sourceKey',
                    ],
                });
            }
            const isAgentActionRef = isAgentActionInvokeRef(ref);
            if (ref.actionId &&
                !(isAgentActionRef ? agentActionIds : commandIds).has(ref.actionId)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: isAgentActionRef
                        ? 'App Module buildingBlockRefs actionId must reference declared agent actions'
                        : 'App Module buildingBlockRefs actionId must reference declared commands',
                    path: [
                        'routes',
                        routeIndex,
                        'buildingBlockRefs',
                        refIndex,
                        'actionId',
                    ],
                });
            }
            if (ref.exportId && !exportIds.has(ref.exportId)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'App Module buildingBlockRefs exportId must reference declared exports',
                    path: [
                        'routes',
                        routeIndex,
                        'buildingBlockRefs',
                        refIndex,
                        'exportId',
                    ],
                });
            }
            if (ref.routePath && !routePathSet.has(ref.routePath)) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: 'App Module buildingBlockRefs routePath must reference declared routes',
                    path: [
                        'routes',
                        routeIndex,
                        'buildingBlockRefs',
                        refIndex,
                        'routePath',
                    ],
                });
            }
        });
    });
    definition.commands.forEach((command, commandIndex) => {
        const ownRowIssue = appBaseOwnRowChangeFieldsIssue(command) ??
            (0, app_base_one_per_owner_1.appBaseOnePerOwnerIssue)(command) ??
            appBaseAttachmentNewRowFieldsIssue(command);
        if (ownRowIssue) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: `App Module command ${command.id}: ${ownRowIssue}`,
                path: ['commands', commandIndex, 'fields'],
            });
        }
        if (command.type === 'rowGroupInsert' &&
            !agentActionIds.has(command.agentActionId)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module rowGroupInsert commands must reference a declared Agent Action',
                path: ['commands', commandIndex, 'agentActionId'],
            });
        }
        const referencedSourceKeys = command.type === 'automationRun'
            ? [
                command.inputSourceKey,
                ...command.inputBindings.map(binding => binding.sourceKey),
                command.resultPresentation.sourceKey,
                command.resultPresentation.filterSourceKey,
            ].filter((value) => Boolean(value))
            : appActionSourceKeys(command);
        referencedSourceKeys.forEach(sourceKey => {
            if (resourceKeys.has(sourceKey))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module commands must reference declared resources for all source keys',
                path: ['commands', commandIndex],
            });
        });
        if (command.type === 'automationRun' &&
            command.resultPresentation.saveActionId &&
            !commandIds.has(command.resultPresentation.saveActionId)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module automationRun resultPresentation saveActionId must reference declared commands',
                path: [
                    'commands',
                    commandIndex,
                    'resultPresentation',
                    'saveActionId',
                ],
            });
        }
    });
    definition.exports.forEach((documentExport, exportIndex) => {
        if (!routePathSet.has(documentExport.routePath)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module document exports must reference declared routes',
                path: ['exports', exportIndex, 'routePath'],
            });
        }
        if (documentExport.targetActionId &&
            !commandIds.has(documentExport.targetActionId)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module document export targetActionId must reference declared commands',
                path: ['exports', exportIndex, 'targetActionId'],
            });
        }
    });
    definition.navigation.forEach((navigationItem, navigationIndex) => {
        if (navigationItem.path === undefined ||
            routePathSet.has(navigationItem.path))
            return;
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'App Module navigation must reference declared routes',
            path: ['navigation', navigationIndex, 'path'],
        });
    });
    definition.routes.forEach((route, routeIndex) => {
        addDuplicateIssues(route.route.agentActionIds, ['routes', routeIndex, 'route', 'agentActionIds'], 'route agentActionIds');
        route.route.agentActionIds.forEach((actionId, actionIndex) => {
            if (agentActionIds.has(actionId))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module route agentActionIds must reference declared agent actions',
                path: ['routes', routeIndex, 'route', 'agentActionIds', actionIndex],
            });
        });
        route.interactionControlIds.forEach((controlId, controlIndex) => {
            const [prefix] = controlId.split(':', 1);
            if (!['route', 'action', 'export', 'nav', 'dataset'].includes(prefix ?? ''))
                return;
            if (controlId.startsWith(`route:${route.route.path}`))
                return;
            if (controlId.startsWith('action:')) {
                const actionId = actionIdFromInteractionControlId(controlId);
                if (actionId && commandIds.has(actionId))
                    return;
            }
            if (controlId.startsWith('export:') &&
                exportIds.has(controlId.slice('export:'.length)))
                return;
            if (controlId.startsWith('nav:') &&
                navigationIds.has(controlId.slice('nav:'.length)))
                return;
            if (controlId.startsWith('dataset:') &&
                resourceKeys.has(controlId.slice('dataset:'.length)))
                return;
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'App Module interactionControlIds must reference route, command, export or navigation ownership',
                path: ['routes', routeIndex, 'interactionControlIds', controlIndex],
            });
        });
    });
});
function actionIdFromInteractionControlId(controlId) {
    if (!controlId.startsWith('action:'))
        return null;
    const actionControlId = controlId.slice('action:'.length);
    const fieldMarkerIndex = actionControlId.indexOf(':field:');
    return fieldMarkerIndex === -1
        ? actionControlId
        : actionControlId.slice(0, fieldMarkerIndex);
}
exports.AppDefinitionOperationSchema = zod_1.z
    .discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal('defineApp'),
        definition: exports.AppDefinitionSchema,
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('replaceAppDefinition'),
        appId: zod_1.z.string().min(1),
        definition: exports.AppDefinitionSchema,
    })
        .strict(),
])
    .superRefine((operation, ctx) => {
    if (operation.type !== 'replaceAppDefinition')
        return;
    if (operation.appId === operation.definition.appId)
        return;
    ctx.addIssue({
        code: zod_1.z.ZodIssueCode.custom,
        message: 'App Module definition replacement must keep appId stable',
        path: ['definition', 'appId'],
    });
});
exports.AppDefinitionOperationBatchSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    operations: zod_1.z.array(exports.AppDefinitionOperationSchema).min(1),
})
    .strict();
function defineApp(input) {
    return exports.AppDefinitionSchema.parse(input);
}
function buildAppDefinitionBuildingBlockRefs(parsed) {
    const refs = [
        ...parsed.resources.map(resource => exports.AppBaseBuildingBlockRefSchema.parse({
            schemaVersion: exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION,
            id: `streamlain.datasource.${resource.role}.${resource.contentModel}.${resource.sourceKey}`,
            kind: 'dataSource',
            family: 'streamlain.datasource',
            label: resource.label ?? resource.sourceKey,
            sourceKey: resource.sourceKey,
            metadata: {
                role: resource.role,
                contentModel: resource.contentModel,
            },
        })),
        ...parsed.commands.map(command => exports.AppBaseBuildingBlockRefSchema.parse({
            schemaVersion: exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION,
            id: `streamlain.action.${command.type}.${command.id}`,
            kind: 'action',
            family: 'streamlain.action',
            label: command.label,
            actionId: command.id,
            sourceKey: appActionSourceKey(command),
            metadata: {
                intent: command.type,
            },
        })),
        ...parsed.agentActions.map(action => exports.AppBaseBuildingBlockRefSchema.parse({
            schemaVersion: exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION,
            id: `streamlain.capability.agentAction.invoke.${action.id}`,
            kind: 'capability',
            family: 'streamlain.capability',
            label: action.displayName,
            capabilityId: 'agentAction.invoke',
            actionId: action.id,
        })),
        ...parsed.exports.map(documentExport => exports.AppBaseBuildingBlockRefSchema.parse({
            schemaVersion: exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION,
            id: `streamlain.documentExport.${documentExport.formats.join('+')}.${documentExport.id}`,
            kind: 'documentExport',
            family: 'streamlain.documentExport',
            label: documentExport.label,
            exportId: documentExport.id,
            actionId: documentExport.targetActionId,
            metadata: {
                formats: [...documentExport.formats],
            },
        })),
        ...parsed.commands.flatMap(command => {
            if (command.type === 'rowInsert') {
                return [
                    exports.AppBaseBuildingBlockRefSchema.parse({
                        schemaVersion: exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION,
                        id: `streamlain.capability.database.row.insert.${command.id}`,
                        kind: 'capability',
                        family: 'streamlain.capability',
                        label: 'database.row.insert',
                        capabilityId: 'database.row.insert',
                        actionId: command.id,
                        sourceKey: command.sourceKey,
                    }),
                ];
            }
            if (command.type === 'attachmentUpdate') {
                return [
                    exports.AppBaseBuildingBlockRefSchema.parse({
                        schemaVersion: exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION,
                        id: `streamlain.capability.attachment.update.${command.id}`,
                        kind: 'capability',
                        family: 'streamlain.capability',
                        label: 'attachment.update',
                        capabilityId: 'attachment.update',
                        actionId: command.id,
                        sourceKey: command.sourceKey,
                    }),
                ];
            }
            if (command.type === 'ownRowChange') {
                const capabilityId = appBaseCapabilityForAction(command);
                return [
                    exports.AppBaseBuildingBlockRefSchema.parse({
                        schemaVersion: exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION,
                        id: `streamlain.capability.${capabilityId}.${command.id}`,
                        kind: 'capability',
                        family: 'streamlain.capability',
                        label: capabilityId,
                        capabilityId,
                        actionId: command.id,
                        sourceKey: command.sourceKey,
                    }),
                ];
            }
            if (command.type === 'rowGroupInsert') {
                return [
                    exports.AppBaseBuildingBlockRefSchema.parse({
                        schemaVersion: exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION,
                        id: `streamlain.capability.database.row.insert.${command.id}`,
                        kind: 'capability',
                        family: 'streamlain.capability',
                        label: 'database.row.insert',
                        capabilityId: 'database.row.insert',
                        actionId: command.id,
                    }),
                ];
            }
            return [
                exports.AppBaseBuildingBlockRefSchema.parse({
                    schemaVersion: exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION,
                    id: `streamlain.capability.automation.run.${command.id}`,
                    kind: 'capability',
                    family: 'streamlain.capability',
                    label: 'automation.run',
                    capabilityId: 'automation.run',
                    actionId: command.id,
                    sourceKey: command.inputSourceKey,
                }),
            ];
        }),
    ];
    const uniqueRefs = new Map();
    for (const ref of refs)
        uniqueRefs.set(ref.id, ref);
    return [...uniqueRefs.values()];
}
function compileAppDefinition(definition) {
    const parsed = exports.AppDefinitionSchema.parse(definition);
    const routes = parsed.routes.map(route => route.route);
    const dataSourceKeys = uniqueStrings([
        ...parsed.resources.map(resource => resource.sourceKey),
        ...routes.flatMap(route => route.dataSourceKeys),
    ]);
    const navigation = parsed.navigation.length > 0
        ? parsed.navigation
        : routes
            .filter(route => route.navigation)
            .map((route, index) => app_base_navigation_contract_1.AppBaseNavigationItemSchema.parse({
            id: `nav:${route.path}`,
            label: route.title,
            path: route.path,
            order: index,
        }));
    const buildingBlockRefs = new Map();
    for (const ref of [
        ...buildAppDefinitionBuildingBlockRefs(parsed),
        ...parsed.routes.flatMap(route => route.buildingBlockRefs),
    ]) {
        buildingBlockRefs.set(ref.id, ref);
    }
    const generatedInteractionControlIds = uniqueStrings([
        ...routes.map(route => `route:${route.path}`),
        ...dataSourceKeys.map(sourceKey => `dataset:${sourceKey}`),
        ...parsed.commands.flatMap(action => [
            `action:${action.id}`,
            ...(action.type === 'automationRun' ? [`status:${action.id}`] : []),
            ...(action.type === 'rowInsert' ||
                action.type === 'automationRun' ||
                action.type === 'ownRowChange'
                ? (action.fields ?? []).map(field => `action:${action.id}:field:${field.columnId}`)
                : []),
        ]),
        ...parsed.exports.map(documentExport => `export:${documentExport.id}`),
    ]);
    const routeModule = exports.AppRouteModuleSchema.parse({
        schemaVersion: exports.APP_ROUTE_MODULE_SCHEMA_VERSION,
        id: parsed.appId,
        label: parsed.title,
        rootRoutePath: parsed.rootRoutePath,
        routePaths: routes.map(route => route.path),
        filePaths: uniqueStrings([
            ...routes.map(route => route.entry),
            ...parsed.routes.flatMap(route => route.filePaths),
            ...Object.keys(parsed.files),
        ]),
        dataSourceKeys,
        actionIds: parsed.commands.map(action => action.id),
        navigationItemIds: navigation.map(item => item.id),
        interactionControlIds: uniqueStrings(parsed.routes
            .flatMap(route => route.interactionControlIds)
            .concat(generatedInteractionControlIds)),
        buildingBlockRefs: [...buildingBlockRefs.values()],
        assetRefs: uniqueStrings(parsed.routes.flatMap(route => route.assetRefs)),
        shared: false,
    });
    return exports.AppBaseAppDefinitionOutputSchema.parse({
        visibility: parsed.visibility,
        routes,
        navigation,
        topBar: parsed.topBar,
        frame: parsed.frame,
        notFound: parsed.notFound,
        resources: parsed.resources,
        dataSourceKeys,
        actions: parsed.commands,
        documentExports: parsed.exports,
        attachmentDownloads: parsed.attachmentDownloads,
        rules: parsed.rules,
        files: parsed.files,
        routeModules: [routeModule],
        routeSeo: buildAppRouteSeoContracts(parsed),
    });
}
function normalizeAppRoutePath(path) {
    if (path === '/')
        return '/';
    const normalized = `/${path.replace(/^\/+/, '').replace(/\/+$/, '')}`;
    return normalized === '//' ? '/' : normalized;
}
/**
 * The page of the App Container that shows the App route `appPath` of an App
 * mounted at `mountPoint`. Composition and installation both convert here.
 */
function joinMountedAppPath(mountPoint, appPath) {
    const normalizedMountPoint = normalizeAppRoutePath(mountPoint);
    const normalizedAppPath = normalizeAppRoutePath(appPath);
    if (normalizedAppPath === '/')
        return normalizedMountPoint;
    if (normalizedMountPoint === '/')
        return normalizedAppPath;
    return `${normalizedMountPoint}${normalizedAppPath}`;
}
/**
 * The App route behind the App Container page `containerPath` of an App
 * mounted at `mountPoint`; the inverse of joinMountedAppPath.
 */
function unmountAppPath(mountPoint, containerPath) {
    const normalizedMountPoint = normalizeAppRoutePath(mountPoint);
    const normalizedContainerPath = normalizeAppRoutePath(containerPath);
    if (normalizedMountPoint === '/')
        return normalizedContainerPath;
    if (normalizedContainerPath === normalizedMountPoint)
        return '/';
    if (!normalizedContainerPath.startsWith(`${normalizedMountPoint}/`)) {
        throw new Error(`App page ${containerPath} is not below mount point ${mountPoint}`);
    }
    return normalizedContainerPath.slice(normalizedMountPoint.length);
}
/**
 * The App the App Container page `routePath` belongs to: the mount with the
 * longest mount point at or above the page. Null where no App is mounted.
 */
function mountOfRoute(mounts, routePath) {
    return (mounts
        .filter(mount => mount.routePrefix === '/' ||
        routePath === mount.routePrefix ||
        routePath.startsWith(mount.routePrefix.replace(/\/$/, '') + '/'))
        .sort((a, b) => b.routePrefix.length - a.routePrefix.length)[0] ?? null);
}
/**
 * A mount point owns its first path segment: the main App at `/` has no page
 * below it. Returns the first mount point this rule finds taken.
 */
function findTakenAppMountPoint(input) {
    const firstSegment = (path) => path.split('/').find(Boolean);
    const mainAppSegments = new Set(input.mainAppRoutePaths.map(firstSegment));
    return (input.mountPoints.find(mountPoint => {
        const segment = firstSegment(mountPoint);
        return segment !== undefined && mainAppSegments.has(segment);
    }) ?? null);
}
/** The id a mount gives an id of its App (an action, a page entry) in the
 * App Container. */
function scopedAppId(mountId, id) {
    return scopedAppIdOfMount(id, mountId) ? id : `${mountId}:${id}`;
}
/** Whether a compiled id (scopedAppId) belongs to the mount `mountId`. */
function scopedAppIdOfMount(id, mountId) {
    return id.startsWith(`${mountId}:`);
}
/**
 * Whether the App Container page `routePath` (its route pattern) leads the
 * command `actionId` of the container: the App mounted there names the
 * command among the controls of that very page. A command of another App,
 * or of another page of the same App, is not led here.
 */
function appPageLeadsCommand(input) {
    const mount = mountOfRoute(input.mounts, input.routePath);
    const definition = mount && input.appDefinitions[mount.appId];
    if (!mount || !definition)
        return false;
    const appPath = normalizeAppRoutePath(unmountAppPath(mount.routePrefix, input.routePath));
    const page = definition.routes.find(candidate => normalizeAppRoutePath(candidate.route.path) === appPath);
    return (page?.interactionControlIds ?? []).some(controlId => {
        const commandId = actionIdFromInteractionControlId(controlId);
        return (commandId !== null &&
            scopedAppId(mount.mountId, commandId) === input.actionId);
    });
}
/** An Agent Action building block names an Agent Action of its own App, not a command. */
function isAgentActionInvokeRef(ref) {
    return ref.kind === 'capability' && ref.capabilityId === 'agentAction.invoke';
}
/** The container table a mount gives an App table, or the App table itself. */
function mountedAppSourceKey(mount, sourceKey) {
    return mount.bindings[sourceKey]?.targetSourceKey ?? sourceKey;
}
/**
 * The frame an App brings, as its mount carries it in the App Container:
 * files under the mount, tables under their container keys.
 */
function mountedAppFrame(mount, frame) {
    const mapFilePath = (path) => scopedAppFilePath(mount.mountId, path);
    return {
        brand: {
            ...frame.brand,
            ...(frame.brand.logo ? { logo: mapFilePath(frame.brand.logo) } : {}),
        },
        ...(frame.stylesheet ? { stylesheet: mapFilePath(frame.stylesheet) } : {}),
        ...(frame.foot ? { foot: mapFilePath(frame.foot) } : {}),
        dataSourceKeys: frame.dataSourceKeys.map(sourceKey => mountedAppSourceKey(mount, sourceKey)),
    };
}
function scopedAppFilePath(mountId, path) {
    if (path.startsWith(`${mountId}/`))
        return path;
    return `${mountId}/${path.replace(/^\/+/, '')}`;
}
function scopedAppRouteModuleId(input) {
    if (input.routeModule.id === input.definition.appId ||
        normalizeAppRoutePath(input.routeModule.rootRoutePath) ===
            normalizeAppRoutePath(input.definition.rootRoutePath)) {
        return input.mount.mountId;
    }
    return scopedAppId(input.mount.mountId, input.routeModule.id);
}
function mapAppActionDataSources(action, mapSourceKey, mapActionId) {
    if (action.type === 'rowInsert') {
        return {
            ...action,
            sourceKey: mapSourceKey(action.sourceKey),
        };
    }
    if (action.type === 'attachmentUpdate' || action.type === 'ownRowChange') {
        return {
            ...action,
            sourceKey: mapSourceKey(action.sourceKey),
        };
    }
    if (action.type === 'rowGroupInsert')
        return action;
    return {
        ...action,
        inputSourceKey: action.inputSourceKey
            ? mapSourceKey(action.inputSourceKey)
            : action.inputSourceKey,
        inputBindings: action.inputBindings.map(binding => ({
            ...binding,
            sourceKey: binding.sourceKey
                ? mapSourceKey(binding.sourceKey)
                : binding.sourceKey,
        })),
        resultPresentation: {
            ...action.resultPresentation,
            sourceKey: action.resultPresentation.sourceKey
                ? mapSourceKey(action.resultPresentation.sourceKey)
                : action.resultPresentation.sourceKey,
            filterSourceKey: action.resultPresentation.filterSourceKey
                ? mapSourceKey(action.resultPresentation.filterSourceKey)
                : action.resultPresentation.filterSourceKey,
            saveActionId: action.resultPresentation.saveActionId
                ? mapActionId(action.resultPresentation.saveActionId)
                : action.resultPresentation.saveActionId,
        },
    };
}
function mapAppBaseInteractionControlId(controlId, input) {
    if (controlId.startsWith('route:')) {
        return `route:${input.mapRoutePath(controlId.slice('route:'.length))}`;
    }
    if (controlId.startsWith('dataset:')) {
        return `dataset:${input.mapSourceKey(controlId.slice('dataset:'.length))}`;
    }
    if (controlId.startsWith('status:')) {
        return `status:${input.mapActionId(controlId.slice('status:'.length))}`;
    }
    if (controlId.startsWith('export:')) {
        return `export:${input.mapExportId(controlId.slice('export:'.length))}`;
    }
    if (controlId.startsWith('action:')) {
        const [, actionId, ...rest] = controlId.split(':');
        if (!actionId)
            return input.mapFallbackId(controlId);
        return ['action', input.mapActionId(actionId), ...rest].join(':');
    }
    return input.mapFallbackId(controlId);
}
const SHA256_ROUND_CONSTANTS = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1,
    0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
    0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786,
    0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
    0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
    0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b,
    0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a,
    0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
    0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2,
];
function rightRotate(value, bits) {
    return (value >>> bits) | (value << (32 - bits));
}
function appBaseSha256Hex(text) {
    const bytes = new TextEncoder().encode(text);
    const bitLength = bytes.length * 8;
    const paddedLength = Math.ceil((bytes.length + 9) / 64) * 64;
    const padded = new Uint8Array(paddedLength);
    padded.set(bytes);
    padded[bytes.length] = 0x80;
    const view = new DataView(padded.buffer);
    view.setUint32(paddedLength - 8, Math.floor(bitLength / 0x100000000));
    view.setUint32(paddedLength - 4, bitLength);
    let h0 = 0x6a09e667;
    let h1 = 0xbb67ae85;
    let h2 = 0x3c6ef372;
    let h3 = 0xa54ff53a;
    let h4 = 0x510e527f;
    let h5 = 0x9b05688c;
    let h6 = 0x1f83d9ab;
    let h7 = 0x5be0cd19;
    const words = new Uint32Array(64);
    for (let offset = 0; offset < paddedLength; offset += 64) {
        for (let i = 0; i < 16; i++) {
            words[i] = view.getUint32(offset + i * 4);
        }
        for (let i = 16; i < 64; i++) {
            const s0 = rightRotate(words[i - 15], 7) ^
                rightRotate(words[i - 15], 18) ^
                (words[i - 15] >>> 3);
            const s1 = rightRotate(words[i - 2], 17) ^
                rightRotate(words[i - 2], 19) ^
                (words[i - 2] >>> 10);
            words[i] = (words[i - 16] + s0 + words[i - 7] + s1) >>> 0;
        }
        let a = h0;
        let b = h1;
        let c = h2;
        let d = h3;
        let e = h4;
        let f = h5;
        let g = h6;
        let h = h7;
        for (let i = 0; i < 64; i++) {
            const s1 = rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25);
            const ch = (e & f) ^ (~e & g);
            const temp1 = (h + s1 + ch + SHA256_ROUND_CONSTANTS[i] + words[i]) >>> 0;
            const s0 = rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22);
            const maj = (a & b) ^ (a & c) ^ (b & c);
            const temp2 = (s0 + maj) >>> 0;
            h = g;
            g = f;
            f = e;
            e = (d + temp1) >>> 0;
            d = c;
            c = b;
            b = a;
            a = (temp1 + temp2) >>> 0;
        }
        h0 = (h0 + a) >>> 0;
        h1 = (h1 + b) >>> 0;
        h2 = (h2 + c) >>> 0;
        h3 = (h3 + d) >>> 0;
        h4 = (h4 + e) >>> 0;
        h5 = (h5 + f) >>> 0;
        h6 = (h6 + g) >>> 0;
        h7 = (h7 + h) >>> 0;
    }
    return [h0, h1, h2, h3, h4, h5, h6, h7]
        .map(value => value.toString(16).padStart(8, '0'))
        .join('');
}
function compileAppMount(input) {
    const definition = exports.AppDefinitionSchema.parse(input.definition);
    const mount = exports.AppBaseAppMountSchema.parse(input.mount);
    const appLevelRoutePath = input.appLevelRoutePath
        ? normalizeAppRoutePath(input.appLevelRoutePath)
        : null;
    if (mount.appId !== definition.appId) {
        throw new Error(`App mount ${mount.mountId} references ${mount.appId} but definition is ${definition.appId}`);
    }
    const output = compileAppDefinition(definition);
    const mapRoutePath = (routePath) => joinMountedAppPath(mount.routePrefix, routePath);
    const mapSourceKey = (sourceKey) => mountedAppSourceKey(mount, sourceKey);
    const mapActionId = (actionId) => scopedAppId(mount.mountId, actionId);
    const mapNavigationId = (navigationId) => scopedAppId(mount.mountId, navigationId);
    const mapExportId = (exportId) => scopedAppId(mount.mountId, exportId);
    const mapFilePath = (path) => scopedAppFilePath(mount.mountId, path);
    const routes = output.routes.map(route => exports.AppRouteSchema.parse({
        ...route,
        path: mapRoutePath(route.path),
        entry: mapFilePath(route.entry),
        dataSourceKeys: route.dataSourceKeys.map(mapSourceKey),
        dynamicSlugSourceKey: route.dynamicSlugSourceKey
            ? mapSourceKey(route.dynamicSlugSourceKey)
            : route.dynamicSlugSourceKey,
        ...(route.access && {
            access: {
                ...route.access,
                tables: Object.fromEntries(Object.entries(route.access.tables).map(([sourceKey, table]) => [
                    mapSourceKey(sourceKey),
                    table,
                ])),
            },
        }),
    }));
    // The mount label renames the block's top-level entry; sub-entries keep
    // their own labels. The mount label is one text: the texts the App brings
    // for other languages go with the label they belong to.
    const rootNavigationPath = normalizeAppRoutePath(definition.rootRoutePath);
    const nestMountNavigation = (entries, startPagePath) => (input.soleMenu ? entries : nestAppNavigation(entries, startPagePath));
    const navigation = mount.navigation && mount.navigationPlacement !== 'hidden'
        ? nestMountNavigation(output.navigation.map(item => {
            const mountLabel = item.path !== undefined &&
                normalizeAppRoutePath(item.path) === rootNavigationPath
                ? mount.navigationLabel
                : undefined;
            const { labelsI18n, ...entry } = item;
            return app_base_navigation_contract_1.AppBaseNavigationItemSchema.parse({
                ...entry,
                ...(labelsI18n && !mountLabel ? { labelsI18n } : {}),
                id: mapNavigationId(item.id),
                ...(item.parentId
                    ? { parentId: mapNavigationId(item.parentId) }
                    : {}),
                label: mountLabel ?? item.label,
                ...(item.path !== undefined
                    ? { path: mapRoutePath(item.path) }
                    : {}),
                ...(item.icon ? { icon: mapFilePath(item.icon) } : {}),
                ...(item.badge
                    ? {
                        badge: {
                            ...item.badge,
                            sourceKey: mapSourceKey(item.badge.sourceKey),
                        },
                    }
                    : {}),
                placement: mount.navigationPlacement,
            });
        }), mapRoutePath(rootNavigationPath))
        : [];
    const actions = output.actions.map(action => exports.AppActionSchema.parse({
        ...mapAppActionDataSources(action, mapSourceKey, mapActionId),
        id: mapActionId(action.id),
    }));
    const documentExports = output.documentExports.map(documentExport => exports.AppBaseDocumentExportSchema.parse({
        ...documentExport,
        id: mapExportId(documentExport.id),
        routePath: mapRoutePath(documentExport.routePath),
        targetActionId: documentExport.targetActionId
            ? mapActionId(documentExport.targetActionId)
            : documentExport.targetActionId,
    }));
    const attachmentDownloads = output.attachmentDownloads.map(download => ({
        ...download,
        sourceKey: mapSourceKey(download.sourceKey),
    }));
    const rules = output.rules && {
        version: output.rules.version,
        rules: output.rules.rules.map(rule => rule.kind === 'linked'
            ? {
                ...rule,
                sourceKey: mapSourceKey(rule.sourceKey),
                targetSourceKey: mapSourceKey(rule.targetSourceKey),
            }
            : { ...rule, sourceKey: mapSourceKey(rule.sourceKey) }),
    };
    const resources = output.resources.map(resource => exports.AppBaseAppResourceDefinitionSchema.parse({
        ...resource,
        sourceKey: mapSourceKey(resource.sourceKey),
    }));
    const files = Object.fromEntries(Object.entries(output.files).map(([, file]) => {
        const path = mapFilePath(file.path);
        const text = (0, app_base_template_markers_1.mapAppBaseTemplateTextMarkers)(file.text, {
            navigationActionIds: (definition.navigationActions ?? []).map(action => action.id),
            routePaths: output.routes.map(route => route.path),
            mapRoutePath,
            sourceKeys: output.resources.map(resource => resource.sourceKey),
            mapSourceKey,
            actions: output.actions,
            documentExports: output.documentExports,
            mapActionId,
            mapExportId,
        });
        return [
            path,
            exports.AppArtifactFileSchema.parse({
                ...file,
                path,
                ...(text !== undefined
                    ? {
                        text,
                        bytes: new TextEncoder().encode(text).byteLength,
                        sha256: appBaseSha256Hex(text),
                    }
                    : {}),
            }),
        ];
    }));
    const routeModules = output.routeModules.map(routeModule => {
        const moduleRoutePaths = routeModule.routePaths.map(mapRoutePath);
        // A building block names its target, and the mount renames the targets: the
        // id is derived again from the renamed fields, so the container and an export
        // of it carry canonical ids. A ref outside the families keeps an id of the
        // mount. Two refs the bindings point at one target are one building block.
        const mappedRefs = new Map();
        for (const ref of routeModule.buildingBlockRefs) {
            // Agent Actions keep their ids in the container: the route's
            // agentActionIds, the commands and the runtime actions name them so.
            const mapped = exports.AppBaseBuildingBlockRefSchema.parse({
                ...ref,
                sourceKey: ref.sourceKey ? mapSourceKey(ref.sourceKey) : ref.sourceKey,
                actionId: isAgentActionInvokeRef(ref)
                    ? ref.actionId
                    : ref.actionId
                        ? mapActionId(ref.actionId)
                        : ref.actionId,
                exportId: ref.exportId ? mapExportId(ref.exportId) : ref.exportId,
                routePath: ref.routePath ? mapRoutePath(ref.routePath) : ref.routePath,
            });
            const id = canonicalAppBaseBuildingBlockRefId(mapped) ??
                scopedAppId(mount.mountId, ref.id);
            if (!mappedRefs.has(id))
                mappedRefs.set(id, { ...mapped, id });
        }
        const documentExportRefs = output.documentExports
            .filter(documentExport => routeModule.routePaths.includes(documentExport.routePath))
            .map(documentExport => exports.AppBaseBuildingBlockRefSchema.parse({
            schemaVersion: exports.APP_BASE_BUILDING_BLOCK_REF_SCHEMA_VERSION,
            id: `streamlain.documentExport.${documentExport.formats.join('+')}.${mapExportId(documentExport.id)}`,
            kind: 'documentExport',
            family: 'streamlain.documentExport',
            label: documentExport.label,
            exportId: mapExportId(documentExport.id),
            actionId: documentExport.targetActionId
                ? mapActionId(documentExport.targetActionId)
                : undefined,
            routePath: mapRoutePath(documentExport.routePath),
            metadata: {
                formats: [...documentExport.formats],
            },
        }));
        const buildingBlockRefs = [...mappedRefs.values()];
        for (const ref of documentExportRefs) {
            if (buildingBlockRefs.some(existing => existing.exportId === ref.exportId)) {
                continue;
            }
            buildingBlockRefs.push(ref);
        }
        return exports.AppRouteModuleSchema.parse({
            ...routeModule,
            id: scopedAppRouteModuleId({ definition, mount, routeModule }),
            label: mount.navigationLabel ?? routeModule.label,
            rootRoutePath: mapRoutePath(routeModule.rootRoutePath),
            routePaths: moduleRoutePaths,
            filePaths: routeModule.filePaths.map(mapFilePath),
            dataSourceKeys: routeModule.dataSourceKeys.map(mapSourceKey),
            actionIds: routeModule.actionIds.map(mapActionId),
            navigationItemIds: mount.navigation && mount.navigationPlacement !== 'hidden'
                ? routeModule.navigationItemIds.map(mapNavigationId)
                : [],
            interactionControlIds: routeModule.interactionControlIds.map(controlId => mapAppBaseInteractionControlId(controlId, {
                mapRoutePath,
                mapSourceKey,
                mapActionId,
                mapExportId,
                mapFallbackId: id => scopedAppId(mount.mountId, id),
            })),
            buildingBlockRefs,
            assetRefs: routeModule.assetRefs.map(mapFilePath),
            shared: false,
        });
    });
    const routeSeo = output.routes.map(route => {
        const routePath = mapRoutePath(route.path);
        return buildCompiledRouteSeo({
            id: `${mount.mountId}:${routePath}`,
            routePath,
            appLevel: routePath === appLevelRoutePath,
            owner: {
                kind: 'app',
                mountId: mount.mountId,
                appId: definition.appId,
            },
            seo: definition.seo,
        });
    });
    return exports.AppBaseAppCompiledOutputSchema.parse({
        mountId: mount.mountId,
        visibility: output.visibility,
        routes,
        navigation,
        topBar: output.topBar.map(item => ({
            ...item,
            id: scopedAppId(mount.mountId, item.id),
            icon: mapFilePath(item.icon),
            ...(item.path ? { path: mapRoutePath(item.path) } : {}),
            ...(item.panel
                ? { panel: { entry: mapFilePath(item.panel.entry) } }
                : {}),
            ...(item.badge
                ? {
                    badge: {
                        ...item.badge,
                        sourceKey: mapSourceKey(item.badge.sourceKey),
                    },
                }
                : {}),
        })),
        frame: output.frame ? mountedAppFrame(mount, output.frame) : undefined,
        notFound: output.notFound
            ? { entry: mapFilePath(output.notFound.entry) }
            : undefined,
        resources,
        dataSourceKeys: output.dataSourceKeys.map(mapSourceKey),
        actions,
        documentExports,
        attachmentDownloads,
        rules,
        files,
        routeModules,
        routeSeo,
    });
}
function compileAppCompositionAppOutputs(input) {
    if (input.composition.mounts.length === 0)
        return [];
    const definitionsById = new Map((input.appDefinitions ?? []).map(definition => {
        const parsed = exports.AppDefinitionSchema.parse(definition);
        return [parsed.appId, parsed];
    }));
    // Entries nest below the start page of their App only beside other menus.
    const soleMenu = input.composition.mounts.filter(mount => mount.navigation && mount.navigationPlacement !== 'hidden').length === 1;
    return input.composition.mounts.map(mount => {
        const definition = definitionsById.get(mount.appId);
        if (!definition) {
            throw new Error(`App mount ${mount.mountId} references missing App Module definition ${mount.appId}`);
        }
        return compileAppMount({
            definition,
            mount,
            appLevelRoutePath: input.composition.shell.rootRoutePath,
            soleMenu,
        });
    });
}
function buildAppRouteSeoContracts(definition) {
    const appLevelRoutePath = normalizeAppRoutePath(definition.rootRoutePath);
    return definition.routes.map(routeDefinition => {
        const route = routeDefinition.route;
        return buildCompiledRouteSeo({
            id: `${definition.appId}:${route.path}`,
            routePath: route.path,
            appLevel: normalizeAppRoutePath(route.path) === appLevelRoutePath,
            owner: {
                kind: 'app',
                mountId: definition.appId,
                appId: definition.appId,
            },
            // What the App declares; the page rights decide where it is indexed
            // (appRouteSeoForExposure).
            seo: definition.seo,
        });
    });
}
exports.AppArtifactSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_ARTIFACT_SCHEMA_VERSION),
    artifactId: zod_1.z.string().min(1),
    createdAt: zod_1.z.string().min(1),
    provenance: exports.AppBaseCompiledArtifactProvenanceSchema.optional(),
    manifest: exports.AppManifestSchema,
    files: zod_1.z.record(zod_1.z.string().min(1), exports.AppArtifactFileSchema),
    routeModules: zod_1.z.array(exports.AppRouteModuleSchema).default([]),
    /** Shared app frame compiled from `composition.shell.frameMountId`. */
    frame: exports.AppBaseCompiledFrameSchema.optional(),
    /** Not-found pages of the mounted Apps that bring one. */
    notFoundPages: zod_1.z.array(exports.AppBaseCompiledNotFoundPageSchema).optional(),
})
    .strict()
    .superRefine((artifact, ctx) => {
    for (const issue of [
        ...(0, app_base_navigation_contract_1.appNavigationIssues)(artifact.manifest.navigation, artifact.manifest.dataSourceKeys, { frame: artifact.frame, routes: artifact.manifest.routes }),
        ...(0, app_base_navigation_contract_1.appNavigationFileIssues)(artifact.manifest.navigation, artifact.files, [
            ...artifact.manifest.routes.map(route => route.entry),
            ...appBaseFrameContentRoutes(artifact.frame, artifact.manifest.topBar).map(route => route.entry),
        ]),
    ]) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            ...issue,
            path: ['manifest', ...issue.path],
        });
    }
    for (const issue of appFrameContentIssues(artifact.frame, artifact.manifest.topBar, artifact.files))
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, ...issue });
    for (const issue of (0, app_base_navigation_contract_1.appNavigationIssues)(artifact.manifest.topBar, artifact.manifest.dataSourceKeys, { frame: artifact.frame, routes: artifact.manifest.routes }, 'topBar'))
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            ...issue,
            path: ['manifest', ...issue.path],
        });
    artifact.notFoundPages?.forEach((page, pageIndex) => {
        if (artifact.files[page.entry])
            return;
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'App not-found entry must be a compiled artifact file',
            path: ['notFoundPages', pageIndex, 'entry'],
        });
    });
});
const APP_BASE_SHELL_INDEX_HTML = [
    '<!doctype html>',
    '<html lang="en">',
    `<head><meta charset="utf-8"><title>${brand_1.BRAND_DISPLAY_NAME} App</title></head>`,
    '<body><div id="streamlain-app-base-root"></div></body>',
    '</html>',
    '',
].join('\n');
const APP_BASE_SHELL_INDEX_HTML_SHA256 = appBaseSha256Hex(APP_BASE_SHELL_INDEX_HTML);
function uniqueStrings(values) {
    return [...new Set(values)];
}
function assertUniqueBy(values, keyOf, label) {
    const seen = new Set();
    for (const value of values) {
        const key = keyOf(value);
        if (seen.has(key)) {
            throw new Error(`Duplicate App compiled ${label}: ${key}`);
        }
        seen.add(key);
    }
}
function routeSeoRobotsDirectives(input) {
    const directives = input.indexableByDefault
        ? ['index', 'follow']
        : ['noindex', 'nofollow'];
    if (input.aiSearch.robotsAiPolicy === 'noai')
        directives.push('noai');
    if (input.aiSearch.robotsAiPolicy === 'noimageai') {
        directives.push('noai', 'noimageai');
    }
    return [...new Set(directives)];
}
function buildCompiledRouteSeo(input) {
    return exports.AppBaseCompiledRouteSeoSchema.parse({
        schemaVersion: exports.APP_BASE_COMPILED_ROUTE_SEO_SCHEMA_VERSION,
        id: input.id,
        routePath: input.routePath,
        appLevel: input.appLevel,
        owner: input.owner,
        strategy: input.seo.strategy,
        indexableByDefault: input.seo.indexableByDefault,
        metadataSource: input.seo.metadataSource,
        structuredDataTypes: input.seo.structuredDataTypes,
        canonical: input.seo.canonical,
        hreflang: input.seo.hreflang,
        aiSearch: input.seo.aiSearch,
        robotsDirectives: routeSeoRobotsDirectives({
            indexableByDefault: input.seo.indexableByDefault,
            aiSearch: input.seo.aiSearch,
        }),
    });
}
/** The table an action is declared on. A rowGroupInsert names none: its
 * tables are the bindings of its Agent Action. */
function appActionSourceKey(action) {
    switch (action.type) {
        case 'rowInsert':
        case 'attachmentUpdate':
        case 'ownRowChange':
            return action.sourceKey;
        case 'automationRun':
            return action.inputSourceKey;
        case 'rowGroupInsert':
            return undefined;
    }
}
function appActionSourceKeys(action) {
    if (action.type === 'rowInsert')
        return [action.sourceKey];
    if (action.type === 'attachmentUpdate')
        return [action.sourceKey];
    if (action.type === 'ownRowChange')
        return [action.sourceKey];
    if (action.type === 'rowGroupInsert')
        return [];
    return [
        action.inputSourceKey,
        action.resultPresentation.sourceKey,
        action.resultPresentation.filterSourceKey,
    ].filter((value) => Boolean(value));
}
/** What each delivery of a manifest serves: its mounted Apps, or all of it. */
function appBaseDeliveryScopes(manifest) {
    if (!manifest.appDeliveries?.length)
        return [manifest];
    return manifest.appDeliveries.map(app => {
        const routePaths = new Set(app.routePaths);
        const actionIds = new Set(app.actionIds);
        return {
            delivery: app.delivery,
            dataSourceKeys: app.dataSourceKeys,
            routes: manifest.routes.filter(route => routePaths.has(route.path)),
            actions: manifest.actions.filter(action => actionIds.has(action.id)),
        };
    });
}
/** The runtime endpoints the deliveries of a manifest need a cache rule for. */
function requiredAppBaseRoutePolicies(manifest) {
    const required = new Map();
    const require = (pathPrefix, cacheClass, label) => required.set(`${pathPrefix} ${cacheClass}`, {
        pathPrefix,
        cacheClass,
        label,
    });
    for (const scope of appBaseDeliveryScopes(manifest)) {
        const internal = scope.delivery.mode === 'internal_live';
        // A public-static artifact may declare publish-time data sources whose
        // values are materialized into the artifact. Only runtime-backed modes
        // expose a data endpoint.
        const usesCustomData = scope.delivery.mode !== 'public_static' &&
            (scope.dataSourceKeys.length > 0 ||
                scope.routes.some(route => route.dataSourceKeys.length > 0) ||
                scope.actions.some(action => appActionSourceKeys(action).length > 0));
        if (usesCustomData) {
            if (internal) {
                require(exports.APP_BASE_SOURCE_QUERY_ROUTE, 'internalLiveData', 'internal live data endpoint');
            }
            else {
                require(exports.APP_BASE_SOURCE_QUERY_ROUTE, 'customData', 'data endpoint');
            }
        }
        if (scope.actions.length > 0) {
            if (internal) {
                require(exports.APP_BASE_INTERNAL_LIVE_COMMAND_ROUTE, 'internalLiveCommand', 'internal live command endpoint');
            }
            else {
                require(exports.APP_BASE_EXTERNAL_ACTION_ROUTE, 'customAction', 'action endpoint');
            }
        }
        if (scope.delivery.liveData.enabled) {
            if (internal) {
                require(exports.APP_BASE_INTERNAL_LIVE_EVENTS_ROUTE, 'internalLiveEvents', 'internal live events endpoint');
            }
            else {
                require(exports.APP_BASE_EXTERNAL_EVENTS_ROUTE, 'customEvents', 'live events endpoint');
            }
        }
    }
    return [...required.values()];
}
function withRequiredAppBaseDeliveryRoutePolicies(input) {
    const routePolicies = [...input.delivery.routePolicies];
    for (const required of requiredAppBaseRoutePolicies(input)) {
        if (routePolicies.some(policy => policy.path === required.pathPrefix &&
            policy.cacheClass === required.cacheClass)) {
            continue;
        }
        routePolicies.push({
            path: required.pathPrefix,
            cacheClass: required.cacheClass,
        });
    }
    return exports.AppBaseDeliverySchema.parse({
        ...input.delivery,
        routePolicies,
    });
}
/**
 * A page that is not public is never in search, whatever its App declares
 * for its public pages.
 */
function nonPublicRouteSeoContract() {
    return buildShellSeoContract(deriveAppBaseExposureProfile('internalLive'));
}
function buildShellSeoContract(exposure) {
    return exports.AppSeoContractSchema.parse(exposure.robotsIndex
        ? {
            schemaVersion: exports.APP_SEO_CONTRACT_SCHEMA_VERSION,
            strategy: 'pageRoute',
            indexableByDefault: true,
            metadataSource: 'static',
            structuredDataTypes: ['WebPage'],
            canonical: 'auto',
            hreflang: 'appLocales',
            aiSearch: {
                llmsTxt: 'include',
                semanticSummary: 'optional',
                robotsAiPolicy: 'allow',
            },
        }
        : {
            schemaVersion: exports.APP_SEO_CONTRACT_SCHEMA_VERSION,
            strategy: 'internalRoute',
            indexableByDefault: false,
            metadataSource: 'none',
            structuredDataTypes: [],
            canonical: 'disabled',
            hreflang: 'none',
            aiSearch: {
                llmsTxt: 'exclude',
                semanticSummary: 'none',
                robotsAiPolicy: 'noai',
            },
        });
}
/** The SEO of the container shell route from the profile of the shell. */
function appShellRouteSeoForExposure(item, profile) {
    return buildCompiledRouteSeo({
        id: item.id,
        routePath: item.routePath,
        appLevel: item.appLevel,
        owner: item.owner,
        seo: buildShellSeoContract(deriveAppBaseExposureProfile(profile)),
    });
}
/**
 * The SEO of one App page from the delivery profile of that page. A page
 * outside search (portal, members, workspace) is never indexed, whatever its
 * App declares; a page open to visitors keeps the App's own indexing decision
 * (indexable, or internalRoute = never in search) and otherwise takes the
 * contract of its profile.
 */
function appRouteSeoForExposure(input) {
    const exposure = deriveAppBaseExposureProfile(input.profile);
    const seo = !exposure.robotsIndex
        ? nonPublicRouteSeoContract()
        : input.appSeo.indexableByDefault ||
            input.appSeo.strategy === 'internalRoute'
            ? input.appSeo
            : buildShellSeoContract(exposure);
    return buildCompiledRouteSeo({
        id: input.id,
        routePath: input.routePath,
        appLevel: input.appLevel,
        owner: input.owner,
        seo,
    });
}
exports.AppVisibilityCompatibilityIssueSchema = zod_1.z
    .object({
    mountId: zod_1.z.string().min(1),
    appId: zod_1.z.string().min(1),
    exposureProfile: exports.AppBaseExposureProfileSchema,
    /** The page the rule refused; null for a rule on the whole App. */
    routePath: zod_1.z.string().nullable(),
    requirement: zod_1.z.string().min(1),
    message: zod_1.z.string().min(1),
})
    .strict();
function liveDataScopeIncludes(scopes, scope) {
    return scopes.includes(scope);
}
function impliedCapabilitiesForAppOutput(output, hasAgentActions = false) {
    const capabilities = new Set();
    if (output.dataSourceKeys.length > 0 ||
        output.routes.some(route => route.dataSourceKeys.length > 0)) {
        capabilities.add('dataset.readWindow');
    }
    if (output.visibility.liveDataScopes.length > 0) {
        capabilities.add('dataset.subscribe');
    }
    for (const action of output.actions) {
        capabilities.add(appBaseCapabilityForAction(action));
    }
    if (output.documentExports.length > 0)
        capabilities.add('document.export');
    if (hasAgentActions)
        capabilities.add('agentAction.invoke');
    // Reading the people with access is a wish of the App, not of its routes.
    if (output.visibility.requiredCapabilities.includes('members.read')) {
        capabilities.add('members.read');
    }
    return capabilities;
}
/**
 * Capabilities the page rights decide per page at runtime: a member acting
 * internally on a page that reads the table (appPageCapabilityAllowed).
 */
const APP_PAGE_RUNTIME_CAPABILITIES = new Set(['members.read', 'dataset.subscribe', 'agentAction.invoke']);
/** The stronger profile asks more of an App: live members before visitors. */
const APP_EXPOSURE_PROFILE_STRENGTH = {
    publicStatic: 0,
    publicInteractive: 1,
    memberPortal: 2,
    internalLive: 3,
};
/** The strongest of these profiles, or `fallback` when there is none. */
function strongestAppBaseExposureProfile(profiles, fallback) {
    let strongest;
    for (const profile of profiles) {
        if (!strongest ||
            APP_EXPOSURE_PROFILE_STRENGTH[profile] >
                APP_EXPOSURE_PROFILE_STRENGTH[strongest])
            strongest = profile;
    }
    return strongest ?? fallback;
}
/**
 * The most open of these profiles, or `fallback` when there is none: the
 * profile of a container shell, which has to deliver every page it holds.
 */
function openestAppBaseExposureProfile(profiles, fallback) {
    let openest;
    for (const profile of profiles) {
        if (!openest ||
            APP_EXPOSURE_PROFILE_STRENGTH[profile] <
                APP_EXPOSURE_PROFILE_STRENGTH[openest])
            openest = profile;
    }
    return openest ?? fallback;
}
/**
 * Whether the mounted Apps fit the profiles their page rights give their
 * pages (`pageExposureProfiles`, by container path). Visitor rules hold per
 * page open to visitors; what an App does as a whole is checked against the
 * strongest profile of its pages. Live data, members and Agent Actions are
 * decided per page at runtime (appPageCapabilityAllowed).
 */
function getAppVisibilityCompatibilityIssues(input) {
    const composition = exports.AppCompositionSchema.parse(input.composition);
    const outputs = compileAppCompositionAppOutputs({
        composition,
        appDefinitions: input.appDefinitions,
    });
    const profileOfPage = (routePath) => {
        const profile = input.pageExposureProfiles.get(routePath);
        if (!profile) {
            throw new Error(`App page ${routePath} has no profile`);
        }
        return profile;
    };
    const mountsById = new Map(composition.mounts.map(mount => [mount.mountId, mount]));
    const definitionsById = new Map((input.appDefinitions ?? []).map(definition => {
        const parsed = exports.AppDefinitionSchema.parse(definition);
        return [parsed.appId, parsed];
    }));
    const issues = [];
    const addIssue = (output, effectiveProfile, requirement, message, routePath = null) => {
        const mount = mountsById.get(output.mountId);
        issues.push(exports.AppVisibilityCompatibilityIssueSchema.parse({
            mountId: output.mountId,
            appId: mount?.appId ?? output.mountId,
            exposureProfile: effectiveProfile,
            routePath,
            requirement,
            message,
        }));
    };
    for (const output of outputs) {
        const visibility = output.visibility;
        const pages = output.routes.map(route => ({
            routePath: route.path,
            profile: profileOfPage(route.path),
        }));
        // Visitor pages: the App must be safe for visitors there.
        for (const page of pages) {
            const pageExposure = deriveAppBaseExposureProfile(page.profile);
            if (pageExposure.requiresAuthenticatedViewer)
                continue;
            if (!visibility.publicSafe) {
                addIssue(output, page.profile, 'publicSafe', `App Module ${output.mountId} must declare publicSafe=true for its visitor page ${page.routePath}`, page.routePath);
            }
            if (visibility.requiresAuth) {
                addIssue(output, page.profile, 'requiresAuth', `App Module ${output.mountId} requires authenticated viewers but page ${page.routePath} is open to visitors`, page.routePath);
            }
            if (visibility.requiresSecret) {
                addIssue(output, page.profile, 'requiresSecret', `App Module ${output.mountId} exposes secret-bound operations on visitor page ${page.routePath}`, page.routePath);
            }
        }
        // What the App does as a whole: against the strongest profile of its pages.
        const effectiveProfile = strongestAppBaseExposureProfile(pages.map(page => page.profile), 'publicStatic');
        const exposure = deriveAppBaseExposureProfile(effectiveProfile);
        const facts = appBaseAudienceFactsForProfile(effectiveProfile);
        // A static public page still takes rows through a form; every other
        // write the capability check below refuses.
        const writesByForm = effectiveProfile === 'publicStatic' &&
            output.actions.some(action => action.type === 'rowInsert' || action.type === 'rowGroupInsert');
        if (!exposure.allowsWrites && visibility.requiresWrite && !writesByForm) {
            addIssue(output, effectiveProfile, 'requiresWrite', `App Module ${output.mountId} requires writes but ${effectiveProfile} is read-only`);
        }
        const mount = mountsById.get(output.mountId);
        const impliedCapabilities = impliedCapabilitiesForAppOutput(output, Boolean(mount && definitionsById.get(mount.appId)?.agentActions.length));
        for (const capability of visibility.requiredCapabilities) {
            if (impliedCapabilities.has(capability))
                continue;
            addIssue(output, effectiveProfile, `requiredCapabilities.${capability}`, `App Module ${output.mountId} declares required capability ${capability} but its compiled output does not expose it`);
        }
        if (effectiveProfile === 'publicStatic') {
            for (const capability of impliedCapabilities) {
                // Decided per page at runtime (appPageCapabilityAllowed).
                if (APP_PAGE_RUNTIME_CAPABILITIES.has(capability))
                    continue;
                const decision = decideAppBaseExposureCapability({
                    exposureProfile: effectiveProfile,
                    principal: 'anonymous',
                    capability,
                });
                if (decision.allowed)
                    continue;
                addIssue(output, effectiveProfile, `publicStatic.${capability}`, `App Module ${output.mountId} capability ${capability} is not allowed in publicStatic`);
            }
        }
        const decide = (action, principal) => action.type === 'rowGroupInsert'
            ? decideAppBaseRowGroupInsertExposure({
                exposureProfile: effectiveProfile,
                principal,
            })
            : decideAppBaseExposureCapability({
                exposureProfile: effectiveProfile,
                principal,
                capability: appBaseCapabilityForAction(action),
            });
        if (!facts.signsIn) {
            for (const action of output.actions) {
                const decision = decide(action, 'anonymous');
                if (action.type === 'rowInsert' || action.type === 'rowGroupInsert') {
                    if (!decision.allowed || !action.consentRequired) {
                        addIssue(output, effectiveProfile, `publicInteractive.action.${action.id}`, `App Module ${output.mountId} action ${action.id} requires authenticated or unsafe execution; publicInteractive ${action.type} actions need consent`);
                    }
                    continue;
                }
                if (!decision.allowed) {
                    addIssue(output, effectiveProfile, `publicInteractive.action.${action.id}`, `App Module ${output.mountId} action ${action.id} requires authenticated or unsafe execution; publicInteractive actions need consent`);
                }
            }
        }
        if (facts.signsIn) {
            // A signed-in App serves portal persons (memberPortal) and members; the
            // page rights decide per page who of them acts.
            const principals = effectiveProfile === 'memberPortal'
                ? ['portal', 'workspaceMember']
                : ['workspaceMember'];
            for (const action of output.actions) {
                const decisions = principals.map(principal => decide(action, principal));
                if (decisions.some(decision => decision.allowed))
                    continue;
                addIssue(output, effectiveProfile, `${effectiveProfile}.action.${action.id}`, `App Module ${output.mountId} action ${action.id} is not allowed for ${effectiveProfile}: ${decisions.at(-1).reason}`);
            }
        }
        if (effectiveProfile === 'internalLive' &&
            visibility.liveDataScopes.length > 0 &&
            !liveDataScopeIncludes(visibility.liveDataScopes, 'dataset-invalidations')) {
            addIssue(output, effectiveProfile, 'internalLive.liveDataScopes', `App Module ${output.mountId} internal live data must include dataset-invalidations`);
        }
    }
    return issues;
}
function appBaseCapabilityForAction(action) {
    switch (action.type) {
        case 'rowInsert':
        case 'rowGroupInsert':
            return 'database.row.insert';
        case 'automationRun':
            return 'automation.run';
        case 'attachmentUpdate':
            return 'attachment.update';
        case 'ownRowChange':
            return action.operation === 'delete'
                ? 'database.row.delete'
                : 'database.row.update';
    }
}
/** The pages of an App that name the navigation action `actionId`. */
function navigationActionSourcePages(definition, actionId) {
    return definition.routes
        .filter(item => item.interactionControlIds.includes(actionId))
        .map(item => item.route.path);
}
/** One executable navigation control; `owner` qualifies id and layout. */
function navigationActionControl(input) {
    const { action, id, owner } = input;
    if (action.scope === 'page' && !input.sourceRoutePaths.length)
        throw new Error(`Navigation action ${owner}:${action.id} has no source page ownership`);
    return exports.AppBaseInteractionControlSchema.parse({
        id,
        navigationActionId: action.id,
        label: action.label,
        kind: 'route',
        intent: 'navigate',
        sourceRoutePaths: input.sourceRoutePaths,
        ...input.target,
        navigation: action.navigation,
        ...(action.layout
            ? {
                layout: `${action.scope === 'frame' ? 'frame' : 'mount'}:${owner}:${action.layout}`,
            }
            : {}),
        selector: `[data-sl-control=${JSON.stringify(id)}]`,
    });
}
/**
 * The navigation controls of an App alone, as its template carries them:
 * ids as its pages name them, a target in another App is missing until a
 * container mounts that App.
 */
function compileAppDefinitionNavigationActions(definition) {
    return (definition.navigationActions ?? []).map(action => navigationActionControl({
        action,
        id: action.id,
        owner: definition.appId,
        sourceRoutePaths: action.scope === 'frame'
            ? definition.routes.map(item => item.route.path)
            : navigationActionSourcePages(definition, action.id),
        target: !action.target.appId || action.target.appId === definition.appId
            ? { routePath: action.target.routePath }
            : { unavailableReason: 'target-missing' },
    }));
}
/** Shared by platform delivery, Studio and the local Streamkit. */
function compileAppNavigationActions(composition, definitions) {
    const byId = new Map(definitions.map(definition => [definition.appId, definition]));
    const mounts = composition.mounts.filter(mount => byId.has(mount.appId));
    const provider = selectAppBaseFrameMount(composition.shell.frameMountId, mounts, mount => Boolean(byId.get(mount.appId)?.frame));
    return mounts.flatMap(owner => {
        const definition = byId.get(owner.appId);
        return (definition.navigationActions ?? []).map(action => {
            const sourceRoutePaths = action.scope === 'frame'
                ? provider?.mountId === owner.mountId ||
                    definition.topBar.some(item => item.panel)
                    ? [
                        ...(!appCompositionHasRootApp(composition)
                            ? [composition.shell.rootRoutePath]
                            : []),
                        ...mounts.flatMap(mount => byId
                            .get(mount.appId)
                            .routes.map(item => joinMountedAppPath(mount.routePrefix, item.route.path))),
                    ]
                    : []
                : navigationActionSourcePages(definition, action.id).map(path => joinMountedAppPath(owner.routePrefix, path));
            const candidates = (!action.target.appId || action.target.appId === owner.appId) &&
                !action.target.mountId
                ? [owner]
                : mounts.filter(mount => mount.appId === (action.target.appId || owner.appId) &&
                    (!action.target.mountId ||
                        mount.mountId === action.target.mountId));
            const target = candidates.length === 1 ? candidates[0] : undefined;
            if (target &&
                !byId
                    .get(target.appId)
                    .routes.some(item => item.route.path === action.target.routePath))
                throw new Error(`Navigation action ${owner.mountId}:${action.id} references an undeclared target route`);
            return navigationActionControl({
                action,
                id: scopedAppId(owner.mountId, action.id),
                owner: owner.mountId,
                sourceRoutePaths,
                target: target
                    ? {
                        routePath: joinMountedAppPath(target.routePrefix, action.target.routePath),
                    }
                    : {
                        unavailableReason: candidates.length
                            ? 'target-ambiguous'
                            : 'target-missing',
                    },
            });
        });
    });
}
function compileAppComposition(input) {
    const composition = exports.AppCompositionSchema.parse(input.composition);
    const appOutputs = compileAppCompositionAppOutputs({
        composition,
        appDefinitions: input.appDefinitions,
    });
    const mountsById = new Map(composition.mounts.map(mount => [mount.mountId, mount]));
    for (const output of appOutputs) {
        if (mountsById.has(output.mountId))
            continue;
        throw new Error(`App compiled output references unknown mount ${output.mountId}`);
    }
    // Compiling knows no page rights: everything starts closed to the outside.
    // Delivery and SEO of the shell and of each page follow the page rights
    // where the container is written (withAppPageExposures).
    const shellProfile = 'internalLive';
    const exposure = deriveAppBaseExposureProfile(shellProfile);
    const definitionsById = new Map((input.appDefinitions ?? []).map(definition => {
        const parsed = exports.AppDefinitionSchema.parse(definition);
        return [parsed.appId, parsed];
    }));
    const shellRoute = exports.AppRouteSchema.parse({
        path: composition.shell.rootRoutePath,
        title: composition.shell.name,
        entry: composition.shell.entry,
        dataSourceKeys: [],
        navigation: true,
    });
    const shellNavigation = app_base_navigation_contract_1.AppBaseNavigationItemSchema.parse({
        id: 'home',
        label: composition.shell.name,
        path: shellRoute.path,
        order: 0,
    });
    const shellFile = exports.AppArtifactFileSchema.parse({
        path: composition.shell.entry,
        contentType: 'text/html',
        sha256: APP_BASE_SHELL_INDEX_HTML_SHA256,
        bytes: new TextEncoder().encode(APP_BASE_SHELL_INDEX_HTML).byteLength,
        text: APP_BASE_SHELL_INDEX_HTML,
    });
    const shellRouteModule = exports.AppRouteModuleSchema.parse({
        schemaVersion: exports.APP_ROUTE_MODULE_SCHEMA_VERSION,
        id: 'shell',
        label: composition.shell.name,
        rootRoutePath: shellRoute.path,
        routePaths: [shellRoute.path],
        filePaths: [shellFile.path],
        dataSourceKeys: [],
        actionIds: [],
        navigationItemIds: [shellNavigation.id],
        interactionControlIds: [`route:${shellRoute.path}`],
        buildingBlockRefs: [],
        assetRefs: [],
        shared: true,
    });
    const hasRootRouteMount = composition.mounts.some(mount => (mount.entryRoutePath ?? mount.routePrefix) ===
        composition.shell.rootRoutePath);
    const frame = compileAppBaseFrame(composition, appOutputs);
    const notFoundPages = appOutputs.flatMap(output => output.notFound
        ? [{ mountId: output.mountId, entry: output.notFound.entry }]
        : []);
    const routes = [
        ...(hasRootRouteMount ? [] : [shellRoute]),
        ...appOutputs.flatMap(output => output.routes),
    ].map(route => withAppBaseFrameSources(route, frame));
    const manifestEntry = routes.find(route => route.path === composition.shell.rootRoutePath)
        ?.entry ?? composition.shell.entry;
    const navigation = [
        ...(hasRootRouteMount ? [] : [shellNavigation]),
        ...appOutputs.flatMap(output => output.navigation),
    ];
    const actions = appOutputs.flatMap(output => output.actions);
    const documentExports = appOutputs.flatMap(output => output.documentExports);
    // Apps can share a table and declare the same downloadable column.
    const attachmentDownloads = [
        ...new Map(appOutputs
            .flatMap(output => output.attachmentDownloads)
            .map(download => [
            JSON.stringify([download.sourceKey, download.columnId]),
            download,
        ])).values(),
    ];
    // Each mounted App keeps its rules; Apps sharing a table check theirs each.
    const appRules = appOutputs.flatMap(output => output.rules?.rules ?? []);
    if (appRules.length > app_rules_1.APP_RULES_MAX)
        throw new Error(`App Container declares ${appRules.length} rules, at most ${app_rules_1.APP_RULES_MAX}`);
    assertUniqueBy(routes, route => route.path, 'route path');
    assertUniqueBy(navigation, item => item.id, 'navigation id');
    assertUniqueBy(actions, action => action.id, 'action id');
    assertUniqueBy(documentExports, documentExport => documentExport.id, 'export id');
    const files = hasRootRouteMount
        ? {}
        : { [shellFile.path]: shellFile };
    for (const output of appOutputs) {
        for (const [path, file] of Object.entries(output.files)) {
            if (files[path]) {
                throw new Error(`Duplicate App compiled file path: ${path}`);
            }
            files[path] = file;
        }
    }
    const routeModules = [
        ...(hasRootRouteMount ? [] : [shellRouteModule]),
        ...appOutputs.flatMap(output => output.routeModules),
    ];
    assertUniqueBy(routeModules, routeModule => routeModule.id, 'route module id');
    const shellSeo = buildCompiledRouteSeo({
        id: 'shell:/',
        routePath: shellRoute.path,
        appLevel: true,
        owner: { kind: 'shell' },
        seo: buildShellSeoContract(exposure),
    });
    const routeSeo = [
        ...(hasRootRouteMount ? [] : [shellSeo]),
        ...appOutputs.flatMap(output => output.routeSeo.map(item => {
            if (item.owner.kind !== 'app')
                return item;
            const definition = definitionsById.get(item.owner.appId);
            if (!definition) {
                throw new Error(`App route SEO ${item.id} names App Module ${item.owner.appId} without a definition`);
            }
            return appRouteSeoForExposure({
                id: item.id,
                routePath: item.routePath,
                appLevel: item.appLevel,
                owner: item.owner,
                appSeo: definition.seo,
                profile: shellProfile,
            });
        })),
    ];
    assertUniqueBy(routeSeo, item => item.id, 'route SEO id');
    const dataSourceKeys = uniqueStrings([
        ...appOutputs.flatMap(output => output.dataSourceKeys),
        ...routes.flatMap(route => route.dataSourceKeys),
        ...actions.flatMap(appActionSourceKeys),
    ]);
    const agentActionCapabilities = appOutputs
        .filter(output => {
        const mount = mountsById.get(output.mountId);
        return Boolean(mount && definitionsById.get(mount.appId)?.agentActions.length);
    })
        .map(output => exports.AppBaseCapabilitySchema.parse({
        id: `agent-action:${output.mountId}:invoke`,
        capabilityId: 'agentAction.invoke',
        label: 'Invoke App Agent Actions',
        permission: 'execute',
        routePaths: output.routes.map(route => route.path),
        dataSourceKeys: output.dataSourceKeys,
        actionIds: [],
    }));
    const membersReadCapabilities = appOutputs
        .filter(output => output.visibility.requiredCapabilities.includes('members.read'))
        .map(output => exports.AppBaseCapabilitySchema.parse({
        id: `members:${output.mountId}:read`,
        capabilityId: 'members.read',
        label: 'Read the people with access',
        permission: 'read',
        routePaths: output.routes.map(route => route.path),
    }));
    // Cache rules stay on the manifest delivery; an App carries what it runs as.
    const appDeliveries = appOutputs.map(output => exports.AppBaseAppDeliverySchema.parse({
        mountId: output.mountId,
        appId: mountsById.get(output.mountId)?.appId ?? output.mountId,
        delivery: { ...exposure.delivery, routePolicies: [] },
        routePaths: output.routes.map(route => route.path),
        actionIds: output.actions.map(action => action.id),
        dataSourceKeys: uniqueStrings([
            ...output.dataSourceKeys,
            ...output.routes.flatMap(route => route.dataSourceKeys),
            ...output.actions.flatMap(appActionSourceKeys),
        ]),
    }));
    const manifest = withAppBaseInteractionContract({
        schemaVersion: exports.APP_MANIFEST_SCHEMA_VERSION,
        navigationLayout: composition.shell.navigationLayout,
        manifestId: composition.shell.manifestId,
        name: composition.shell.name,
        entry: manifestEntry,
        delivery: withRequiredAppBaseDeliveryRoutePolicies({
            delivery: exposure.delivery,
            appDeliveries,
            dataSourceKeys,
            routes,
            actions,
        }),
        appDeliveries,
        routes,
        navigation,
        topBar: [...appOutputs]
            .sort((a, b) => mountsById.get(a.mountId).order - mountsById.get(b.mountId).order)
            .flatMap(output => [...output.topBar].sort((a, b) => a.order - b.order)),
        dataSourceKeys,
        actions,
        capabilities: [...agentActionCapabilities, ...membersReadCapabilities],
        documentExports,
        attachmentDownloads,
        ...(appRules.length > 0 ? { rules: { version: 1, rules: appRules } } : {}),
        routeSeo,
        interaction: {
            schemaVersion: exports.APP_BASE_INTERACTION_CONTRACT_SCHEMA_VERSION,
            protocol: 'streamlain-app-base-bridge/v1',
            controls: compileAppNavigationActions(composition, [
                ...definitionsById.values(),
            ]),
        },
    });
    const compiledAt = input.now ?? new Date().toISOString();
    return exports.AppArtifactSchema.parse({
        schemaVersion: exports.APP_ARTIFACT_SCHEMA_VERSION,
        artifactId: input.artifactId ??
            `${composition.compositionId}-r${composition.revision}-compiled`,
        createdAt: compiledAt,
        provenance: {
            schemaVersion: exports.APP_BASE_COMPILED_ARTIFACT_PROVENANCE_SCHEMA_VERSION,
            source: 'appComposition',
            compositionId: composition.compositionId,
            compositionRevision: composition.revision,
            compiledAt,
            compilerVersion: exports.APP_BASE_COMPOSITION_COMPILER_VERSION,
        },
        manifest,
        files,
        routeModules,
        frame,
        ...(notFoundPages.length > 0 ? { notFoundPages } : {}),
    });
}
/**
 * The mount whose App provides the shared frame of an App Container, out of
 * its mounts in composition order. `frameMountId` undefined selects the first
 * mount whose App brings a frame, a mount id names the provider, null disables
 * the shared frame explicitly. Reads nothing but its arguments.
 */
function selectAppBaseFrameMount(frameMountId, mounts, bringsFrame) {
    if (frameMountId === null)
        return undefined;
    return frameMountId === undefined
        ? mounts.find(bringsFrame)
        : mounts.find(mount => mount.mountId === frameMountId);
}
function compileAppBaseFrame(composition, appOutputs) {
    const provider = selectAppBaseFrameMount(composition.shell.frameMountId, appOutputs, output => Boolean(output.frame));
    if (!provider)
        return undefined;
    if (!provider.frame) {
        throw new Error(`App frame mount ${provider.mountId} does not provide an app frame`);
    }
    return { mountId: provider.mountId, ...provider.frame };
}
/**
 * The frame wraps every route page but its own file, so each such route reads
 * the frame's tables too: delivery, tickets, access and live updates follow
 * the route sources unchanged. Route modules keep only the sources their App
 * brings (export, ownership).
 */
/** A framed route reads the frame tables in addition to its own. */
function withAppBaseFrameSources(route, frame) {
    if (!frame || frame.dataSourceKeys.length === 0)
        return route;
    return {
        ...route,
        dataSourceKeys: uniqueStrings([
            ...route.dataSourceKeys,
            ...frame.dataSourceKeys,
        ]),
    };
}
exports.AppBaseLifecycleBriefSchema = zod_1.z
    .object({
    prompt: zod_1.z.string().min(1).max(4000),
    goals: zod_1.z.array(zod_1.z.string().min(1).max(240)).max(16).default([]),
    updatedAt: zod_1.z.string().min(1),
    updatedByUserId: zod_1.z.string().min(1),
})
    .strict();
exports.AppBaseLifecycleRunStateSchema = zod_1.z
    .object({
    status: zod_1.z
        .enum([
        'idle',
        'plan-ready',
        'awaiting-confirmation',
        'applied',
        'failed',
    ])
        .default('idle'),
    lastPlanSummary: zod_1.z.string().max(2000).optional(),
    lastError: zod_1.z.string().max(2000).optional(),
    updatedAt: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.AppBaseLifecycleBudgetCountersSchema = zod_1.z
    .object({
    routes: zod_1.z.number().int().nonnegative().default(0),
    navigationItems: zod_1.z.number().int().nonnegative().default(0),
    dataSources: zod_1.z.number().int().nonnegative().default(0),
    actions: zod_1.z.number().int().nonnegative().default(0),
    files: zod_1.z.number().int().nonnegative().default(0),
    artifactBytes: zod_1.z.number().int().nonnegative().default(0),
    updatedAt: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.AppBaseLifecycleSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_LIFECYCLE_SCHEMA_VERSION),
    brief: exports.AppBaseLifecycleBriefSchema.optional(),
    runState: exports.AppBaseLifecycleRunStateSchema.prefault({ status: 'idle' }),
    budgetCounters: exports.AppBaseLifecycleBudgetCountersSchema.prefault({}),
    confirmationRequired: zod_1.z.literal(true).default(true),
})
    .strict();
exports.AppBaseDatabaseBindingOwnershipSchema = zod_1.z.enum([
    'app-base-owned',
    'attached-existing',
]);
exports.AppBaseDatabaseBindingStatusSchema = zod_1.z.enum([
    'active',
    'detached',
]);
exports.AppBaseDatabaseBindingDetachPolicySchema = zod_1.z.enum([
    'preserve-source',
]);
exports.AppBaseDatabaseBindingExposureSchema = zod_1.z
    .object({
    materialized: zod_1.z.boolean().default(true),
    columnIds: zod_1.z.array(zod_1.z.string().min(1)).default([]),
    /** Maximum rows in one response window; the source has no total row cap. */
    rowLimit: zod_1.z.number().int().positive().max(5000).default(500),
})
    .strict();
exports.AppBaseDatabaseBindingPlacementSchema = zod_1.z
    .object({
    docId: zod_1.z.string().min(1),
    blockId: zod_1.z.string().min(1),
})
    .strict();
/** Binding of one data requirement: see APP_BASE_PLATFORM_AUTHORING_GUIDE.terminology. */
exports.AppBaseDatabaseBindingSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_DATABASE_BINDING_SCHEMA_VERSION),
    sourceKey: zod_1.z.string().min(1),
    semanticKey: zod_1.z.string().min(1),
    role: zod_1.z.string().min(1),
    contentModel: zod_1.z.string().min(1),
    schemaFingerprint: zod_1.z.string().min(1),
    // Absent on legacy bindings: resolve via
    // resolveAppBaseDatabaseBindingSchemaAuthority.
    schemaAuthority: zod_1.z.enum(['standard', 'declared']).optional(),
    databaseId: zod_1.z.string().min(1),
    ownership: exports.AppBaseDatabaseBindingOwnershipSchema,
    status: exports.AppBaseDatabaseBindingStatusSchema.default('active'),
    label: zod_1.z.string().min(1),
    detachPolicy: exports.AppBaseDatabaseBindingDetachPolicySchema.default('preserve-source'),
    createdAt: zod_1.z.string().min(1),
    updatedAt: zod_1.z.string().min(1),
    revision: zod_1.z.number().int().nonnegative().default(1),
    placement: exports.AppBaseDatabaseBindingPlacementSchema,
    originalPlacement: exports.AppBaseDatabaseBindingPlacementSchema,
    // App column id -> bound database column id; absent keys resolve to
    // themselves. Translate only via app-base-column-map.
    columnMap: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.string().min(1)).optional(),
    exposure: exports.AppBaseDatabaseBindingExposureSchema,
})
    .strict();
exports.AppBaseDatabaseBindingRegistrySchema = zod_1.z.record(zod_1.z.string().min(1), exports.AppBaseDatabaseBindingSchema);
/** The Apps of a container outside the trash: the only ones with pages. */
function liveAppDefinitions(definitions) {
    return Object.values(definitions).filter(definition => !definition.trash);
}
/** The Apps of a container in the trash. */
function trashedAppDefinitions(definitions) {
    return Object.values(definitions).filter((definition) => definition.trash !== undefined);
}
/**
 * Headroom of one JSON-encoded replica chunk over the stored row shard limit
 * (field names, quoting, escaping). Set, not measured; revisit with real data.
 */
exports.APP_BASE_REPLICA_JSON_EXPANSION_FACTOR = 4;
/**
 * Agent Actions an App Container may hold for each table its plan grants
 * (plan field `appBaseTableLimit`); the plan names no second number.
 */
exports.APP_CONTAINER_AGENT_ACTIONS_PER_TABLE = 2;
function appContainerAgentActionLimit(tableLimit) {
    return tableLimit * exports.APP_CONTAINER_AGENT_ACTIONS_PER_TABLE;
}
const APP_BASE_MAX_DATA_SOURCES = 256;
/**
 * The rows one relation cell links at most. The relation writer of the
 * platform refuses a write past it, and so does the StreamKit, with this code
 * and sentence.
 */
exports.APP_BASE_RELATION_LINK_LIMIT = 100;
exports.APP_BASE_RELATION_LINK_LIMIT_EXCEEDED = 'APP_BASE_RELATION_LINK_LIMIT_EXCEEDED';
exports.APP_BASE_RELATION_LINK_LIMIT_TEXT = `Relation cells are limited to ${exports.APP_BASE_RELATION_LINK_LIMIT} linked rows.`;
/**
 * An App write links only rows the person can read through the page. A
 * missing and an unreadable row answer alike, so nobody learns about rows of
 * others.
 */
exports.APP_BASE_MUTATION_LINKED_ROW_NOT_FOUND = 'APP_BASE_MUTATION_LINKED_ROW_NOT_FOUND';
exports.APP_BASE_MUTATION_LINKED_ROW_NOT_FOUND_TEXT = 'The linked row does not exist or cannot be read.';
/** A row that links back to only one row is linked elsewhere already. */
exports.APP_BASE_MUTATION_RELATION_TAKEN = 'APP_BASE_MUTATION_RELATION_TAKEN';
exports.APP_BASE_MUTATION_RELATION_TAKEN_TEXT = 'The linked row is already linked elsewhere.';
/** A relation value of an App write that is no list of row ids or null. */
exports.APP_BASE_MUTATION_ROW_PAYLOAD_INVALID = 'APP_BASE_MUTATION_ROW_PAYLOAD_INVALID';
exports.APP_BASE_MUTATION_ROW_PAYLOAD_INVALID_TEXT = 'A value of the new row does not fit its column.';
/**
 * The row ids an App write puts into a relation cell, each once: null clears
 * the cell. Anything but a list of non-empty ids is invalid (null result).
 */
function appBaseLinkedRowIds(value) {
    if (value === null)
        return [];
    if (!Array.isArray(value) ||
        !value.every(id => typeof id === 'string' && id.length > 0))
        return null;
    return [...new Set(value)];
}
exports.APP_BASE_BUDGETS = {
    /** Bounds manifest parsing while leaving room for large user-owned command sets. */
    maxManifestBytes: 512 * 1024,
    /**
     * The one file count of an App Container, the same for saving, publishing,
     * installing, import and packages (card dec-streamkit-module-file-limits-1020
     * = A): the cost per file is one stored object, one hash and one list entry.
     */
    maxFiles: 1024,
    /**
     * Bounds one text file (HTML, CSS, JavaScript, JSON): editor, AI tools and
     * preview load it whole.
     */
    maxFileBytes: 4 * 1024 * 1024,
    /**
     * Bounds one binary file (image, font): it travels as a stream into its
     * blob, never whole in memory (card dec-app-files-max-file-bytes-1102 = B).
     */
    maxBinaryFileBytes: 32 * 1024 * 1024,
    /**
     * Publish limit of an App Container: its files are stored blobs and travel
     * as streams in packages, so only one file lies in memory at a time.
     */
    maxTotalBytes: 128 * 1024 * 1024,
    /** Save ceiling: the publish limit; a save stores every binary file as its blob. */
    maxStoredTotalBytes: 128 * 1024 * 1024,
    /** Bounds one query response before transport framing and revision metadata. */
    maxDatasetChunkBytes: 256 * 1024,
    /** Bounds navigation validation and rendered navigation/control expansion. */
    maxNavigationItems: 128,
    /** Bounds per-action payload validation and generated interaction controls. */
    maxActionFields: 64,
    /** Bounds one command body before schema validation and execution admission. */
    maxActionPayloadBytes: 64 * 1024,
    /**
     * The tables of one App Container. Install and delete touch them together;
     * what one page reads stays bounded by `maxPageTables`.
     */
    maxDataSources: APP_BASE_MAX_DATA_SOURCES,
    /**
     * Agent Action schemas of one App Container, injected into authoring and
     * runtime registries: as many as its largest table count allows. One App
     * may hold all of them; splitting into Apps stays optional (user 20.10.2026).
     */
    maxAgentActions: appContainerAgentActionLimit(APP_BASE_MAX_DATA_SOURCES),
    ...app_base_bridge_budgets_1.APP_BASE_READ_BUDGETS,
    /** Bounds one encoded row shard so replica reads stay byte-bounded in memory. */
    maxReplicaChunkBytes: database_identity_1.DATABASE_ROW_SHARD_HARD_LIMIT_BYTES *
        exports.APP_BASE_REPLICA_JSON_EXPANSION_FACTOR,
};
/**
 * How many reads of App data one workspace and one instance admit at once, on
 * the platform (AppBaseTenantReadQueue) and in the StreamKit alike. Initial
 * settings, not load-test measurements: 4 parallel reads keep one workspace
 * from occupying the database pool, 64 waiters cover a full replica load of
 * several viewers, 10 s stays below proxy timeouts; an instance admits at
 * most 8 active and 128 waiting reads.
 */
exports.APP_BASE_READ_ADMISSION_LIMITS = {
    concurrency: 4,
    maxWaiting: 64,
    waitTimeoutMs: 10_000,
    readTimeoutMs: 5_000,
    totalConcurrency: () => 8,
    totalMaxWaiting: 128,
};
function sumArtifactBytes(files) {
    return Object.values(files).reduce((sum, file) => sum + file.bytes, 0);
}
function formatAppBaseBytes(bytes) {
    const mib = bytes / (1024 * 1024);
    if (mib >= 1)
        return `${Number(mib.toFixed(1))} MiB`;
    return `${Math.ceil(bytes / 1024)} KiB`;
}
function appArtifactUsage(input) {
    const budget = exports.APP_BASE_BUDGETS;
    const files = input.artifact?.files ?? {};
    return {
        files: {
            used: Object.keys(files).length,
            limit: budget.maxFiles,
        },
        bytes: {
            used: sumArtifactBytes(files),
            limit: budget.maxTotalBytes,
            ceiling: budget.maxStoredTotalBytes,
        },
        dataSources: {
            used: input.artifact?.manifest.dataSourceKeys.length ?? 0,
            limit: budget.maxDataSources,
        },
        apps: Object.values(input.appDefinitions ?? {}).map(definition => ({
            appId: definition.appId,
            title: definition.title,
            files: {
                used: Object.keys(definition.files).length,
                limit: budget.maxFiles,
            },
            bytes: {
                used: sumArtifactBytes(definition.files),
                limit: budget.maxTotalBytes,
            },
        })),
    };
}
/** One line for agents and the StreamKit: used / limit per budget, then per App. */
function formatAppArtifactUsage(usage) {
    const appBase = [
        `${formatAppBaseBytes(usage.bytes.used)} / ${formatAppBaseBytes(usage.bytes.limit)}`,
        `${usage.files.used}/${usage.files.limit} files`,
        `${usage.dataSources.used}/${usage.dataSources.limit} data sources`,
    ].join(', ');
    const apps = usage.apps.map(app => `App Module ${app.title}: ${formatAppBaseBytes(app.bytes.used)} / ${formatAppBaseBytes(app.bytes.limit)}, ${app.files.used}/${app.files.limit} files`);
    return [appBase, ...apps].join('; ');
}
/**
 * A page reads the tables of its route and of the frame together; above
 * `maxPageTables` the issue names the page and its listed limit.
 */
function appPageTablesIssue(path, routeKeys, frameKeys = []) {
    const tables = new Set([...routeKeys, ...frameKeys]).size;
    return tables > exports.APP_BASE_BUDGETS.maxPageTables
        ? `App Module page ${path} reads ${tables} tables (max ${exports.APP_BASE_BUDGETS.maxPageTables}) (limit page.tables)`
        : null;
}
/** Publish limits only; saving is allowed up to the storage ceiling. */
function appArtifactWithinPublishLimits(usage) {
    return (usage.bytes.used <= usage.bytes.limit &&
        usage.files.used <= usage.files.limit);
}
/**
 * An App has no limit of its own: it may hold everything its App Container
 * may hold (user 20.10.2026).
 */
function appBudgetViolations(definition) {
    const budget = exports.APP_BASE_BUDGETS;
    const files = Object.values(definition.files);
    const totalBytes = files.reduce((sum, file) => sum + file.bytes, 0);
    // Each count with the listed limit it is measured against (app-limits.ts).
    const checks = [
        [
            definition.resources.length,
            budget.maxDataSources,
            'resources',
            'appContainer.tables',
        ],
        [
            definition.agentActions.length,
            budget.maxAgentActions,
            'Agent Actions',
            'appContainer.agentActions',
        ],
        [files.length, budget.maxFiles, 'files', 'appContainer.files'],
        [totalBytes, budget.maxTotalBytes, 'bytes', 'appContainer.publishBytes'],
    ];
    return checks
        .filter(([actual, limit]) => actual > limit)
        .map(([actual, limit, label, id]) => `${actual} ${label} (max ${limit}) (limit ${id})`);
}
/** Runtime hints every App Container carries; an App adds only its own. */
const APP_BASE_GENERATED_RUNTIME_HINTS = [
    'Use manifest-declared controls and platform actions; never infer privileged operations from hidden DOM state.',
    'Generated route, dataset, action, status, and field control IDs are rebuilt from the manifest; custom controls must use separate custom IDs.',
    'Generated export controls expose document export selectors/formats and optional attachment saveback actions through StreamLainAppBase.exportElement/downloadExport/saveExport.',
    'Database attachment cells must be rendered through StreamLainAppBase.resolveAttachmentUrl(cellOrFile, { sourceKey, rowId, columnId }); raw blob URLs are not part of the App contract.',
    'Whether a stored attachment still holds the same bytes is checked through StreamLainAppBase.attachmentDigest(cellOrFile, { sourceKey, rowId, columnId }), which answers { sha256 (lowercase hex), byteLength } under the same rights; Apps read no attachment bytes.',
    'The original file of an attachment cell is downloaded through StreamLainAppBase.downloadAttachment(cellOrFile, { sourceKey, rowId, columnId }) after its column is declared in app.json attachmentDownloads; it resolves to { success, filename, bytes } or rejects with a localized message.',
    'A file the visitor chose goes to a declared attachment update action through StreamLainAppBase.uploadAttachment({ actionId, rowId, file }); the server checks size, type, quota and rights and answers with the result or an error.',
    'Generated capability declarations are the review and runtime source of truth for dataset reads, subscriptions, platform actions, App Agent Actions, automation runs, attachment updates, and document exports.',
    'Display route, data-source, action, automation, and attachment permission denials as disabled controls or user-safe status messages.',
];
function buildAppBaseInteractionContract(manifest) {
    const generatedControls = [
        ...manifest.routes.map(route => exports.AppBaseInteractionControlSchema.parse({
            id: `route:${route.path}`,
            label: route.title,
            kind: 'route',
            intent: 'navigate',
            routePath: route.path,
            requiredRole: 'reader',
        })),
        ...manifest.dataSourceKeys.map(sourceKey => exports.AppBaseInteractionControlSchema.parse({
            id: `dataset:${sourceKey}`,
            label: sourceKey,
            kind: 'dataset',
            intent: 'readDataset',
            sourceKey,
            requiredRole: 'reader',
        })),
        ...manifest.actions.flatMap(action => {
            const actionControl = exports.AppBaseInteractionControlSchema.parse({
                id: `action:${action.id}`,
                label: action.label,
                kind: 'action',
                intent: appActionIntent(action),
                actionId: action.id,
                sourceKey: appActionSourceKey(action),
                requiredRole: 'writer',
                confirmationPolicy: action.type === 'automationRun' ||
                    action.type === 'attachmentUpdate' ||
                    (action.type === 'ownRowChange' && action.operation === 'delete') ||
                    action.consentRequired
                    ? 'required'
                    : 'recommended',
            });
            const statusControl = action.type === 'automationRun'
                ? [
                    exports.AppBaseInteractionControlSchema.parse({
                        id: `status:${action.id}`,
                        label: `${action.label} status`,
                        kind: 'status',
                        intent: 'readStatus',
                        actionId: action.id,
                        requiredRole: 'reader',
                    }),
                ]
                : [];
            const fieldControls = action.type === 'rowInsert' ||
                action.type === 'automationRun' ||
                action.type === 'ownRowChange'
                ? (action.fields ?? []).map(field => exports.AppBaseInteractionControlSchema.parse({
                    id: `action:${action.id}:field:${field.columnId}`,
                    label: field.label,
                    kind: 'field',
                    intent: 'editField',
                    actionId: action.id,
                    sourceKey: action.type === 'automationRun'
                        ? action.inputSourceKey
                        : action.sourceKey,
                    fieldColumnId: field.columnId,
                    fieldType: field.type,
                    fieldRequired: field.required,
                    fieldOptions: field.options,
                    requiredRole: 'writer',
                }))
                : [];
            return [actionControl, ...statusControl, ...fieldControls];
        }),
        ...manifest.documentExports.map(documentExport => exports.AppBaseInteractionControlSchema.parse({
            id: `export:${documentExport.id}`,
            label: documentExport.label,
            kind: 'export',
            intent: 'exportDocument',
            routePath: documentExport.routePath,
            actionId: documentExport.targetActionId,
            exportId: documentExport.id,
            selector: documentExport.selector,
            formats: documentExport.formats,
            filenameTemplate: documentExport.filenameTemplate,
            requiredRole: documentExport.targetActionId ? 'writer' : 'reader',
            confirmationPolicy: documentExport.targetActionId
                ? 'recommended'
                : 'none',
        })),
    ];
    const controls = new Map();
    const generatedControlIds = new Set(generatedControls.map(control => control.id));
    for (const control of generatedControls)
        controls.set(control.id, control);
    for (const control of manifest.interaction?.controls ?? []) {
        if (generatedControlIds.has(control.id)) {
            continue;
        }
        if (isGeneratedAppBaseInteractionControlId(control.id)) {
            continue;
        }
        controls.set(control.id, exports.AppBaseInteractionControlSchema.parse(control));
    }
    return exports.AppBaseInteractionContractSchema.parse({
        schemaVersion: exports.APP_BASE_INTERACTION_CONTRACT_SCHEMA_VERSION,
        protocol: 'streamlain-app-base-bridge/v1',
        controls: [...controls.values()],
        // The built-in hints lead; a manifest that already carries them (a
        // rebuilt contract) keeps them once.
        runtimeHints: [
            ...APP_BASE_GENERATED_RUNTIME_HINTS,
            ...(manifest.interaction?.runtimeHints ?? []).filter(hint => !APP_BASE_GENERATED_RUNTIME_HINTS.includes(hint)),
        ],
    });
}
/**
 * A capability id of the declarations buildAppBaseCapabilityDeclarations
 * writes from the sources, actions and exports of a manifest; a rebuild
 * writes these anew and keeps every other declaration of the author.
 */
function isGeneratedAppBaseCapabilityId(id) {
    return (id.startsWith('dataset:') ||
        id.startsWith('action:') ||
        id.startsWith('export:'));
}
function buildAppBaseCapabilityDeclarations(manifest) {
    const routePathsForSource = (sourceKey) => manifest.routes
        .filter(route => route.dataSourceKeys.includes(sourceKey))
        .map(route => route.path);
    const actionDataSourceKeys = manifest.actions.flatMap(appActionSourceKeys);
    const declaredDataSourceKeys = [
        ...new Set([
            ...manifest.dataSourceKeys,
            ...manifest.routes.flatMap(route => route.dataSourceKeys),
            ...actionDataSourceKeys,
        ]),
    ];
    const generated = [
        ...declaredDataSourceKeys.flatMap(sourceKey => {
            const routePaths = routePathsForSource(sourceKey);
            const readCapability = exports.AppBaseCapabilitySchema.parse({
                id: `dataset:${sourceKey}:readWindow`,
                capabilityId: 'dataset.readWindow',
                label: `Read ${sourceKey}`,
                permission: 'read',
                routePaths,
                dataSourceKeys: [sourceKey],
            });
            const subscribeCapability = resolveAppDeliveriesForSource(manifest, sourceKey).some(({ delivery }) => appDeliveryHasLiveData(delivery))
                ? [
                    exports.AppBaseCapabilitySchema.parse({
                        id: `dataset:${sourceKey}:subscribe`,
                        capabilityId: 'dataset.subscribe',
                        label: `Subscribe to ${sourceKey}`,
                        permission: 'read',
                        routePaths,
                        dataSourceKeys: [sourceKey],
                    }),
                ]
                : [];
            const restoreCapability = exports.AppBaseCapabilitySchema.parse({
                id: `dataset:${sourceKey}:restore`,
                capabilityId: 'dataset.restore',
                label: `Ask to restore ${sourceKey}`,
                permission: 'write',
                routePaths,
                dataSourceKeys: [sourceKey],
            });
            return [readCapability, ...subscribeCapability, restoreCapability];
        }),
        ...manifest.actions.map(action => {
            const capabilityId = appBaseCapabilityForAction(action);
            return exports.AppBaseCapabilitySchema.parse({
                id: `action:${action.id}:${capabilityId}`,
                capabilityId,
                label: action.label,
                permission: 'execute',
                dataSourceKeys: appActionSourceKeys(action),
                actionIds: [action.id],
            });
        }),
        ...manifest.documentExports.map(documentExport => exports.AppBaseCapabilitySchema.parse({
            id: `export:${documentExport.id}:document.export`,
            capabilityId: 'document.export',
            label: documentExport.label,
            permission: documentExport.targetActionId ? 'write' : 'read',
            routePaths: [documentExport.routePath],
            actionIds: documentExport.targetActionId
                ? [documentExport.targetActionId]
                : [],
        })),
    ];
    const merged = new Map();
    for (const capability of generated)
        merged.set(capability.id, capability);
    for (const capability of manifest.capabilities ?? []) {
        merged.set(capability.id, exports.AppBaseCapabilitySchema.parse(capability));
    }
    return [...merged.values()];
}
function isGeneratedAppBaseInteractionControlId(id) {
    return (id.startsWith('route:') ||
        id.startsWith('dataset:') ||
        id.startsWith('action:') ||
        id.startsWith('status:') ||
        id.startsWith('export:'));
}
/**
 * Controls a route names that no App declares. The platform builds every
 * control of an App from its routes, tables, commands, statuses, exports and
 * navigation, including its executable navigation actions. Installation
 * refuses ownership references that none of these contracts declares.
 */
function appRouteControlIssues(definition) {
    return definition.routes.flatMap(route => route.interactionControlIds
        .filter(id => !isGeneratedAppBaseInteractionControlId(id) &&
        !id.startsWith('nav:') &&
        !definition.navigationActions?.some(action => action.id === id))
        .map(id => `route ${route.route.path} names the control ${id}, which no App Module declares; a route names only route:, dataset:, action:, status:, export: or nav: controls`));
}
function appActionIntent(action) {
    switch (action.type) {
        case 'rowInsert':
        case 'rowGroupInsert':
            return 'rowInsert';
        case 'automationRun':
            return 'automationRun';
        case 'attachmentUpdate':
            return 'saveAttachment';
        case 'ownRowChange':
            return action.operation === 'delete' ? 'rowDelete' : 'rowUpdate';
    }
}
function withAppBaseInteractionContract(manifest) {
    const parsed = exports.AppManifestSchema.parse(manifest);
    const capabilities = buildAppBaseCapabilityDeclarations(parsed);
    return exports.AppManifestSchema.parse({
        ...parsed,
        capabilities,
        interaction: buildAppBaseInteractionContract(parsed),
    });
}
/**
 * Effective schema contract of a binding. `declared` means the binding's
 * exposure.columnIds allowlist is the schema contract; `standard` means the
 * role's standard columns apply. Attached existing databases keep their
 * owner's schema, so legacy bindings without an explicit authority resolve to
 * `declared` for that ownership.
 */
function resolveAppBaseDatabaseBindingSchemaAuthority(binding) {
    return (binding.schemaAuthority ??
        (binding.ownership === 'attached-existing' ? 'declared' : 'standard'));
}
function createAppBaseDatabaseBinding(input) {
    const now = input.now ?? new Date().toISOString();
    const semanticKey = createAppBaseDatabaseSemanticKey(input);
    const schemaFingerprint = input.schemaFingerprint ??
        createAppBaseDatabaseSchemaFingerprint({
            role: input.role,
            contentModel: input.contentModel,
            columnIds: input.columnIds ?? [],
        });
    return exports.AppBaseDatabaseBindingSchema.parse({
        schemaVersion: exports.APP_BASE_DATABASE_BINDING_SCHEMA_VERSION,
        sourceKey: input.sourceKey,
        semanticKey,
        role: input.role,
        contentModel: input.contentModel,
        schemaFingerprint,
        schemaAuthority: input.schemaAuthority,
        databaseId: input.databaseId,
        ownership: input.ownership,
        status: 'active',
        label: input.label,
        detachPolicy: 'preserve-source',
        createdAt: now,
        updatedAt: now,
        revision: 1,
        placement: { docId: input.docId, blockId: input.blockId },
        originalPlacement: { docId: input.docId, blockId: input.blockId },
        ...(input.columnMap && Object.keys(input.columnMap).length > 0
            ? { columnMap: input.columnMap }
            : {}),
        exposure: {
            materialized: true,
            columnIds: input.columnIds ?? [],
            rowLimit: input.rowLimit ?? exports.APP_BASE_BUDGETS.defaultDatasetRows,
        },
    });
}
function createAppBaseDatabaseSemanticKey(input) {
    const semanticKey = input.semanticKey?.trim() || input.sourceKey.trim();
    if (!semanticKey) {
        throw new Error('App database semanticKey requires a sourceKey');
    }
    return semanticKey;
}
const APP_BASE_DB_SCHEMA_PREFIX = 'app-base-db-schema:2:';
const APP_BASE_DB_SCHEMA_DIGEST_LENGTH = 32;
const APP_BASE_DB_SCHEMA_NO_COLUMNS = 'none';
/**
 * Checksum of a database's schema, not its column text. Three digests:
 * kind (role + content model), columns (name, type and data without ids or
 * physical references, so a copy in another workspace matches) and exact
 * (everything incl. ids, so any change of the database changes it).
 */
function createAppBaseDatabaseSchemaFingerprint(input) {
    const columns = input.columns
        ? input.columns.map(column => ({
            id: column.id,
            name: column.name ?? null,
            type: column.type ?? null,
            data: stableJsonValue(column.data ?? null),
        }))
        : (input.columnIds ?? []).map(id => ({
            id,
            name: null,
            type: null,
            data: null,
        }));
    const kind = schemaDigest({
        role: input.role,
        contentModel: input.contentModel,
    });
    const comparable = columns
        .map(column => stableJsonStringify({
        name: column.name,
        type: column.type,
        data: stripPhysicalSchemaData(column.data),
    }))
        .sort();
    const exact = schemaDigest({
        role: input.role,
        contentModel: input.contentModel,
        columns: columns.sort((a, b) => a.id.localeCompare(b.id)),
    });
    return `${APP_BASE_DB_SCHEMA_PREFIX}${kind}:${comparable.length === 0
        ? APP_BASE_DB_SCHEMA_NO_COLUMNS
        : schemaDigest(comparable)}:${exact}`;
}
/**
 * Whether two databases can stand for each other: same kind and the same
 * columns by name, type and data. A side without columns accepts any.
 */
function isAppBaseDatabaseSchemaCompatible(a, b) {
    if (a === b)
        return true;
    const aSchema = parseAppBaseDatabaseSchemaFingerprint(a);
    const bSchema = parseAppBaseDatabaseSchemaFingerprint(b);
    if (!aSchema || !bSchema || aSchema.kind !== bSchema.kind)
        return false;
    return (aSchema.columns === APP_BASE_DB_SCHEMA_NO_COLUMNS ||
        bSchema.columns === APP_BASE_DB_SCHEMA_NO_COLUMNS ||
        aSchema.columns === bSchema.columns);
}
function parseAppBaseDatabaseSchemaFingerprint(value) {
    if (!value.startsWith(APP_BASE_DB_SCHEMA_PREFIX))
        return null;
    const [kind, columns, exact, ...rest] = value
        .slice(APP_BASE_DB_SCHEMA_PREFIX.length)
        .split(':');
    if (!kind || !columns || !exact || rest.length > 0)
        return null;
    return { kind, columns };
}
function schemaDigest(value) {
    return appBaseSha256Hex(stableJsonStringify(value)).slice(0, APP_BASE_DB_SCHEMA_DIGEST_LENGTH);
}
/** Ids of other databases and inverse fields differ per workspace copy. */
function stripPhysicalSchemaData(value) {
    if (Array.isArray(value))
        return value.map(stripPhysicalSchemaData);
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value)
            .filter(([key]) => key !== 'targetDatabaseId' && key !== 'inverseFieldId')
            .map(([key, nested]) => [key, stripPhysicalSchemaData(nested)]));
    }
    return value;
}
function stableJsonValue(value) {
    if (Array.isArray(value))
        return value.map(stableJsonValue);
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value)
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([key, nested]) => [key, stableJsonValue(nested)]));
    }
    return value;
}
function stableJsonStringify(value) {
    return JSON.stringify(stableJsonValue(value));
}
function bumpAppBaseDatabaseBindingRevision(binding, patch) {
    const { now, ...bindingPatch } = patch;
    return exports.AppBaseDatabaseBindingSchema.parse({
        ...binding,
        ...bindingPatch,
        updatedAt: now ?? new Date().toISOString(),
        revision: binding.revision + 1,
    });
}
var app_base_bridge_budgets_2 = require("./app-base-bridge-budgets");
Object.defineProperty(exports, "APP_BASE_BRIDGE_BUDGETS", { enumerable: true, get: function () { return app_base_bridge_budgets_2.APP_BASE_BRIDGE_BUDGETS; } });
Object.defineProperty(exports, "APP_BASE_READ_BUDGETS", { enumerable: true, get: function () { return app_base_bridge_budgets_2.APP_BASE_READ_BUDGETS; } });
Object.defineProperty(exports, "appBaseDataBusyBody", { enumerable: true, get: function () { return app_base_bridge_budgets_2.appBaseDataBusyBody; } });
